"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApi = void 0;
const getApi = (client) => {
    const getApiV1AddressBookContactUserId = (userId, params) => {
        return client.request({ url: `api/v1/address-book/contact/${userId}`, method: 'GET',
            params
        });
    };
    const putApiV1AddressBookContactUserId = (userId, userAddressBookUpdateRequest, params) => {
        return client.request({ url: `api/v1/address-book/contact/${userId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: userAddressBookUpdateRequest,
            params
        });
    };
    const deleteApiV1AddressBookContactUserId = (userId, params) => {
        return client.request({ url: `api/v1/address-book/contact/${userId}`, method: 'DELETE',
            params
        });
    };
    const postApiV1AddressBookContact = (userAddressBookRequest, params) => {
        return client.request({ url: `api/v1/address-book/contact`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: userAddressBookRequest,
            params
        });
    };
    const getApiV1AddressBookList = () => {
        return client.request({ url: `api/v1/address-book/list`, method: 'GET'
        });
    };
    const getApiV1AddressBookMy = (params) => {
        return client.request({ url: `api/v1/address-book/my`, method: 'GET',
            params
        });
    };
    const getApiV1AddressBookUserRights = (params) => {
        return client.request({ url: `api/v1/address-book/user-rights`, method: 'GET',
            params
        });
    };
    const postApiV1AddressBookAddressBookIdAddRights = (addressBookId, postApiV1AddressBookAddressBookIdAddRightsBody) => {
        return client.request({ url: `api/v1/address-book/${addressBookId}/add-rights`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: postApiV1AddressBookAddressBookIdAddRightsBody
        });
    };
    const getApiV1AddressBookAddressBookIdContact = (addressBookId, params) => {
        return client.request({ url: `api/v1/address-book/${addressBookId}/contact`, method: 'GET',
            params
        });
    };
    const getApiV1AddressBookAddressBookIdExport = (addressBookId) => {
        return client.request({ url: `api/v1/address-book/${addressBookId}/export`, method: 'GET'
        });
    };
    const getApiV1AddressBookAddressBookId = (addressBookId) => {
        return client.request({ url: `api/v1/address-book/${addressBookId}`, method: 'GET'
        });
    };
    const putApiV1AddressBookAddressBookId = (addressBookId, addressBookUpdateRequest) => {
        return client.request({ url: `api/v1/address-book/${addressBookId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: addressBookUpdateRequest
        });
    };
    const deleteApiV1AddressBookAddressBookId = (addressBookId) => {
        return client.request({ url: `api/v1/address-book/${addressBookId}`, method: 'DELETE'
        });
    };
    const getApiV1AddressBook = (params) => {
        return client.request({ url: `api/v1/address-book`, method: 'GET',
            params
        });
    };
    const postApiV1AddressBook = (addressBookRequest) => {
        return client.request({ url: `api/v1/address-book`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: addressBookRequest
        });
    };
    const postApiV1ApiConfirmPassword = (passwordRequest) => {
        return client.request({ url: `api/v1/api/confirm-password`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: passwordRequest
        });
    };
    const postApiV1ApiCreate = (apiUserRequest) => {
        return client.request({ url: `api/v1/api/create`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: apiUserRequest
        });
    };
    const deleteApiV1ApiDeleteId = (id) => {
        return client.request({ url: `api/v1/api/delete/${id}`, method: 'DELETE'
        });
    };
    const getApiV1ApiGeneratePassword = () => {
        return client.request({ url: `api/v1/api/generate-password`, method: 'GET'
        });
    };
    const getApiV1ApiId = (id) => {
        return client.request({ url: `api/v1/api/${id}`, method: 'GET'
        });
    };
    const getApiV1Api = (params) => {
        return client.request({ url: `api/v1/api`, method: 'GET',
            params
        });
    };
    const getApiV1ArticleGalleryGallery = (gallery) => {
        return client.request({ url: `api/v1/article/gallery/${gallery}`, method: 'GET'
        });
    };
    const getApiV1ArticleImageId = (id) => {
        return client.request({ url: `api/v1/article/image/${id}`, method: 'GET'
        });
    };
    const getApiV1ArticleSectionId = (id) => {
        return client.request({ url: `api/v1/article/section/${id}`, method: 'GET'
        });
    };
    const putApiV1ArticleSectionId = (id, articleSectionUpdateRequest) => {
        return client.request({ url: `api/v1/article/section/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: articleSectionUpdateRequest
        });
    };
    const deleteApiV1ArticleSectionId = (id) => {
        return client.request({ url: `api/v1/article/section/${id}`, method: 'DELETE'
        });
    };
    const getApiV1ArticleSection = (params) => {
        return client.request({ url: `api/v1/article/section`, method: 'GET',
            params
        });
    };
    const postApiV1ArticleSection = (articleSectionRequest) => {
        return client.request({ url: `api/v1/article/section`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: articleSectionRequest
        });
    };
    const getApiV1ArticleId = (id) => {
        return client.request({ url: `api/v1/article/${id}`, method: 'GET'
        });
    };
    const putApiV1ArticleId = (id, articleUpdateRequest) => {
        const formData = new FormData();
        if (articleUpdateRequest.articleSectionId !== undefined && articleUpdateRequest.articleSectionId !== null) {
            formData.append('articleSectionId', articleUpdateRequest.articleSectionId.toString());
        }
        if (articleUpdateRequest.name !== undefined && articleUpdateRequest.name !== null) {
            formData.append('name', articleUpdateRequest.name);
        }
        if (articleUpdateRequest.leadParagraph !== undefined && articleUpdateRequest.leadParagraph !== null) {
            formData.append('leadParagraph', articleUpdateRequest.leadParagraph);
        }
        if (articleUpdateRequest.content !== undefined && articleUpdateRequest.content !== null) {
            formData.append('content', articleUpdateRequest.content);
        }
        if (articleUpdateRequest.created !== undefined && articleUpdateRequest.created !== null) {
            formData.append('created', articleUpdateRequest.created);
        }
        if (articleUpdateRequest.showFrom !== undefined && articleUpdateRequest.showFrom !== null) {
            formData.append('showFrom', articleUpdateRequest.showFrom);
        }
        if (articleUpdateRequest.showTo !== undefined && articleUpdateRequest.showTo !== null) {
            formData.append('showTo', articleUpdateRequest.showTo);
        }
        if (articleUpdateRequest.authorId !== undefined && articleUpdateRequest.authorId !== null) {
            formData.append('authorId', articleUpdateRequest.authorId.toString());
        }
        if (articleUpdateRequest.modified !== undefined && articleUpdateRequest.modified !== null) {
            formData.append('modified', articleUpdateRequest.modified);
        }
        if (articleUpdateRequest.modifiedById !== undefined && articleUpdateRequest.modifiedById !== null) {
            formData.append('modifiedById', articleUpdateRequest.modifiedById.toString());
        }
        if (articleUpdateRequest.publishedById !== undefined && articleUpdateRequest.publishedById !== null) {
            formData.append('publishedById', articleUpdateRequest.publishedById.toString());
        }
        if (articleUpdateRequest.picture !== undefined && articleUpdateRequest.picture !== null) {
            formData.append('picture', articleUpdateRequest.picture);
        }
        if (articleUpdateRequest.mainPage !== undefined && articleUpdateRequest.mainPage !== null) {
            formData.append('mainPage', articleUpdateRequest.mainPage.toString());
        }
        if (articleUpdateRequest.mainPageDate !== undefined && articleUpdateRequest.mainPageDate !== null) {
            formData.append('mainPageDate', articleUpdateRequest.mainPageDate);
        }
        if (articleUpdateRequest.top !== undefined && articleUpdateRequest.top !== null) {
            formData.append('top', articleUpdateRequest.top.toString());
        }
        if (articleUpdateRequest.lock !== undefined && articleUpdateRequest.lock !== null) {
            formData.append('lock', articleUpdateRequest.lock.toString());
        }
        if (articleUpdateRequest.showLeadParagraph !== undefined && articleUpdateRequest.showLeadParagraph !== null) {
            formData.append('showLeadParagraph', articleUpdateRequest.showLeadParagraph.toString());
        }
        if (articleUpdateRequest.showDate !== undefined && articleUpdateRequest.showDate !== null) {
            formData.append('showDate', articleUpdateRequest.showDate.toString());
        }
        if (articleUpdateRequest.gallery !== undefined && articleUpdateRequest.gallery !== null) {
            formData.append('gallery', articleUpdateRequest.gallery);
        }
        if (articleUpdateRequest.additionalFiles !== undefined && articleUpdateRequest.additionalFiles !== null) {
            formData.append('additionalFiles', articleUpdateRequest.additionalFiles);
        }
        if (articleUpdateRequest.counter !== undefined && articleUpdateRequest.counter !== null) {
            formData.append('counter', articleUpdateRequest.counter.toString());
        }
        if (articleUpdateRequest.archive !== undefined && articleUpdateRequest.archive !== null) {
            formData.append('archive', articleUpdateRequest.archive.toString());
        }
        if (articleUpdateRequest.url !== undefined && articleUpdateRequest.url !== null) {
            formData.append('url', articleUpdateRequest.url);
        }
        return client.request({ url: `api/v1/article/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1ArticleId = (id) => {
        return client.request({ url: `api/v1/article/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Article = (params) => {
        return client.request({ url: `api/v1/article`, method: 'GET',
            params
        });
    };
    const postApiV1Article = (articleRequest) => {
        const formData = new FormData();
        formData.append('articleSectionId', articleRequest.articleSectionId);
        formData.append('name', articleRequest.name);
        formData.append('leadParagraph', articleRequest.leadParagraph);
        formData.append('content', articleRequest.content);
        formData.append('created', articleRequest.created);
        if (articleRequest.showFrom !== undefined && articleRequest.showFrom !== null) {
            formData.append('showFrom', articleRequest.showFrom);
        }
        if (articleRequest.showTo !== undefined && articleRequest.showTo !== null) {
            formData.append('showTo', articleRequest.showTo);
        }
        if (articleRequest.authorId !== undefined && articleRequest.authorId !== null) {
            formData.append('authorId', articleRequest.authorId.toString());
        }
        if (articleRequest.modified !== undefined && articleRequest.modified !== null) {
            formData.append('modified', articleRequest.modified);
        }
        if (articleRequest.modifiedById !== undefined && articleRequest.modifiedById !== null) {
            formData.append('modifiedById', articleRequest.modifiedById.toString());
        }
        formData.append('publishedById', articleRequest.publishedById.toString());
        formData.append('picture', articleRequest.picture);
        formData.append('mainPage', articleRequest.mainPage.toString());
        if (articleRequest.mainPageDate !== undefined && articleRequest.mainPageDate !== null) {
            formData.append('mainPageDate', articleRequest.mainPageDate);
        }
        formData.append('top', articleRequest.top.toString());
        formData.append('lock', articleRequest.lock.toString());
        formData.append('showLeadParagraph', articleRequest.showLeadParagraph.toString());
        formData.append('showDate', articleRequest.showDate.toString());
        formData.append('gallery', articleRequest.gallery);
        formData.append('additionalFiles', articleRequest.additionalFiles);
        formData.append('counter', articleRequest.counter.toString());
        formData.append('archive', articleRequest.archive.toString());
        formData.append('url', articleRequest.url);
        return client.request({ url: `api/v1/article`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1AssociationId = (id, params) => {
        return client.request({ url: `api/v1/association/${id}`, method: 'GET',
            params
        });
    };
    const putApiV1AssociationId = (id, associationUpdateRequest) => {
        return client.request({ url: `api/v1/association/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: associationUpdateRequest
        });
    };
    const deleteApiV1AssociationId = (id) => {
        return client.request({ url: `api/v1/association/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Association = (params) => {
        return client.request({ url: `api/v1/association`, method: 'GET',
            params
        });
    };
    const postApiV1Association = (associationRequest) => {
        return client.request({ url: `api/v1/association`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: associationRequest
        });
    };
    const getApiV1AuthAccess = () => {
        return client.request({ url: `api/v1/auth/access`, method: 'GET'
        });
    };
    const postApiV1AuthLogin = (loginRequest) => {
        return client.request({ url: `api/v1/auth/login`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: loginRequest
        });
    };
    const getApiV1AuthMe = () => {
        return client.request({ url: `api/v1/auth/me`, method: 'GET'
        });
    };
    const putApiV1AuthPassword = (changePasswordRequest) => {
        return client.request({ url: `api/v1/auth/password`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: changePasswordRequest
        });
    };
    const postApiV1AuthRefresh = (refreshRequest) => {
        return client.request({ url: `api/v1/auth/refresh`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refreshRequest
        });
    };
    const postApiV1AuthResetConfirm = (confirmPasswordChangeRequest) => {
        return client.request({ url: `api/v1/auth/reset/confirm`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: confirmPasswordChangeRequest
        });
    };
    const postApiV1AuthReset = (resetRequest) => {
        return client.request({ url: `api/v1/auth/reset`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: resetRequest
        });
    };
    const putApiV1AuthUsername = (changeUsernameRequest) => {
        return client.request({ url: `api/v1/auth/username`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: changeUsernameRequest
        });
    };
    const deleteApiV1BankAccountAccountId = (accountId) => {
        return client.request({ url: `api/v1/bank/account/${accountId}`, method: 'DELETE'
        });
    };
    const postApiV1BankAccount = (accountRequest) => {
        return client.request({ url: `api/v1/bank/account`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: accountRequest
        });
    };
    const getApiV1BankAccountsExport = (params) => {
        return client.request({ url: `api/v1/bank/accounts/export`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsStatisticsExport = (params) => {
        return client.request({ url: `api/v1/bank/accounts/statistics/export`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsStatistics = (params) => {
        return client.request({ url: `api/v1/bank/accounts/statistics`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsTypeType = (type, params) => {
        return client.request({ url: `api/v1/bank/accounts/type/${type}`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsAccountIdTransactionsExport = (accountId, params) => {
        return client.request({ url: `api/v1/bank/accounts/${accountId}/transactions/export`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsAccountIdTransactionsPdf = (accountId, params) => {
        return client.request({ url: `api/v1/bank/accounts/${accountId}/transactions/pdf`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsAccountIdTransactions = (accountId, params) => {
        return client.request({ url: `api/v1/bank/accounts/${accountId}/transactions`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsAccountId = (accountId) => {
        return client.request({ url: `api/v1/bank/accounts/${accountId}`, method: 'GET'
        });
    };
    const getApiV1BankAccounts = (params) => {
        return client.request({ url: `api/v1/bank/accounts`, method: 'GET',
            params
        });
    };
    const getApiV1BankAccountsList = () => {
        return client.request({ url: `api/v1/bank/accounts-list`, method: 'GET'
        });
    };
    const postApiV1BankPayRequest = (requestPayRequest) => {
        return client.request({ url: `api/v1/bank/pay-request`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: requestPayRequest
        });
    };
    const getApiV1BankPaymentPaymentId = (paymentId) => {
        return client.request({ url: `api/v1/bank/payment/${paymentId}`, method: 'GET'
        });
    };
    const getApiV1BankPayment = (params) => {
        return client.request({ url: `api/v1/bank/payment`, method: 'GET',
            params
        });
    };
    const getApiV1BankRequestPaymentRequestId = (requestId) => {
        return client.request({ url: `api/v1/bank/request-payment/${requestId}`, method: 'GET'
        });
    };
    const postApiV1BankTransaction = (bankTransactionRequest, params) => {
        return client.request({ url: `api/v1/bank/transaction`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: bankTransactionRequest,
            params
        });
    };
    const getApiV1BankUserRights = (params) => {
        return client.request({ url: `api/v1/bank/user-rights`, method: 'GET',
            params
        });
    };
    const postApiV1BankWithdraw = (withdrawRequest, params) => {
        return client.request({ url: `api/v1/bank/withdraw`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: withdrawRequest,
            params
        });
    };
    const getApiV1BankIdAccountName = (id) => {
        return client.request({ url: `api/v1/bank/${id}/account-name`, method: 'GET'
        });
    };
    const getApiV1BannerFileId = (id) => {
        return client.request({ url: `api/v1/banner/file/${id}`, method: 'GET'
        });
    };
    const getApiV1BannerId = (id) => {
        return client.request({ url: `api/v1/banner/${id}`, method: 'GET'
        });
    };
    const putApiV1BannerId = (id, bannerUpdateRequest) => {
        const formData = new FormData();
        if (bannerUpdateRequest.slot !== undefined && bannerUpdateRequest.slot !== null) {
            formData.append('slot', bannerUpdateRequest.slot);
        }
        if (bannerUpdateRequest.file !== undefined && bannerUpdateRequest.file !== null) {
            formData.append('file', bannerUpdateRequest.file);
        }
        if (bannerUpdateRequest.showFrom !== undefined && bannerUpdateRequest.showFrom !== null) {
            formData.append('showFrom', bannerUpdateRequest.showFrom);
        }
        if (bannerUpdateRequest.showTo !== undefined && bannerUpdateRequest.showTo !== null) {
            formData.append('showTo', bannerUpdateRequest.showTo);
        }
        if (bannerUpdateRequest.insertedBy !== undefined && bannerUpdateRequest.insertedBy !== null) {
            formData.append('insertedBy', bannerUpdateRequest.insertedBy.toString());
        }
        if (bannerUpdateRequest.url !== undefined && bannerUpdateRequest.url !== null) {
            formData.append('url', bannerUpdateRequest.url);
        }
        if (bannerUpdateRequest.blank !== undefined && bannerUpdateRequest.blank !== null) {
            formData.append('blank', bannerUpdateRequest.blank.toString());
        }
        return client.request({ url: `api/v1/banner/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1BannerId = (id) => {
        return client.request({ url: `api/v1/banner/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Banner = (params) => {
        return client.request({ url: `api/v1/banner`, method: 'GET',
            params
        });
    };
    const postApiV1Banner = (bannerRequest) => {
        const formData = new FormData();
        formData.append('slot', bannerRequest.slot);
        formData.append('file', bannerRequest.file);
        formData.append('showFrom', bannerRequest.showFrom);
        if (bannerRequest.showTo !== undefined && bannerRequest.showTo !== null) {
            formData.append('showTo', bannerRequest.showTo);
        }
        if (bannerRequest.insertedBy !== undefined && bannerRequest.insertedBy !== null) {
            formData.append('insertedBy', bannerRequest.insertedBy.toString());
        }
        formData.append('url', bannerRequest.url);
        formData.append('blank', bannerRequest.blank.toString());
        return client.request({ url: `api/v1/banner`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1BeachAbv = (params) => {
        return client.request({ url: `api/v1/beach/abv`, method: 'GET',
            params
        });
    };
    const getApiV1BeachAgeCategories = () => {
        return client.request({ url: `api/v1/beach/age-categories`, method: 'GET'
        });
    };
    const getApiV1BeachAllowedFolders = () => {
        return client.request({ url: `api/v1/beach/allowed-folders`, method: 'GET'
        });
    };
    const getApiV1BeachApplicationPlayerPlayerIdHistory = (playerId, params) => {
        return client.request({ url: `api/v1/beach/application/player/${playerId}/history`, method: 'GET',
            params
        });
    };
    const postApiV1BeachApplicationSetWildCardRegistrationId = (registrationId, beachWildCardRequest) => {
        return client.request({ url: `api/v1/beach/application/set-wild-card/${registrationId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachWildCardRequest
        });
    };
    const putApiV1BeachApplicationRegistrationId = (registrationId, beachTournamentRegistrationUpdateRequest) => {
        return client.request({ url: `api/v1/beach/application/${registrationId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentRegistrationUpdateRequest
        });
    };
    const getApiV1BeachApplicationTournamentIdMainCompetition = (tournamentId) => {
        return client.request({ url: `api/v1/beach/application/${tournamentId}/main-competition`, method: 'GET'
        });
    };
    const getApiV1BeachApplicationTournamentIdQualification = (tournamentId) => {
        return client.request({ url: `api/v1/beach/application/${tournamentId}/qualification`, method: 'GET'
        });
    };
    const getApiV1BeachApplicationTournamentId = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/application/${tournamentId}`, method: 'GET',
            params
        });
    };
    const postApiV1BeachApplication = (beachTournamentRegistrationRequest, params) => {
        return client.request({ url: `api/v1/beach/application`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentRegistrationRequest,
            params
        });
    };
    const putApiV1BeachAttachmentType = (beachAttachmentTypeCollection, params) => {
        return client.request({ url: `api/v1/beach/attachment/type`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachAttachmentTypeCollection,
            params
        });
    };
    const getApiV1BeachCategory = () => {
        return client.request({ url: `api/v1/beach/category`, method: 'GET'
        });
    };
    const getApiV1BeachConstants = (params) => {
        return client.request({ url: `api/v1/beach/constants`, method: 'GET',
            params
        });
    };
    const getApiV1BeachDelegationCategoryCategory = (category, params) => {
        return client.request({ url: `api/v1/beach/delegation/category/${category}`, method: 'GET',
            params
        });
    };
    const deleteApiV1BeachDelegationPenaltyPenaltyId = (penaltyId) => {
        return client.request({ url: `api/v1/beach/delegation/penalty/${penaltyId}`, method: 'DELETE'
        });
    };
    const postApiV1BeachDelegationPenalty = (beachRefereePenaltyRequest, params) => {
        return client.request({ url: `api/v1/beach/delegation/penalty`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachRefereePenaltyRequest,
            params
        });
    };
    const postApiV1BeachDelegationRefereeEmail = () => {
        return client.request({ url: `api/v1/beach/delegation/referee/email`, method: 'POST'
        });
    };
    const putApiV1BeachDelegationRefereeTests = (beachDelegationRefereeTestUpdateCollection) => {
        return client.request({ url: `api/v1/beach/delegation/referee/tests`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachDelegationRefereeTestUpdateCollection
        });
    };
    const getApiV1BeachDelegationRefereeUserIdTournaments = (userId, params) => {
        return client.request({ url: `api/v1/beach/delegation/referee/${userId}/tournaments`, method: 'GET',
            params
        });
    };
    const getApiV1BeachDelegationRefereeUserIdValuation = (userId) => {
        return client.request({ url: `api/v1/beach/delegation/referee/${userId}/valuation`, method: 'GET'
        });
    };
    const putApiV1BeachDelegationRefereeUserIdValuation = (userId, beachDelegationRefereeValuationUpdateCollection) => {
        return client.request({ url: `api/v1/beach/delegation/referee/${userId}/valuation`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachDelegationRefereeValuationUpdateCollection
        });
    };
    const putApiV1BeachDelegationRefereeUserId = (userId, beachRefereeTestRequest) => {
        return client.request({ url: `api/v1/beach/delegation/referee/${userId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachRefereeTestRequest
        });
    };
    const getApiV1BeachDelegationReferee = (params) => {
        return client.request({ url: `api/v1/beach/delegation/referee`, method: 'GET',
            params
        });
    };
    const getApiV1BeachDelegationTournamentTournamentIdReferee = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/delegation/tournament/${tournamentId}/referee`, method: 'GET',
            params
        });
    };
    const postApiV1BeachDelegationTournamentTournamentIdValuation = (tournamentId, beachDelegationTournamentRefereeValuationCollection) => {
        return client.request({ url: `api/v1/beach/delegation/tournament/${tournamentId}/valuation`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachDelegationTournamentRefereeValuationCollection
        });
    };
    const postApiV1BeachFolderGivePermission = (beachGiveFolderPermissionRequest, params) => {
        return client.request({ url: `api/v1/beach/folder/give-permission`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachGiveFolderPermissionRequest,
            params
        });
    };
    const postApiV1BeachFolderTakePermission = (params) => {
        return client.request({ url: `api/v1/beach/folder/take-permission`, method: 'POST',
            params
        });
    };
    const getApiV1BeachFolderTournaments = (params) => {
        return client.request({ url: `api/v1/beach/folder/tournaments`, method: 'GET',
            params
        });
    };
    const getApiV1BeachFolderFolderIdPermissionAvailableLevels = (folderId) => {
        return client.request({ url: `api/v1/beach/folder/${folderId}/permission/available-levels`, method: 'GET'
        });
    };
    const getApiV1BeachFolderFolderIdPermission = (folderId, params) => {
        return client.request({ url: `api/v1/beach/folder/${folderId}/permission`, method: 'GET',
            params
        });
    };
    const getApiV1BeachFolderFolderIdSubfolders = (folderId) => {
        return client.request({ url: `api/v1/beach/folder/${folderId}/subfolders`, method: 'GET'
        });
    };
    const getApiV1BeachFolderFolderId = (folderId) => {
        return client.request({ url: `api/v1/beach/folder/${folderId}`, method: 'GET'
        });
    };
    const putApiV1BeachFolderFolderId = (folderId, beachFolderUpdateRequest) => {
        return client.request({ url: `api/v1/beach/folder/${folderId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachFolderUpdateRequest
        });
    };
    const deleteApiV1BeachFolderFolderId = (folderId) => {
        return client.request({ url: `api/v1/beach/folder/${folderId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachFolder = (params) => {
        return client.request({ url: `api/v1/beach/folder`, method: 'GET',
            params
        });
    };
    const postApiV1BeachFolder = (beachFolderRequest, params) => {
        return client.request({ url: `api/v1/beach/folder`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachFolderRequest,
            params
        });
    };
    const getApiV1BeachGameMatchId = (matchId) => {
        return client.request({ url: `api/v1/beach/game/${matchId}`, method: 'GET'
        });
    };
    const putApiV1BeachGameMatchId = (matchId, beachGameUpdateRequest) => {
        return client.request({ url: `api/v1/beach/game/${matchId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachGameUpdateRequest
        });
    };
    const deleteApiV1BeachGameMatchId = (matchId) => {
        return client.request({ url: `api/v1/beach/game/${matchId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachGame = (params) => {
        return client.request({ url: `api/v1/beach/game`, method: 'GET',
            params
        });
    };
    const postApiV1BeachGame = (beachGameRequest) => {
        return client.request({ url: `api/v1/beach/game`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachGameRequest
        });
    };
    const getApiV1BeachHosting = (params) => {
        return client.request({ url: `api/v1/beach/hosting`, method: 'GET',
            params
        });
    };
    const postApiV1BeachHosting = (beachHostingRequest) => {
        return client.request({ url: `api/v1/beach/hosting`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachHostingRequest
        });
    };
    const getApiV1BeachLeaderboardList = (params) => {
        return client.request({ url: `api/v1/beach/leaderboard/list`, method: 'GET',
            params
        });
    };
    const getApiV1BeachLeaderboardSettings = (params) => {
        return client.request({ url: `api/v1/beach/leaderboard/settings`, method: 'GET',
            params
        });
    };
    const getApiV1BeachLeaderboardLeaderboardIdPlayers = (leaderboardId, params) => {
        return client.request({ url: `api/v1/beach/leaderboard/${leaderboardId}/players`, method: 'GET',
            params
        });
    };
    const putApiV1BeachLeaderboardLeaderboardIdPointsPointsId = (leaderboardId, pointsId, beachLeaderboardPointsUpdateRequest) => {
        return client.request({ url: `api/v1/beach/leaderboard/${leaderboardId}/points/${pointsId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachLeaderboardPointsUpdateRequest
        });
    };
    const deleteApiV1BeachLeaderboardLeaderboardIdPointsPointsId = (leaderboardId, pointsId) => {
        return client.request({ url: `api/v1/beach/leaderboard/${leaderboardId}/points/${pointsId}`, method: 'DELETE'
        });
    };
    const postApiV1BeachLeaderboardLeaderboardIdPoints = (leaderboardId, beachLeaderboardPointsRequest) => {
        return client.request({ url: `api/v1/beach/leaderboard/${leaderboardId}/points`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachLeaderboardPointsRequest
        });
    };
    const getApiV1BeachLeaderboardLeaderboardId = (leaderboardId) => {
        return client.request({ url: `api/v1/beach/leaderboard/${leaderboardId}`, method: 'GET'
        });
    };
    const putApiV1BeachLeaderboardLeaderboardId = (leaderboardId, beachLeaderboardUpdateRequest) => {
        return client.request({ url: `api/v1/beach/leaderboard/${leaderboardId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachLeaderboardUpdateRequest
        });
    };
    const getApiV1BeachLeaderboard = (params) => {
        return client.request({ url: `api/v1/beach/leaderboard`, method: 'GET',
            params
        });
    };
    const postApiV1BeachLeaderboard = (beachLeaderboardRequest, params) => {
        return client.request({ url: `api/v1/beach/leaderboard`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachLeaderboardRequest,
            params
        });
    };
    const getApiV1BeachLeaderboardsRecalculate = () => {
        return client.request({ url: `api/v1/beach/leaderboards/recalculate`, method: 'GET'
        });
    };
    const getApiV1BeachLeaderboards = (params) => {
        return client.request({ url: `api/v1/beach/leaderboards`, method: 'GET',
            params
        });
    };
    const getApiV1BeachMyTournamentsCanSignUp = (params) => {
        return client.request({ url: `api/v1/beach/my-tournaments/can-sign-up`, method: 'GET',
            params
        });
    };
    const getApiV1BeachMyTournamentsFuture = (params) => {
        return client.request({ url: `api/v1/beach/my-tournaments/future`, method: 'GET',
            params
        });
    };
    const getApiV1BeachMyTournamentsPlayed = (params) => {
        return client.request({ url: `api/v1/beach/my-tournaments/played`, method: 'GET',
            params
        });
    };
    const getApiV1BeachPersonIdTest = (id) => {
        return client.request({ url: `api/v1/beach/person/${id}/test`, method: 'GET'
        });
    };
    const getApiV1BeachPlayerId = (id) => {
        return client.request({ url: `api/v1/beach/player/${id}`, method: 'GET'
        });
    };
    const putApiV1BeachPlayerId = (id, beachPlayerUpdateRequest) => {
        return client.request({ url: `api/v1/beach/player/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachPlayerUpdateRequest
        });
    };
    const deleteApiV1BeachPlayerId = (id) => {
        return client.request({ url: `api/v1/beach/player/${id}`, method: 'DELETE'
        });
    };
    const getApiV1BeachPlayerUserIdLeaderboardLeaderboardId = (userId, leaderboardId, params) => {
        return client.request({ url: `api/v1/beach/player/${userId}/leaderboard/${leaderboardId}`, method: 'GET',
            params
        });
    };
    const getApiV1BeachPlayerUserIdLeaderboards = (userId, params) => {
        return client.request({ url: `api/v1/beach/player/${userId}/leaderboards`, method: 'GET',
            params
        });
    };
    const getApiV1BeachPlayer = (params) => {
        return client.request({ url: `api/v1/beach/player`, method: 'GET',
            params
        });
    };
    const postApiV1BeachPlayer = (beachPlayerRequest) => {
        return client.request({ url: `api/v1/beach/player`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachPlayerRequest
        });
    };
    const getApiV1BeachPoints = (params) => {
        return client.request({ url: `api/v1/beach/points`, method: 'GET',
            params
        });
    };
    const postApiV1BeachPoints = (beachPointRequest) => {
        return client.request({ url: `api/v1/beach/points`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachPointRequest
        });
    };
    const getApiV1BeachRefereeDelegationListListId = (listId, params) => {
        return client.request({ url: `api/v1/beach/referee/delegation/list/${listId}`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereeListBulkEmail = (bREmailRequest) => {
        return client.request({ url: `api/v1/beach/referee/list/bulk-email`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: bREmailRequest
        });
    };
    const postApiV1BeachRefereeListReferee = (beachRefereeListRefereeRequest, params) => {
        return client.request({ url: `api/v1/beach/referee/list/referee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachRefereeListRefereeRequest,
            params
        });
    };
    const deleteApiV1BeachRefereeListListIdRefereeUserId = (listId, userId) => {
        return client.request({ url: `api/v1/beach/referee/list/${listId}/referee/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachRefereeListListId = (listId, params) => {
        return client.request({ url: `api/v1/beach/referee/list/${listId}`, method: 'GET',
            params
        });
    };
    const deleteApiV1BeachRefereeListListId = (listId) => {
        return client.request({ url: `api/v1/beach/referee/list/${listId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachRefereeList = (params) => {
        return client.request({ url: `api/v1/beach/referee/list`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereeList = (beachRefereeListRequest) => {
        return client.request({ url: `api/v1/beach/referee/list`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachRefereeListRequest
        });
    };
    const getApiV1BeachRefereeMyDelegationUnavailability = (params) => {
        return client.request({ url: `api/v1/beach/referee/my-delegation/unavailability`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereeMyDelegationUnavailability = (beachUnavailabilityRequest) => {
        return client.request({ url: `api/v1/beach/referee/my-delegation/unavailability`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachUnavailabilityRequest
        });
    };
    const putApiV1BeachRefereeMyDelegationDelegationIdConfirm = (delegationId) => {
        return client.request({ url: `api/v1/beach/referee/my-delegation/${delegationId}/confirm`, method: 'PUT'
        });
    };
    const putApiV1BeachRefereeMyDelegationDelegationIdDecline = (delegationId) => {
        return client.request({ url: `api/v1/beach/referee/my-delegation/${delegationId}/decline`, method: 'PUT'
        });
    };
    const deleteApiV1BeachRefereeMyDelegationUnavailabilityIdCancel = (unavailabilityId) => {
        return client.request({ url: `api/v1/beach/referee/my-delegation/${unavailabilityId}/cancel`, method: 'DELETE'
        });
    };
    const getApiV1BeachRefereeMyDelegation = (params) => {
        return client.request({ url: `api/v1/beach/referee/my-delegation`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereePaymentsConfirmPayment = (confirmPaymentRequest) => {
        return client.request({ url: `api/v1/beach/referee/payments/confirm-payment`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: confirmPaymentRequest
        });
    };
    const postApiV1BeachRefereePaymentsDeclinePayment = (confirmPaymentRequest) => {
        return client.request({ url: `api/v1/beach/referee/payments/decline-payment`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: confirmPaymentRequest
        });
    };
    const postApiV1BeachRefereePaymentsShowPdf = (confirmPaymentRequest) => {
        return client.request({ url: `api/v1/beach/referee/payments/show-pdf`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: confirmPaymentRequest
        });
    };
    const getApiV1BeachRefereePaymentsTournaments = (params) => {
        return client.request({ url: `api/v1/beach/referee/payments/tournaments`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereePaymentsTournamentIdCreatePaymentUserId = (tournamentId, userId, refereePaymentRequest) => {
        return client.request({ url: `api/v1/beach/referee/payments/${tournamentId}/create-payment/${userId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refereePaymentRequest
        });
    };
    const getApiV1BeachRefereePaymentsTournamentIdOverview = (tournamentId) => {
        return client.request({ url: `api/v1/beach/referee/payments/${tournamentId}/overview`, method: 'GET'
        });
    };
    const getApiV1BeachRefereePaymentsTournamentIdPaymentUserId = (tournamentId, userId) => {
        return client.request({ url: `api/v1/beach/referee/payments/${tournamentId}/payment/${userId}`, method: 'GET'
        });
    };
    const getApiV1BeachRefereePaymentsTournamentIdReferees = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/referee/payments/${tournamentId}/referees`, method: 'GET',
            params
        });
    };
    const getApiV1BeachRefereeTournamentList = (params) => {
        return client.request({ url: `api/v1/beach/referee/tournament/list`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereeTournamentRefereeNotify = (beachRefereeTournamentRefereeNotifyRequest, params) => {
        return client.request({ url: `api/v1/beach/referee/tournament/referee/notify`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachRefereeTournamentRefereeNotifyRequest,
            params
        });
    };
    const postApiV1BeachRefereeTournamentReferee = (beachRefereeDelegationRequest, params) => {
        return client.request({ url: `api/v1/beach/referee/tournament/referee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachRefereeDelegationRequest,
            params
        });
    };
    const getApiV1BeachRefereeTournamentTournamentIdReferee = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/referee/tournament/${tournamentId}/referee`, method: 'GET',
            params
        });
    };
    const getApiV1BeachRefereeTournamentTournamentId = (tournamentId) => {
        return client.request({ url: `api/v1/beach/referee/tournament/${tournamentId}`, method: 'GET'
        });
    };
    const getApiV1BeachRefereeWhisper = (params) => {
        return client.request({ url: `api/v1/beach/referee/whisper`, method: 'GET',
            params
        });
    };
    const deleteApiV1BeachRefereeRefereeId = (refereeId) => {
        return client.request({ url: `api/v1/beach/referee/${refereeId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachRefereeUserIdDelegation = (userId, params) => {
        return client.request({ url: `api/v1/beach/referee/${userId}/delegation`, method: 'GET',
            params
        });
    };
    const getApiV1BeachRefereeUserIdUnavailability = (userId, params) => {
        return client.request({ url: `api/v1/beach/referee/${userId}/unavailability`, method: 'GET',
            params
        });
    };
    const postApiV1BeachRefereeUserIdUnavailability = (userId, beachUnavailabilityRequest) => {
        return client.request({ url: `api/v1/beach/referee/${userId}/unavailability`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachUnavailabilityRequest
        });
    };
    const deleteApiV1BeachRefereeUnavailabilityIdCancel = (unavailabilityId) => {
        return client.request({ url: `api/v1/beach/referee/${unavailabilityId}/cancel`, method: 'DELETE'
        });
    };
    const deleteApiV1BeachRefereeUnavailabilityIdDelete = (unavailabilityId) => {
        return client.request({ url: `api/v1/beach/referee/${unavailabilityId}/delete`, method: 'DELETE'
        });
    };
    const putApiV1BeachRefereeUnavailabilityIdUnavailability = (unavailabilityId, beachUnavailabilityRequest) => {
        return client.request({ url: `api/v1/beach/referee/${unavailabilityId}/unavailability`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachUnavailabilityRequest
        });
    };
    const getApiV1BeachScoreboardTournamentId = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/scoreboard/${tournamentId}`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticExport = (params) => {
        return client.request({ url: `api/v1/beach/statistic/export`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatistic = (params) => {
        return client.request({ url: `api/v1/beach/statistic`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsClubsTypeExport = (type, params) => {
        return client.request({ url: `api/v1/beach/statistics/clubs/${type}/export`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsClubsType = (type, params) => {
        return client.request({ url: `api/v1/beach/statistics/clubs/${type}`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsPlayersExport = (params) => {
        return client.request({ url: `api/v1/beach/statistics/players/export`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsPlayers = (params) => {
        return client.request({ url: `api/v1/beach/statistics/players`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsRefereeDelegations = (params) => {
        return client.request({ url: `api/v1/beach/statistics/referee/delegations`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsRefereeEvaluation = (params) => {
        return client.request({ url: `api/v1/beach/statistics/referee/evaluation`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsRefereeUnavailability = (params) => {
        return client.request({ url: `api/v1/beach/statistics/referee/unavailability`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsSummaryExport = (params) => {
        return client.request({ url: `api/v1/beach/statistics/summary/export`, method: 'GET',
            params
        });
    };
    const getApiV1BeachStatisticsSummary = (params) => {
        return client.request({ url: `api/v1/beach/statistics/summary`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTemplatesEvaluationCopyFileId = (fileId, beachTemplatesEvaluationCopyRequest) => {
        return client.request({ url: `api/v1/beach/templates/evaluation/copy/${fileId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTemplatesEvaluationCopyRequest
        });
    };
    const getApiV1BeachTemplatesEvaluationDownloadFileId = (fileId) => {
        return client.request({ url: `api/v1/beach/templates/evaluation/download/${fileId}`, method: 'GET'
        });
    };
    const putApiV1BeachTemplatesEvaluationEditFileId = (fileId, beachTemplatesEvaluationEditRequest) => {
        return client.request({ url: `api/v1/beach/templates/evaluation/edit/${fileId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTemplatesEvaluationEditRequest
        });
    };
    const getApiV1BeachTemplatesEvaluationValuesFileId = (fileId, params) => {
        return client.request({ url: `api/v1/beach/templates/evaluation/values/${fileId}`, method: 'GET',
            params
        });
    };
    const getApiV1BeachTemplatesEvaluationFileId = (fileId) => {
        return client.request({ url: `api/v1/beach/templates/evaluation/${fileId}`, method: 'GET'
        });
    };
    const deleteApiV1BeachTemplatesEvaluationFileId = (fileId) => {
        return client.request({ url: `api/v1/beach/templates/evaluation/${fileId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachTemplatesEvaluation = (params) => {
        return client.request({ url: `api/v1/beach/templates/evaluation`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTemplatesEvaluation = (beachTemplatesEvaluationRequest) => {
        const formData = new FormData();
        if (beachTemplatesEvaluationRequest.file !== undefined && beachTemplatesEvaluationRequest.file !== null) {
            formData.append('file', beachTemplatesEvaluationRequest.file);
        }
        return client.request({ url: `api/v1/beach/templates/evaluation`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1BeachTemplatesEvaluations = (params) => {
        return client.request({ url: `api/v1/beach/templates/evaluations`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTemplatesScheduleCopyFileId = (fileId, beachTemplatesScheduleCopyRequest) => {
        return client.request({ url: `api/v1/beach/templates/schedule/copy/${fileId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTemplatesScheduleCopyRequest
        });
    };
    const getApiV1BeachTemplatesScheduleDownloadFileId = (fileId) => {
        return client.request({ url: `api/v1/beach/templates/schedule/download/${fileId}`, method: 'GET'
        });
    };
    const putApiV1BeachTemplatesScheduleEditFileId = (fileId, beachTemplatesScheduleEditRequest) => {
        return client.request({ url: `api/v1/beach/templates/schedule/edit/${fileId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTemplatesScheduleEditRequest
        });
    };
    const getApiV1BeachTemplatesScheduleFileId = (fileId) => {
        return client.request({ url: `api/v1/beach/templates/schedule/${fileId}`, method: 'GET'
        });
    };
    const deleteApiV1BeachTemplatesScheduleFileId = (fileId) => {
        return client.request({ url: `api/v1/beach/templates/schedule/${fileId}`, method: 'DELETE'
        });
    };
    const postApiV1BeachTemplatesSchedule = (beachTemplatesScheduleRequest) => {
        const formData = new FormData();
        if (beachTemplatesScheduleRequest.file !== undefined && beachTemplatesScheduleRequest.file !== null) {
            formData.append('file', beachTemplatesScheduleRequest.file);
        }
        return client.request({ url: `api/v1/beach/templates/schedule`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1BeachTemplatesSchedules = (params) => {
        return client.request({ url: `api/v1/beach/templates/schedules`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTest = (beachTestRequest) => {
        return client.request({ url: `api/v1/beach/test`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTestRequest
        });
    };
    const getApiV1BeachTournamentDetailLists = () => {
        return client.request({ url: `api/v1/beach/tournament/detail/lists`, method: 'GET'
        });
    };
    const getApiV1BeachTournamentGetEvaluationTournamentId = (tournamentId) => {
        return client.request({ url: `api/v1/beach/tournament/get-evaluation/${tournamentId}`, method: 'GET'
        });
    };
    const getApiV1BeachTournamentMainCompetitionScript = (params) => {
        return client.request({ url: `api/v1/beach/tournament/main-competition/script`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTournamentMainCompetitionScript = (beachTournamentScriptRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/main-competition/script`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentScriptRequest,
            params
        });
    };
    const postApiV1BeachTournamentOverlapAllow = (beachTournamentOverlapRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/overlap/allow`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentOverlapRequest,
            params
        });
    };
    const postApiV1BeachTournamentOverlapForbid = (beachTournamentOverlapRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/overlap/forbid`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentOverlapRequest,
            params
        });
    };
    const getApiV1BeachTournamentQualificationScript = (params) => {
        return client.request({ url: `api/v1/beach/tournament/qualification/script`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTournamentQualificationScript = (beachTournamentScriptRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/qualification/script`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentScriptRequest,
            params
        });
    };
    const postApiV1BeachTournamentRegistrationEmail = (beachTournamentRegistrationEmailRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/registration/email`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentRegistrationEmailRequest,
            params
        });
    };
    const putApiV1BeachTournamentRegistrationRegistrationIdCancel = (registrationId, params) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}/cancel`, method: 'PUT',
            params
        });
    };
    const getApiV1BeachTournamentRegistrationRegistrationIdDetail = (registrationId) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}/detail`, method: 'GET'
        });
    };
    const putApiV1BeachTournamentRegistrationRegistrationIdRenew = (registrationId) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}/renew`, method: 'PUT'
        });
    };
    const putApiV1BeachTournamentRegistrationRegistrationIdWildcard = (registrationId, beachWildCardRequest) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}/wildcard`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachWildCardRequest
        });
    };
    const deleteApiV1BeachTournamentRegistrationRegistrationIdWildcard = (registrationId) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}/wildcard`, method: 'DELETE'
        });
    };
    const putApiV1BeachTournamentRegistrationRegistrationId = (registrationId, beachTournamentRegistrationUpdateRequest) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentRegistrationUpdateRequest
        });
    };
    const deleteApiV1BeachTournamentRegistrationRegistrationId = (registrationId) => {
        return client.request({ url: `api/v1/beach/tournament/registration/${registrationId}`, method: 'DELETE'
        });
    };
    const postApiV1BeachTournamentRegistration = (beachTournamentRegistrationRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/registration`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentRegistrationRequest,
            params
        });
    };
    const postApiV1BeachTournamentReturnStartingFee = (beachTournamentReturnStartingFeeRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament/return-starting-fee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentReturnStartingFeeRequest,
            params
        });
    };
    const putApiV1BeachTournamentSetEvaluationTournamentId = (tournamentId, evaluationRequest) => {
        return client.request({ url: `api/v1/beach/tournament/set-evaluation/${tournamentId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: evaluationRequest
        });
    };
    const getApiV1BeachTournamentTypes = () => {
        return client.request({ url: `api/v1/beach/tournament/types`, method: 'GET'
        });
    };
    const getApiV1BeachTournamentWildCardTypes = () => {
        return client.request({ url: `api/v1/beach/tournament/wild-card-types`, method: 'GET'
        });
    };
    const getApiV1BeachTournamentTournamentIdAttachmentAttachmentId = (tournamentId, attachmentId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/attachment/${attachmentId}`, method: 'GET'
        });
    };
    const deleteApiV1BeachTournamentTournamentIdAttachmentAttachmentId = (tournamentId, attachmentId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/attachment/${attachmentId}`, method: 'DELETE'
        });
    };
    const getApiV1BeachTournamentTournamentIdAttachment = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/attachment`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTournamentTournamentIdAttachment = (tournamentId, beachAttachmentRequest, params) => {
        const formData = new FormData();
        if (beachAttachmentRequest.file !== undefined && beachAttachmentRequest.file !== null) {
            formData.append('file', beachAttachmentRequest.file);
        }
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/attachment`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData,
            params
        });
    };
    const putApiV1BeachTournamentTournamentIdCancelQualificationRegistrationId = (tournamentId, registrationId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/cancel-qualification/${registrationId}`, method: 'PUT'
        });
    };
    const getApiV1BeachTournamentTournamentIdDetail = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/detail`, method: 'GET',
            params
        });
    };
    const putApiV1BeachTournamentTournamentIdEndQualification = (tournamentId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/end-qualification`, method: 'PUT'
        });
    };
    const getApiV1BeachTournamentTournamentIdMainCompetitionMatches = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/main-competition/matches`, method: 'GET',
            params
        });
    };
    const getApiV1BeachTournamentTournamentIdQualificationMatches = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/qualification/matches`, method: 'GET',
            params
        });
    };
    const putApiV1BeachTournamentTournamentIdQualifyRegistrationId = (tournamentId, registrationId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/qualify/${registrationId}`, method: 'PUT'
        });
    };
    const getApiV1BeachTournamentTournamentIdRegistrationRecalculate = (tournamentId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/registration/recalculate`, method: 'GET'
        });
    };
    const getApiV1BeachTournamentTournamentIdResultExport = (tournamentId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/result/export`, method: 'GET'
        });
    };
    const getApiV1BeachTournamentTournamentIdResult = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/result`, method: 'GET',
            params
        });
    };
    const putApiV1BeachTournamentTournamentIdResults = (tournamentId, beachResultCollection) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/results`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachResultCollection
        });
    };
    const getApiV1BeachTournamentTournamentIdStartingFee = (tournamentId, params) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}/starting-fee`, method: 'GET',
            params
        });
    };
    const putApiV1BeachTournamentTournamentId = (tournamentId, beachTournamentUpdateRequest) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentUpdateRequest
        });
    };
    const deleteApiV1BeachTournamentTournamentId = (tournamentId) => {
        return client.request({ url: `api/v1/beach/tournament/${tournamentId}`, method: 'DELETE'
        });
    };
    const putApiV1BeachTournamentMatchIdMainCompetitionMatch = (matchId, beachTournamentMatchUpdateRequest) => {
        return client.request({ url: `api/v1/beach/tournament/${matchId}/main-competition/match`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentMatchUpdateRequest
        });
    };
    const putApiV1BeachTournamentMatchIdQualificationMatchResult = (matchId, beachTournamentMatchResultRequest) => {
        return client.request({ url: `api/v1/beach/tournament/${matchId}/qualification/match/result`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentMatchResultRequest
        });
    };
    const getApiV1BeachTournamentMatchIdQualificationMatch = (matchId) => {
        return client.request({ url: `api/v1/beach/tournament/${matchId}/qualification/match`, method: 'GET'
        });
    };
    const putApiV1BeachTournamentMatchIdQualificationMatch = (matchId, beachTournamentMatchUpdateRequest) => {
        return client.request({ url: `api/v1/beach/tournament/${matchId}/qualification/match`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentMatchUpdateRequest
        });
    };
    const getApiV1BeachTournament = (params) => {
        return client.request({ url: `api/v1/beach/tournament`, method: 'GET',
            params
        });
    };
    const postApiV1BeachTournament = (beachTournamentRequest, params) => {
        return client.request({ url: `api/v1/beach/tournament`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentRequest,
            params
        });
    };
    const getApiV1BeachUserRights = (params) => {
        return client.request({ url: `api/v1/beach/user-rights`, method: 'GET',
            params
        });
    };
    const postApiV1CardCreateUserId = (userId, params) => {
        return client.request({ url: `api/v1/card/create/${userId}`, method: 'POST',
            params
        });
    };
    const getApiV1CardHistoryUserId = (userId) => {
        return client.request({ url: `api/v1/card/history/${userId}`, method: 'GET'
        });
    };
    const getApiV1CardPdfUserId = (userId) => {
        return client.request({ url: `api/v1/card/pdf/${userId}`, method: 'GET'
        });
    };
    const getApiV1CardId = (id) => {
        return client.request({ url: `api/v1/card/${id}`, method: 'GET'
        });
    };
    const putApiV1CardId = (id, cardUpdateRequest) => {
        return client.request({ url: `api/v1/card/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: cardUpdateRequest
        });
    };
    const deleteApiV1CardId = (id) => {
        return client.request({ url: `api/v1/card/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Card = (params) => {
        return client.request({ url: `api/v1/card`, method: 'GET',
            params
        });
    };
    const postApiV1Card = (cardRequest) => {
        return client.request({ url: `api/v1/card`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: cardRequest
        });
    };
    const getApiV1CategoryList = () => {
        return client.request({ url: `api/v1/category/list`, method: 'GET'
        });
    };
    const getApiV1CategoryId = (id) => {
        return client.request({ url: `api/v1/category/${id}`, method: 'GET'
        });
    };
    const putApiV1CategoryId = (id, categoryUpdateRequest) => {
        return client.request({ url: `api/v1/category/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: categoryUpdateRequest
        });
    };
    const getApiV1Category = (params) => {
        return client.request({ url: `api/v1/category`, method: 'GET',
            params
        });
    };
    const postApiV1Category = (categoryRequest) => {
        return client.request({ url: `api/v1/category`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: categoryRequest
        });
    };
    const getApiV1ClubAbv = (params) => {
        return client.request({ url: `api/v1/club/abv`, method: 'GET',
            params
        });
    };
    const getApiV1ClubDonationPayment = (params) => {
        return client.request({ url: `api/v1/club/donation/payment`, method: 'GET',
            params
        });
    };
    const getApiV1ClubDonationStatus = (params) => {
        return client.request({ url: `api/v1/club/donation/status`, method: 'GET',
            params
        });
    };
    const getApiV1ClubFavorite = (params) => {
        return client.request({ url: `api/v1/club/favorite`, method: 'GET',
            params
        });
    };
    const getApiV1ClubImageClubId = (clubId) => {
        return client.request({ url: `api/v1/club/image/${clubId}`, method: 'GET'
        });
    };
    const putApiV1ClubImageClubId = (clubId, clubImageUpdateRequest) => {
        const formData = new FormData();
        formData.append('logo', clubImageUpdateRequest.logo);
        return client.request({ url: `api/v1/club/image/${clubId}`, method: 'PUT',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1ClubImageClubId = (clubId) => {
        return client.request({ url: `api/v1/club/image/${clubId}`, method: 'DELETE'
        });
    };
    const getApiV1ClubMatchPastId = (id) => {
        return client.request({ url: `api/v1/club/match/past/${id}`, method: 'GET'
        });
    };
    const getApiV1ClubMatchId = (id) => {
        return client.request({ url: `api/v1/club/match/${id}`, method: 'GET'
        });
    };
    const putApiV1ClubMatchId = (id, clubMatchUpdateRequest) => {
        return client.request({ url: `api/v1/club/match/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: clubMatchUpdateRequest
        });
    };
    const getApiV1ClubMemberBeachDailyOverview = (params) => {
        return client.request({ url: `api/v1/club/member/beach/daily-overview`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMemberBeachDailyOverviewDetail = (params) => {
        return client.request({ url: `api/v1/club/member/beach/daily-overview-detail`, method: 'GET',
            params
        });
    };
    const putApiV1ClubMemberBeachUserIdSetBeach = (userId, clubMemberBeachRequest) => {
        return client.request({ url: `api/v1/club/member/beach/${userId}/set-beach`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: clubMemberBeachRequest
        });
    };
    const getApiV1ClubMemberBeach = (params) => {
        return client.request({ url: `api/v1/club/member/beach`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMemberBirthNumber = (params) => {
        return client.request({ url: `api/v1/club/member/birthNumber`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMemberExport = (params) => {
        return client.request({ url: `api/v1/club/member/export`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMember = (params) => {
        return client.request({ url: `api/v1/club/member`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMembersForNsaCsvExportClubId = (clubId, params) => {
        return client.request({ url: `api/v1/club/members-for-nsa/csv-export/${clubId}`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMembersForNsaExportClubId = (clubId, params) => {
        return client.request({ url: `api/v1/club/members-for-nsa/export/${clubId}`, method: 'GET',
            params
        });
    };
    const getApiV1ClubMembersForNsaYears = () => {
        return client.request({ url: `api/v1/club/members-for-nsa/years`, method: 'GET'
        });
    };
    const getApiV1ClubMembersForNsaClubId = (clubId, params) => {
        return client.request({ url: `api/v1/club/members-for-nsa/${clubId}`, method: 'GET',
            params
        });
    };
    const getApiV1ClubResponsiblePeopleClubId = (clubId, params) => {
        return client.request({ url: `api/v1/club/responsible-people/${clubId}`, method: 'GET',
            params
        });
    };
    const postApiV1ClubTalentedYouthUserId = (userId, params) => {
        return client.request({ url: `api/v1/club/talented-youth/${userId}`, method: 'POST',
            params
        });
    };
    const getApiV1ClubUserRights = (params) => {
        return client.request({ url: `api/v1/club/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1ClubWhisper = (params) => {
        return client.request({ url: `api/v1/club/whisper`, method: 'GET',
            params
        });
    };
    const putApiV1ClubIdCancel = (id) => {
        return client.request({ url: `api/v1/club/${id}/cancel`, method: 'PUT'
        });
    };
    const putApiV1ClubIdRestore = (id) => {
        return client.request({ url: `api/v1/club/${id}/restore`, method: 'PUT'
        });
    };
    const getApiV1ClubId = (id) => {
        return client.request({ url: `api/v1/club/${id}`, method: 'GET'
        });
    };
    const putApiV1ClubId = (id, clubUpdateRequest) => {
        return client.request({ url: `api/v1/club/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: clubUpdateRequest
        });
    };
    const getApiV1ClubClubIdMemberEventsDatesUserId = (clubId, userId, params) => {
        return client.request({ url: `api/v1/club/${clubId}/member/events-dates/${userId}`, method: 'GET',
            params
        });
    };
    const getApiV1Club = (params) => {
        return client.request({ url: `api/v1/club`, method: 'GET',
            params
        });
    };
    const postApiV1Club = (clubRequest) => {
        return client.request({ url: `api/v1/club`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: clubRequest
        });
    };
    const postApiV1CompetitionFavoriteId = (id) => {
        return client.request({ url: `api/v1/competition/favorite/${id}`, method: 'POST'
        });
    };
    const deleteApiV1CompetitionFavoriteId = (id) => {
        return client.request({ url: `api/v1/competition/favorite/${id}`, method: 'DELETE'
        });
    };
    const getApiV1CompetitionFavorite = () => {
        return client.request({ url: `api/v1/competition/favorite`, method: 'GET'
        });
    };
    const getApiV1CompetitionFolderFolderIdCompetitions = (folderId, params) => {
        return client.request({ url: `api/v1/competition/folder/${folderId}/competitions`, method: 'GET',
            params
        });
    };
    const getApiV1CompetitionFolderFolderIdSeasons = (folderId) => {
        return client.request({ url: `api/v1/competition/folder/${folderId}/seasons`, method: 'GET'
        });
    };
    const getApiV1CompetitionFolderFolderIdSubfolders = (folderId) => {
        return client.request({ url: `api/v1/competition/folder/${folderId}/subfolders`, method: 'GET'
        });
    };
    const postApiV1CompetitionFolderFolderIdTakePermission = (folderId) => {
        return client.request({ url: `api/v1/competition/folder/${folderId}/take-permission`, method: 'POST'
        });
    };
    const putApiV1CompetitionFolderFolderId = (folderId, folderUpdateRequest) => {
        return client.request({ url: `api/v1/competition/folder/${folderId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: folderUpdateRequest
        });
    };
    const deleteApiV1CompetitionFolderFolderId = (folderId) => {
        return client.request({ url: `api/v1/competition/folder/${folderId}`, method: 'DELETE'
        });
    };
    const postApiV1CompetitionFolder = (folderRequest, params) => {
        return client.request({ url: `api/v1/competition/folder`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: folderRequest,
            params
        });
    };
    const deleteApiV1CompetitionGroupGroupIdRefereeUserId = (groupId, userId) => {
        return client.request({ url: `api/v1/competition/group/${groupId}/referee/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1CompetitionGroupGroupIdReferee = (groupId, params) => {
        return client.request({ url: `api/v1/competition/group/${groupId}/referee`, method: 'GET',
            params
        });
    };
    const postApiV1CompetitionGroupGroupIdReferee = (groupId, competitionRefereeRequest) => {
        return client.request({ url: `api/v1/competition/group/${groupId}/referee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: competitionRefereeRequest
        });
    };
    const postApiV1CompetitionGroupGroupIdRunScheduleScript = (groupId, competitionScriptRequest, params) => {
        const formData = new FormData();
        if (competitionScriptRequest.file !== undefined && competitionScriptRequest.file !== null) {
            formData.append('file', competitionScriptRequest.file);
        }
        return client.request({ url: `api/v1/competition/group/${groupId}/run-schedule-script`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData,
            params
        });
    };
    const getApiV1CompetitionRegionWhisper = (params) => {
        return client.request({ url: `api/v1/competition/region/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1CompetitionScriptFileId = (fileId) => {
        return client.request({ url: `api/v1/competition/script/${fileId}`, method: 'GET'
        });
    };
    const deleteApiV1CompetitionScriptFileId = (fileId) => {
        return client.request({ url: `api/v1/competition/script/${fileId}`, method: 'DELETE'
        });
    };
    const getApiV1CompetitionScript = (params) => {
        return client.request({ url: `api/v1/competition/script`, method: 'GET',
            params
        });
    };
    const postApiV1CompetitionScript = (competitionScriptRequest) => {
        const formData = new FormData();
        if (competitionScriptRequest.file !== undefined && competitionScriptRequest.file !== null) {
            formData.append('file', competitionScriptRequest.file);
        }
        return client.request({ url: `api/v1/competition/script`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1CompetitionScripts = (params) => {
        return client.request({ url: `api/v1/competition/scripts`, method: 'GET',
            params
        });
    };
    const getApiV1CompetitionSeasons = () => {
        return client.request({ url: `api/v1/competition/seasons`, method: 'GET'
        });
    };
    const getApiV1CompetitionSystems = () => {
        return client.request({ url: `api/v1/competition/systems`, method: 'GET'
        });
    };
    const getApiV1CompetitionUserRights = (params) => {
        return client.request({ url: `api/v1/competition/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1CompetitionWhisper = (params) => {
        return client.request({ url: `api/v1/competition/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1CompetitionIdBalls = (id) => {
        return client.request({ url: `api/v1/competition/${id}/balls`, method: 'GET'
        });
    };
    const getApiV1CompetitionIdGroups = (id, params) => {
        return client.request({ url: `api/v1/competition/${id}/groups`, method: 'GET',
            params
        });
    };
    const getApiV1CompetitionId = (id) => {
        return client.request({ url: `api/v1/competition/${id}`, method: 'GET'
        });
    };
    const putApiV1CompetitionId = (id, competitionUpdateRequest) => {
        return client.request({ url: `api/v1/competition/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: competitionUpdateRequest
        });
    };
    const deleteApiV1CompetitionId = (id) => {
        return client.request({ url: `api/v1/competition/${id}`, method: 'DELETE'
        });
    };
    const postApiV1CompetitionFolderIdTakePermission = (folderId) => {
        return client.request({ url: `api/v1/competition/${folderId}/take-permission`, method: 'POST'
        });
    };
    const getApiV1Competition = (params) => {
        return client.request({ url: `api/v1/competition`, method: 'GET',
            params
        });
    };
    const postApiV1Competition = (competitionRequest, params) => {
        return client.request({ url: `api/v1/competition`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: competitionRequest,
            params
        });
    };
    const getApiV1ContractAvailableClubsUserId = (userId, params) => {
        return client.request({ url: `api/v1/contract/available-clubs/${userId}`, method: 'GET',
            params
        });
    };
    const getApiV1ContractContractClubs = (params) => {
        return client.request({ url: `api/v1/contract/contract-clubs`, method: 'GET',
            params
        });
    };
    const getApiV1ContractId = (id) => {
        return client.request({ url: `api/v1/contract/${id}`, method: 'GET'
        });
    };
    const putApiV1ContractId = (id, contractUpdateRequest) => {
        return client.request({ url: `api/v1/contract/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: contractUpdateRequest
        });
    };
    const deleteApiV1ContractId = (id) => {
        return client.request({ url: `api/v1/contract/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Contract = (params) => {
        return client.request({ url: `api/v1/contract`, method: 'GET',
            params
        });
    };
    const postApiV1Contract = (contractRequest) => {
        return client.request({ url: `api/v1/contract`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: contractRequest
        });
    };
    const getApiV1DelegationEvaluationMatchId = (matchId) => {
        return client.request({ url: `api/v1/delegation/evaluation/${matchId}`, method: 'GET'
        });
    };
    const postApiV1DelegationEvaluationMatchId = (matchId, delegationEvaluationRequest) => {
        return client.request({ url: `api/v1/delegation/evaluation/${matchId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: delegationEvaluationRequest
        });
    };
    const postApiV1DelegationGroupAddFavorite = (delegationSetFavoriteRequest) => {
        return client.request({ url: `api/v1/delegation/group/add-favorite`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: delegationSetFavoriteRequest
        });
    };
    const getApiV1DelegationGroupFavorite = (params) => {
        return client.request({ url: `api/v1/delegation/group/favorite`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationGroupPermission = (params) => {
        return client.request({ url: `api/v1/delegation/group/permission`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationGroupGroupIdIsFavorite = (groupId) => {
        return client.request({ url: `api/v1/delegation/group/${groupId}/is-favorite`, method: 'GET'
        });
    };
    const getApiV1DelegationGroupGroupIdMatch = (groupId, params) => {
        return client.request({ url: `api/v1/delegation/group/${groupId}/match`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationGroupGroupIdMatchDelegations = (groupId, params) => {
        return client.request({ url: `api/v1/delegation/group/${groupId}/match-delegations`, method: 'GET',
            params
        });
    };
    const deleteApiV1DelegationGroupGroupIdRemoveFavorite = (groupId) => {
        return client.request({ url: `api/v1/delegation/group/${groupId}/remove-favorite`, method: 'DELETE'
        });
    };
    const getApiV1DelegationGroup = () => {
        return client.request({ url: `api/v1/delegation/group`, method: 'GET'
        });
    };
    const getApiV1DelegationListListIdEvaluationSend = (listId) => {
        return client.request({ url: `api/v1/delegation/list/${listId}/evaluation/send`, method: 'GET'
        });
    };
    const getApiV1DelegationListListIdEvaluation = (listId, params) => {
        return client.request({ url: `api/v1/delegation/list/${listId}/evaluation`, method: 'GET',
            params
        });
    };
    const putApiV1DelegationListListIdTests = (listId, delegationRefereeTestUpdateCollection) => {
        return client.request({ url: `api/v1/delegation/list/${listId}/tests`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: delegationRefereeTestUpdateCollection
        });
    };
    const getApiV1DelegationList = () => {
        return client.request({ url: `api/v1/delegation/list`, method: 'GET'
        });
    };
    const getApiV1DelegationMatchVacantExport = (params) => {
        return client.request({ url: `api/v1/delegation/match/vacant/export`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationMatchVacantMaster = (params) => {
        return client.request({ url: `api/v1/delegation/match/vacant/master`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationMatchVacant = (params) => {
        return client.request({ url: `api/v1/delegation/match/vacant`, method: 'GET',
            params
        });
    };
    const putApiV1DelegationMatchMatchIdEvaluation = (matchId, matchEvaluationRequest) => {
        return client.request({ url: `api/v1/delegation/match/${matchId}/evaluation`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: matchEvaluationRequest
        });
    };
    const getApiV1DelegationPenaltySend = () => {
        return client.request({ url: `api/v1/delegation/penalty/send`, method: 'GET'
        });
    };
    const getApiV1DelegationPenaltyId = (id) => {
        return client.request({ url: `api/v1/delegation/penalty/${id}`, method: 'GET'
        });
    };
    const putApiV1DelegationPenaltyId = (id, penaltyTestUpdateRequest) => {
        return client.request({ url: `api/v1/delegation/penalty/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: penaltyTestUpdateRequest
        });
    };
    const deleteApiV1DelegationPenaltyId = (id) => {
        return client.request({ url: `api/v1/delegation/penalty/${id}`, method: 'DELETE'
        });
    };
    const getApiV1DelegationPenalty = (params) => {
        return client.request({ url: `api/v1/delegation/penalty`, method: 'GET',
            params
        });
    };
    const postApiV1DelegationPenalty = (penaltyTestRequest) => {
        return client.request({ url: `api/v1/delegation/penalty`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: penaltyTestRequest
        });
    };
    const getApiV1DelegationRefereeUserIdEvaluation = (userId) => {
        return client.request({ url: `api/v1/delegation/referee/${userId}/evaluation`, method: 'GET'
        });
    };
    const getApiV1DelegationRefereeUserIdMatchDelegations = (userId, params) => {
        return client.request({ url: `api/v1/delegation/referee/${userId}/match-delegations`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationRefereeUserIdPenalty = (userId) => {
        return client.request({ url: `api/v1/delegation/referee/${userId}/penalty`, method: 'GET'
        });
    };
    const postApiV1DelegationRefereeUserIdPenalty = (userId, penaltyTestAddRequest) => {
        return client.request({ url: `api/v1/delegation/referee/${userId}/penalty`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: penaltyTestAddRequest
        });
    };
    const getApiV1DelegationResultId = (id) => {
        return client.request({ url: `api/v1/delegation/result/${id}`, method: 'GET'
        });
    };
    const putApiV1DelegationResultId = (id, penaltyTestUpdateRequest) => {
        return client.request({ url: `api/v1/delegation/result/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: penaltyTestUpdateRequest
        });
    };
    const deleteApiV1DelegationResultId = (id) => {
        return client.request({ url: `api/v1/delegation/result/${id}`, method: 'DELETE'
        });
    };
    const getApiV1DelegationResult = (params) => {
        return client.request({ url: `api/v1/delegation/result`, method: 'GET',
            params
        });
    };
    const postApiV1DelegationResult = (penaltyTestRequest) => {
        return client.request({ url: `api/v1/delegation/result`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: penaltyTestRequest
        });
    };
    const getApiV1DelegationTechnicalList = (params) => {
        return client.request({ url: `api/v1/delegation/technical/list`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationTechnicalUserIdMatchList = (userId, params) => {
        return client.request({ url: `api/v1/delegation/technical/${userId}/match-list`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationUserRights = (params) => {
        return client.request({ url: `api/v1/delegation/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1DelegationId = (id) => {
        return client.request({ url: `api/v1/delegation/${id}`, method: 'GET'
        });
    };
    const putApiV1DelegationId = (id, delegationUpdateRequest) => {
        return client.request({ url: `api/v1/delegation/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: delegationUpdateRequest
        });
    };
    const deleteApiV1DelegationId = (id) => {
        return client.request({ url: `api/v1/delegation/${id}`, method: 'DELETE'
        });
    };
    const getApiV1DelegationDelegationIdEvaluation = (delegationId) => {
        return client.request({ url: `api/v1/delegation/${delegationId}/evaluation`, method: 'GET'
        });
    };
    const putApiV1DelegationDelegationIdEvaluation = (delegationId, delegationSimpleEvaluationRequest) => {
        return client.request({ url: `api/v1/delegation/${delegationId}/evaluation`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: delegationSimpleEvaluationRequest
        });
    };
    const postApiV1DelegationDelegationIdRefereeUserIdConfirmEvaluation = (delegationId, userId) => {
        return client.request({ url: `api/v1/delegation/${delegationId}/referee/${userId}/confirm-evaluation`, method: 'POST'
        });
    };
    const getApiV1Delegation = (params) => {
        return client.request({ url: `api/v1/delegation`, method: 'GET',
            params
        });
    };
    const postApiV1Delegation = (delegationRequest) => {
        return client.request({ url: `api/v1/delegation`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: delegationRequest
        });
    };
    const getApiV1DeviceId = (id) => {
        return client.request({ url: `api/v1/device/${id}`, method: 'GET'
        });
    };
    const putApiV1DeviceId = (id, deviceUpdateRequest) => {
        return client.request({ url: `api/v1/device/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: deviceUpdateRequest
        });
    };
    const deleteApiV1DeviceId = (id) => {
        return client.request({ url: `api/v1/device/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Device = (params) => {
        return client.request({ url: `api/v1/device`, method: 'GET',
            params
        });
    };
    const postApiV1Device = (deviceRequest) => {
        return client.request({ url: `api/v1/device`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: deviceRequest
        });
    };
    const getApiV1DonationClubIdUser = (id, params) => {
        return client.request({ url: `api/v1/donation/club/${id}/user`, method: 'GET',
            params
        });
    };
    const getApiV1DonationClubId = (id, params) => {
        return client.request({ url: `api/v1/donation/club/${id}`, method: 'GET',
            params
        });
    };
    const getApiV1DonationStatisticsClubClubId = (clubId, params) => {
        return client.request({ url: `api/v1/donation/statistics/club/${clubId}`, method: 'GET',
            params
        });
    };
    const getApiV1DonationStatisticsClub = (params) => {
        return client.request({ url: `api/v1/donation/statistics/club`, method: 'GET',
            params
        });
    };
    const getApiV1DonationStatisticsDistrict = (params) => {
        return client.request({ url: `api/v1/donation/statistics/district`, method: 'GET',
            params
        });
    };
    const getApiV1DonationStatisticsRegion = (params) => {
        return client.request({ url: `api/v1/donation/statistics/region`, method: 'GET',
            params
        });
    };
    const getApiV1DonationUserId = (id, params) => {
        return client.request({ url: `api/v1/donation/user/${id}`, method: 'GET',
            params
        });
    };
    const getApiV1DonationId = (id) => {
        return client.request({ url: `api/v1/donation/${id}`, method: 'GET'
        });
    };
    const putApiV1DonationId = (id, donationUpdateRequest) => {
        return client.request({ url: `api/v1/donation/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: donationUpdateRequest
        });
    };
    const deleteApiV1DonationId = (id) => {
        return client.request({ url: `api/v1/donation/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Donation = (params) => {
        return client.request({ url: `api/v1/donation`, method: 'GET',
            params
        });
    };
    const postApiV1Donation = (donationRequest) => {
        return client.request({ url: `api/v1/donation`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: donationRequest
        });
    };
    const getApiV1EmailPackage = () => {
        return client.request({ url: `api/v1/email/package`, method: 'GET'
        });
    };
    const postApiV1EmailSend = (emailRequest) => {
        const formData = new FormData();
        formData.append('subject', emailRequest.subject);
        formData.append('message', emailRequest.message);
        if (emailRequest.receiverId !== undefined && emailRequest.receiverId !== null) {
            formData.append('receiverId', emailRequest.receiverId);
        }
        if (emailRequest.email !== undefined && emailRequest.email !== null) {
            formData.append('email', emailRequest.email);
        }
        if (emailRequest.addressBook !== undefined && emailRequest.addressBook !== null) {
            formData.append('addressBook', emailRequest.addressBook);
        }
        if (emailRequest.package !== undefined && emailRequest.package !== null) {
            formData.append('package', emailRequest.package);
        }
        if (emailRequest.competitionId !== undefined && emailRequest.competitionId !== null) {
            formData.append('competitionId', emailRequest.competitionId);
        }
        if (emailRequest.attachments !== undefined && emailRequest.attachments !== null) {
            emailRequest.attachments.forEach(value => formData.append('attachments', value));
        }
        return client.request({ url: `api/v1/email/send`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1Email = (params) => {
        return client.request({ url: `api/v1/email`, method: 'GET',
            params
        });
    };
    const getApiV1ExcuseId = (id) => {
        return client.request({ url: `api/v1/excuse/${id}`, method: 'GET'
        });
    };
    const putApiV1ExcuseId = (id, excuseRequest) => {
        return client.request({ url: `api/v1/excuse/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: excuseRequest
        });
    };
    const deleteApiV1ExcuseId = (id) => {
        return client.request({ url: `api/v1/excuse/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Excuse = (params) => {
        return client.request({ url: `api/v1/excuse`, method: 'GET',
            params
        });
    };
    const postApiV1Excuse = (excuseRequest) => {
        return client.request({ url: `api/v1/excuse`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: excuseRequest
        });
    };
    const getApiV1FamouspersonExport = (params) => {
        return client.request({ url: `api/v1/famousperson/export`, method: 'GET',
            params
        });
    };
    const postApiV1FamouspersonPayDonations = () => {
        return client.request({ url: `api/v1/famousperson/pay-donations`, method: 'POST'
        });
    };
    const getApiV1FamouspersonId = (id) => {
        return client.request({ url: `api/v1/famousperson/${id}`, method: 'GET'
        });
    };
    const putApiV1FamouspersonId = (id, famousPersonUpdateRequest) => {
        return client.request({ url: `api/v1/famousperson/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: famousPersonUpdateRequest
        });
    };
    const deleteApiV1FamouspersonId = (id) => {
        return client.request({ url: `api/v1/famousperson/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Famousperson = (params) => {
        return client.request({ url: `api/v1/famousperson`, method: 'GET',
            params
        });
    };
    const postApiV1Famousperson = (famousPersonRequest) => {
        return client.request({ url: `api/v1/famousperson`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: famousPersonRequest
        });
    };
    const getApiV1FeeId = (id) => {
        return client.request({ url: `api/v1/fee/${id}`, method: 'GET'
        });
    };
    const putApiV1FeeId = (id, feeUpdateRequest) => {
        return client.request({ url: `api/v1/fee/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: feeUpdateRequest
        });
    };
    const deleteApiV1FeeId = (id) => {
        return client.request({ url: `api/v1/fee/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Fee = (params) => {
        return client.request({ url: `api/v1/fee`, method: 'GET',
            params
        });
    };
    const postApiV1Fee = (feeRequest) => {
        return client.request({ url: `api/v1/fee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: feeRequest
        });
    };
    const getApiV1FilesId = (id) => {
        return client.request({ url: `api/v1/files/${id}`, method: 'GET'
        });
    };
    const putApiV1FilesId = (id, fileNameRequest) => {
        return client.request({ url: `api/v1/files/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: fileNameRequest
        });
    };
    const deleteApiV1FilesId = (id) => {
        return client.request({ url: `api/v1/files/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Files = () => {
        return client.request({ url: `api/v1/files`, method: 'GET'
        });
    };
    const postApiV1Files = (fileRequest) => {
        const formData = new FormData();
        formData.append('module', fileRequest.module);
        formData.append('moduleId', fileRequest.moduleId);
        formData.append('file', fileRequest.file);
        return client.request({ url: `api/v1/files`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const postApiV1GroupCreateCompetitionId = (competitionId, groupCreateRequest) => {
        return client.request({ url: `api/v1/group/create/${competitionId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: groupCreateRequest
        });
    };
    const postApiV1GroupDraw = (groupDrawRequest) => {
        const formData = new FormData();
        formData.append('groupId', groupDrawRequest.groupId);
        if (groupDrawRequest.fileId !== undefined && groupDrawRequest.fileId !== null) {
            formData.append('fileId', groupDrawRequest.fileId);
        }
        if (groupDrawRequest.script !== undefined && groupDrawRequest.script !== null) {
            formData.append('script', groupDrawRequest.script);
        }
        return client.request({ url: `api/v1/group/draw`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const postApiV1GroupFavoriteGroupId = (groupId) => {
        return client.request({ url: `api/v1/group/favorite/${groupId}`, method: 'POST'
        });
    };
    const deleteApiV1GroupFavoriteGroupId = (groupId) => {
        return client.request({ url: `api/v1/group/favorite/${groupId}`, method: 'DELETE'
        });
    };
    const getApiV1GroupFavorite = () => {
        return client.request({ url: `api/v1/group/favorite`, method: 'GET'
        });
    };
    const getApiV1GroupWhisper = (params) => {
        return client.request({ url: `api/v1/group/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1GroupGroupIdBracket = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/bracket`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdOverlapsGroups = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/overlaps-groups`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdPhotoReportMatchNumber = (groupId, matchNumber) => {
        return client.request({ url: `api/v1/group/${groupId}/photo-report/${matchNumber}`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdPossibleOrganizers = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/possible-organizers`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdScheduleExport = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/schedule/export`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdSchedule = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/schedule`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdTableExport = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/table/export`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdTableFilter = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}/table/filter`, method: 'GET'
        });
    };
    const getApiV1GroupGroupIdTable = (groupId, params) => {
        return client.request({ url: `api/v1/group/${groupId}/table`, method: 'GET',
            params
        });
    };
    const getApiV1GroupGroupIdTeamTeamId = (groupId, teamId) => {
        return client.request({ url: `api/v1/group/${groupId}/team/${teamId}`, method: 'GET'
        });
    };
    const postApiV1GroupGroupIdUploadPhotoReport = (groupId, uploadSchedulePhotoReport, params) => {
        const formData = new FormData();
        formData.append('matchNumber', uploadSchedulePhotoReport.matchNumber);
        formData.append('file', uploadSchedulePhotoReport.file);
        return client.request({ url: `api/v1/group/${groupId}/upload-photo-report`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData,
            params
        });
    };
    const getApiV1GroupGroupId = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}`, method: 'GET'
        });
    };
    const putApiV1GroupGroupId = (groupId, groupUpdateRequest) => {
        return client.request({ url: `api/v1/group/${groupId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: groupUpdateRequest
        });
    };
    const deleteApiV1GroupGroupId = (groupId) => {
        return client.request({ url: `api/v1/group/${groupId}`, method: 'DELETE'
        });
    };
    const getApiV1GroupGroupId1OverlapsGroupId2 = (groupId1, groupId2) => {
        return client.request({ url: `api/v1/group/${groupId1}/overlaps/${groupId2}`, method: 'GET'
        });
    };
    const getApiV1Group = (params) => {
        return client.request({ url: `api/v1/group`, method: 'GET',
            params
        });
    };
    const postApiV1Group = (groupRequest) => {
        return client.request({ url: `api/v1/group`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: groupRequest
        });
    };
    const getApiV1HallClubId = (id) => {
        return client.request({ url: `api/v1/hall/club/${id}`, method: 'GET'
        });
    };
    const getApiV1HallFilterOptions = () => {
        return client.request({ url: `api/v1/hall/filter-options`, method: 'GET'
        });
    };
    const getApiV1HallListExport = (params) => {
        return client.request({ url: `api/v1/hall/list/export`, method: 'GET',
            params
        });
    };
    const getApiV1HallList = (params) => {
        return client.request({ url: `api/v1/hall/list`, method: 'GET',
            params
        });
    };
    const getApiV1HallPersonId = (id) => {
        return client.request({ url: `api/v1/hall/person/${id}`, method: 'GET'
        });
    };
    const putApiV1HallPersonId = (id, hallPersonUpdateRequest) => {
        return client.request({ url: `api/v1/hall/person/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: hallPersonUpdateRequest
        });
    };
    const deleteApiV1HallPersonId = (id) => {
        return client.request({ url: `api/v1/hall/person/${id}`, method: 'DELETE'
        });
    };
    const getApiV1HallPerson = (params) => {
        return client.request({ url: `api/v1/hall/person`, method: 'GET',
            params
        });
    };
    const postApiV1HallPerson = (hallPersonRequest) => {
        return client.request({ url: `api/v1/hall/person`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: hallPersonRequest
        });
    };
    const getApiV1HallSuggestionList = (params) => {
        return client.request({ url: `api/v1/hall/suggestion/list`, method: 'GET',
            params
        });
    };
    const postApiV1HallSuggestionHallSuggestionIdApprove = (hallSuggestionId) => {
        return client.request({ url: `api/v1/hall/suggestion/${hallSuggestionId}/approve`, method: 'POST'
        });
    };
    const getApiV1HallSuggestionHallSuggestionIdDetail = (hallSuggestionId) => {
        return client.request({ url: `api/v1/hall/suggestion/${hallSuggestionId}/detail`, method: 'GET'
        });
    };
    const deleteApiV1HallSuggestionHallSuggestionIdReject = (hallSuggestionId) => {
        return client.request({ url: `api/v1/hall/suggestion/${hallSuggestionId}/reject`, method: 'DELETE'
        });
    };
    const getApiV1HallSuggestionHallSuggestionId = (hallSuggestionId) => {
        return client.request({ url: `api/v1/hall/suggestion/${hallSuggestionId}`, method: 'GET'
        });
    };
    const putApiV1HallSuggestionHallSuggestionId = (hallSuggestionId, hallSuggestionUpdateRequest) => {
        return client.request({ url: `api/v1/hall/suggestion/${hallSuggestionId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: hallSuggestionUpdateRequest
        });
    };
    const deleteApiV1HallSuggestionHallSuggestionId = (hallSuggestionId) => {
        return client.request({ url: `api/v1/hall/suggestion/${hallSuggestionId}`, method: 'DELETE'
        });
    };
    const getApiV1HallSuggestion = (params) => {
        return client.request({ url: `api/v1/hall/suggestion`, method: 'GET',
            params
        });
    };
    const postApiV1HallSuggestion = (hallSuggestionRequest) => {
        return client.request({ url: `api/v1/hall/suggestion`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: hallSuggestionRequest
        });
    };
    const getApiV1HallUserRights = (params) => {
        return client.request({ url: `api/v1/hall/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1HallIdDetail = (id) => {
        return client.request({ url: `api/v1/hall/${id}/detail`, method: 'GET'
        });
    };
    const getApiV1HallId = (id) => {
        return client.request({ url: `api/v1/hall/${id}`, method: 'GET'
        });
    };
    const putApiV1HallId = (id, hallUpdateRequest) => {
        return client.request({ url: `api/v1/hall/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: hallUpdateRequest
        });
    };
    const deleteApiV1HallId = (id) => {
        return client.request({ url: `api/v1/hall/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Hall = (params) => {
        return client.request({ url: `api/v1/hall`, method: 'GET',
            params
        });
    };
    const postApiV1Hall = (hallRequest) => {
        return client.request({ url: `api/v1/hall`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: hallRequest
        });
    };
    const getApiV1Hash = (params) => {
        return client.request({ url: `api/v1/hash`, method: 'GET',
            params
        });
    };
    const getApiV1HelloGet = () => {
        return client.request({ url: `api/v1/hello/get`, method: 'GET'
        });
    };
    const getApiV1LibraryPostId = (id) => {
        return client.request({ url: `api/v1/library/post/${id}`, method: 'GET'
        });
    };
    const postApiV1LibraryPostId = (id, libraryPostUpdateRequest) => {
        const formData = new FormData();
        if (libraryPostUpdateRequest.libraryId !== undefined && libraryPostUpdateRequest.libraryId !== null) {
            formData.append('libraryId', libraryPostUpdateRequest.libraryId.toString());
        }
        if (libraryPostUpdateRequest.authorId !== undefined && libraryPostUpdateRequest.authorId !== null) {
            formData.append('authorId', libraryPostUpdateRequest.authorId.toString());
        }
        if (libraryPostUpdateRequest.text !== undefined && libraryPostUpdateRequest.text !== null) {
            formData.append('text', libraryPostUpdateRequest.text);
        }
        if (libraryPostUpdateRequest.file !== undefined && libraryPostUpdateRequest.file !== null) {
            formData.append('file', libraryPostUpdateRequest.file);
        }
        if (libraryPostUpdateRequest.dateTime !== undefined && libraryPostUpdateRequest.dateTime !== null) {
            formData.append('dateTime', libraryPostUpdateRequest.dateTime);
        }
        if (libraryPostUpdateRequest.private !== undefined && libraryPostUpdateRequest.private !== null) {
            formData.append('private', libraryPostUpdateRequest.private.toString());
        }
        return client.request({ url: `api/v1/library/post/${id}`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1LibraryPostId = (id) => {
        return client.request({ url: `api/v1/library/post/${id}`, method: 'DELETE'
        });
    };
    const getApiV1LibraryPost = (params) => {
        return client.request({ url: `api/v1/library/post`, method: 'GET',
            params
        });
    };
    const postApiV1LibraryPost = (libraryPostRequest) => {
        const formData = new FormData();
        formData.append('libraryId', libraryPostRequest.libraryId);
        formData.append('authorId', libraryPostRequest.authorId);
        formData.append('text', libraryPostRequest.text);
        if (libraryPostRequest.file !== undefined && libraryPostRequest.file !== null) {
            formData.append('file', libraryPostRequest.file);
        }
        if (libraryPostRequest.dateTime !== undefined && libraryPostRequest.dateTime !== null) {
            formData.append('dateTime', libraryPostRequest.dateTime);
        }
        formData.append('private', libraryPostRequest.private.toString());
        return client.request({ url: `api/v1/library/post`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1LibraryId = (id) => {
        return client.request({ url: `api/v1/library/${id}`, method: 'GET'
        });
    };
    const putApiV1LibraryId = (id, libraryUpdateRequest) => {
        return client.request({ url: `api/v1/library/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: libraryUpdateRequest
        });
    };
    const deleteApiV1LibraryId = (id) => {
        return client.request({ url: `api/v1/library/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Library = (params) => {
        return client.request({ url: `api/v1/library`, method: 'GET',
            params
        });
    };
    const postApiV1Library = (libraryRequest) => {
        return client.request({ url: `api/v1/library`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: libraryRequest
        });
    };
    const getApiV1LicenseDetailUserIdCredits = (userId, params) => {
        return client.request({ url: `api/v1/license/detail/${userId}/credits`, method: 'GET',
            params
        });
    };
    const getApiV1LicenseDetailUserIdTraining = (userId, params) => {
        return client.request({ url: `api/v1/license/detail/${userId}/training`, method: 'GET',
            params
        });
    };
    const getApiV1LicenseDetailUserId = (userId) => {
        return client.request({ url: `api/v1/license/detail/${userId}`, method: 'GET'
        });
    };
    const getApiV1LicenseExport = () => {
        return client.request({ url: `api/v1/license/export`, method: 'GET'
        });
    };
    const postApiV1LicenseRenewUserId = (userId) => {
        return client.request({ url: `api/v1/license/renew/${userId}`, method: 'POST'
        });
    };
    const deleteApiV1LicenseTrainingCreditsId = (id) => {
        return client.request({ url: `api/v1/license/training/credits/${id}`, method: 'DELETE'
        });
    };
    const postApiV1LicenseTrainingCredits = (licenseCreditsRequest) => {
        return client.request({ url: `api/v1/license/training/credits`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: licenseCreditsRequest
        });
    };
    const postApiV1LicenseTrainingMarkParticipation = (licenseTrainingParticipationRequest) => {
        return client.request({ url: `api/v1/license/training/mark-participation`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: licenseTrainingParticipationRequest
        });
    };
    const getApiV1LicenseTrainingQualifications = () => {
        return client.request({ url: `api/v1/license/training/qualifications`, method: 'GET'
        });
    };
    const getApiV1LicenseTrainingIdParticipants = (id, params) => {
        return client.request({ url: `api/v1/license/training/${id}/participants`, method: 'GET',
            params
        });
    };
    const getApiV1LicenseTrainingId = (id) => {
        return client.request({ url: `api/v1/license/training/${id}`, method: 'GET'
        });
    };
    const putApiV1LicenseTrainingId = (id, licenseTrainingUpdateRequest) => {
        return client.request({ url: `api/v1/license/training/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: licenseTrainingUpdateRequest
        });
    };
    const deleteApiV1LicenseTrainingId = (id) => {
        return client.request({ url: `api/v1/license/training/${id}`, method: 'DELETE'
        });
    };
    const deleteApiV1LicenseTrainingTrainingIdUnmarkParticipationUserId = (trainingId, userId) => {
        return client.request({ url: `api/v1/license/training/${trainingId}/unmark-participation/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1LicenseTraining = (params) => {
        return client.request({ url: `api/v1/license/training`, method: 'GET',
            params
        });
    };
    const postApiV1LicenseTraining = (licenseTrainingRequest) => {
        return client.request({ url: `api/v1/license/training`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: licenseTrainingRequest
        });
    };
    const getApiV1LicenseId = (id) => {
        return client.request({ url: `api/v1/license/${id}`, method: 'GET'
        });
    };
    const putApiV1LicenseId = (id, licenseUpdateRequest) => {
        return client.request({ url: `api/v1/license/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: licenseUpdateRequest
        });
    };
    const deleteApiV1LicenseId = (id) => {
        return client.request({ url: `api/v1/license/${id}`, method: 'DELETE'
        });
    };
    const getApiV1License = (params) => {
        return client.request({ url: `api/v1/license`, method: 'GET',
            params
        });
    };
    const postApiV1License = (licenseRequest) => {
        return client.request({ url: `api/v1/license`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: licenseRequest
        });
    };
    const getApiV1ListAll = (params) => {
        return client.request({ url: `api/v1/list/all`, method: 'GET',
            params
        });
    };
    const getApiV1ListArchived = () => {
        return client.request({ url: `api/v1/list/archived`, method: 'GET'
        });
    };
    const getApiV1ListByCategory = (params) => {
        return client.request({ url: `api/v1/list/by-category`, method: 'GET',
            params
        });
    };
    const getApiV1ListColumnOptions = () => {
        return client.request({ url: `api/v1/list/column/options`, method: 'GET'
        });
    };
    const getApiV1ListFilterList = (params) => {
        return client.request({ url: `api/v1/list/filter-list`, method: 'GET',
            params
        });
    };
    const getApiV1ListUser = (params) => {
        return client.request({ url: `api/v1/list/user`, method: 'GET',
            params
        });
    };
    const getApiV1ListUserRights = (params) => {
        return client.request({ url: `api/v1/list/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1ListIdDetail = (id) => {
        return client.request({ url: `api/v1/list/${id}/detail`, method: 'GET'
        });
    };
    const getApiV1ListIdRefereeArchive = (id, params) => {
        return client.request({ url: `api/v1/list/${id}/referee/archive`, method: 'GET',
            params
        });
    };
    const postApiV1ListIdRefereeEmail = (id, refereeListGroupEmailRequest) => {
        const formData = new FormData();
        formData.append('subject', refereeListGroupEmailRequest.subject);
        formData.append('text', refereeListGroupEmailRequest.text);
        if (refereeListGroupEmailRequest.attachment !== undefined && refereeListGroupEmailRequest.attachment !== null) {
            formData.append('attachment', refereeListGroupEmailRequest.attachment);
        }
        return client.request({ url: `api/v1/list/${id}/referee/email`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1ListIdRefereeExport = (id, params) => {
        return client.request({ url: `api/v1/list/${id}/referee/export`, method: 'GET',
            params
        });
    };
    const getApiV1ListIdRefereeHistory = (id, params) => {
        return client.request({ url: `api/v1/list/${id}/referee/history`, method: 'GET',
            params
        });
    };
    const getApiV1ListIdRefereeVersion = (id, params) => {
        return client.request({ url: `api/v1/list/${id}/referee/version`, method: 'GET',
            params
        });
    };
    const deleteApiV1ListIdRefereeRefereeListId = (id, refereeListId) => {
        return client.request({ url: `api/v1/list/${id}/referee/${refereeListId}`, method: 'DELETE'
        });
    };
    const getApiV1ListIdRefereeUserIdDetail = (id, userId, params) => {
        return client.request({ url: `api/v1/list/${id}/referee/${userId}/detail`, method: 'GET',
            params
        });
    };
    const getApiV1ListIdReferee = (id, params) => {
        return client.request({ url: `api/v1/list/${id}/referee`, method: 'GET',
            params
        });
    };
    const postApiV1ListIdReferee = (id, refereeListRequest) => {
        return client.request({ url: `api/v1/list/${id}/referee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refereeListRequest
        });
    };
    const postApiV1ListIdRestore = (id) => {
        return client.request({ url: `api/v1/list/${id}/restore`, method: 'POST'
        });
    };
    const getApiV1ListId = (id) => {
        return client.request({ url: `api/v1/list/${id}`, method: 'GET'
        });
    };
    const putApiV1ListId = (id, listUpdateRequest) => {
        return client.request({ url: `api/v1/list/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: listUpdateRequest
        });
    };
    const deleteApiV1ListId = (id) => {
        return client.request({ url: `api/v1/list/${id}`, method: 'DELETE'
        });
    };
    const getApiV1List = (params) => {
        return client.request({ url: `api/v1/list`, method: 'GET',
            params
        });
    };
    const postApiV1List = (listRequest) => {
        return client.request({ url: `api/v1/list`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: listRequest
        });
    };
    const getApiV1LoginId = (id) => {
        return client.request({ url: `api/v1/login/${id}`, method: 'GET'
        });
    };
    const putApiV1LoginId = (id, loginLogUpdateRequest) => {
        return client.request({ url: `api/v1/login/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: loginLogUpdateRequest
        });
    };
    const deleteApiV1LoginId = (id) => {
        return client.request({ url: `api/v1/login/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Login = (params) => {
        return client.request({ url: `api/v1/login`, method: 'GET',
            params
        });
    };
    const postApiV1Login = (loginLogRequest) => {
        return client.request({ url: `api/v1/login`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: loginLogRequest
        });
    };
    const getApiV1MatchTeamHallsTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/match/team-halls/${teamId}`, method: 'GET',
            params
        });
    };
    const getApiV1MatchId = (id) => {
        return client.request({ url: `api/v1/match/${id}`, method: 'GET'
        });
    };
    const getApiV1MatchMatchIdDetail = (matchId, params) => {
        return client.request({ url: `api/v1/match/${matchId}/detail`, method: 'GET',
            params
        });
    };
    const putApiV1MatchMatchIdDetail = (matchId, matchDetailUpdateRequest, params) => {
        return client.request({ url: `api/v1/match/${matchId}/detail`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: matchDetailUpdateRequest,
            params
        });
    };
    const getApiV1MatchMatchIdDetailEdit = (matchId, params) => {
        return client.request({ url: `api/v1/match/${matchId}/detail-edit`, method: 'GET',
            params
        });
    };
    const postApiV1MatchMatchIdSetOutcome = (matchId, matchSetOutcomeRequest, params) => {
        return client.request({ url: `api/v1/match/${matchId}/set-outcome`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: matchSetOutcomeRequest,
            params
        });
    };
    const deleteApiV1MatchMatchId = (matchId, params) => {
        return client.request({ url: `api/v1/match/${matchId}`, method: 'DELETE',
            params
        });
    };
    const getApiV1Match = (params) => {
        return client.request({ url: `api/v1/match`, method: 'GET',
            params
        });
    };
    const postApiV1Match = (matchRequest) => {
        return client.request({ url: `api/v1/match`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: matchRequest
        });
    };
    const getApiV1MenuId = (id) => {
        return client.request({ url: `api/v1/menu/${id}`, method: 'GET'
        });
    };
    const putApiV1MenuId = (id, menuUpdateRequest) => {
        return client.request({ url: `api/v1/menu/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: menuUpdateRequest
        });
    };
    const deleteApiV1MenuId = (id) => {
        return client.request({ url: `api/v1/menu/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Menu = (params) => {
        return client.request({ url: `api/v1/menu`, method: 'GET',
            params
        });
    };
    const postApiV1Menu = (menuRequest) => {
        return client.request({ url: `api/v1/menu`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: menuRequest
        });
    };
    const getApiV1NsaExportClubExtraYear = (year) => {
        return client.request({ url: `api/v1/nsa/export/club/extra/${year}`, method: 'GET'
        });
    };
    const getApiV1NsaExportClub = () => {
        return client.request({ url: `api/v1/nsa/export/club`, method: 'GET'
        });
    };
    const getApiV1NsaExportPersonUniqYear = (year) => {
        return client.request({ url: `api/v1/nsa/export/person/uniq/${year}`, method: 'GET'
        });
    };
    const getApiV1NsaExportPersonYear = (year) => {
        return client.request({ url: `api/v1/nsa/export/person/${year}`, method: 'GET'
        });
    };
    const getApiV1NsaExportPlayerTcm = () => {
        return client.request({ url: `api/v1/nsa/export/player/tcm`, method: 'GET'
        });
    };
    const getApiV1NsaExportPlayerYear = (year) => {
        return client.request({ url: `api/v1/nsa/export/player/${year}`, method: 'GET'
        });
    };
    const getApiV1NsaExportTrainerTcm = () => {
        return client.request({ url: `api/v1/nsa/export/trainer/tcm`, method: 'GET'
        });
    };
    const getApiV1NsaExportTrainerYear = (year) => {
        return client.request({ url: `api/v1/nsa/export/trainer/${year}`, method: 'GET'
        });
    };
    const postApiV1NsaImportPlayer = (nSATCMPlayerImportRequest) => {
        const formData = new FormData();
        formData.append('file', nSATCMPlayerImportRequest.file);
        return client.request({ url: `api/v1/nsa/import/player`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const postApiV1NsaImportTrainer = (nSATCMTrainerImportRequest) => {
        const formData = new FormData();
        formData.append('file', nSATCMTrainerImportRequest.file);
        return client.request({ url: `api/v1/nsa/import/trainer`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1NsaPlayerExtId = (extId) => {
        return client.request({ url: `api/v1/nsa/player/${extId}`, method: 'GET'
        });
    };
    const putApiV1NsaPlayerExtId = (extId, nSAPlayerUpdateRequest) => {
        return client.request({ url: `api/v1/nsa/player/${extId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: nSAPlayerUpdateRequest
        });
    };
    const getApiV1NsaSubsidyClubId = (id) => {
        return client.request({ url: `api/v1/nsa/subsidy/club/${id}`, method: 'GET'
        });
    };
    const getApiV1NsaSummary = () => {
        return client.request({ url: `api/v1/nsa/summary`, method: 'GET'
        });
    };
    const getApiV1NsaTalentedYouthExport = (params) => {
        return client.request({ url: `api/v1/nsa/talented-youth/export`, method: 'GET',
            params
        });
    };
    const getApiV1NsaTalentedYouth = (params) => {
        return client.request({ url: `api/v1/nsa/talented-youth`, method: 'GET',
            params
        });
    };
    const getApiV1OnlineId = (id) => {
        return client.request({ url: `api/v1/online/${id}`, method: 'GET'
        });
    };
    const putApiV1OnlineId = (id, onlineUpdateRequest) => {
        return client.request({ url: `api/v1/online/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: onlineUpdateRequest
        });
    };
    const deleteApiV1OnlineId = (id) => {
        return client.request({ url: `api/v1/online/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Online = (params) => {
        return client.request({ url: `api/v1/online`, method: 'GET',
            params
        });
    };
    const postApiV1Online = (onlineRequest) => {
        return client.request({ url: `api/v1/online`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: onlineRequest
        });
    };
    const postApiV1ParticipationImport = (eventParticipationRequest) => {
        return client.request({ url: `api/v1/participation/import`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: eventParticipationRequest
        });
    };
    const getApiV1ParticipationImportCron = () => {
        return client.request({ url: `api/v1/participation/import-cron`, method: 'GET'
        });
    };
    const getApiV1ParticipationImportSeparateCron = () => {
        return client.request({ url: `api/v1/participation/import-separate-cron`, method: 'GET'
        });
    };
    const getApiV1PartnerId = (id) => {
        return client.request({ url: `api/v1/partner/${id}`, method: 'GET'
        });
    };
    const putApiV1PartnerId = (id, partnerUpdateRequest) => {
        return client.request({ url: `api/v1/partner/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: partnerUpdateRequest
        });
    };
    const deleteApiV1PartnerId = (id) => {
        return client.request({ url: `api/v1/partner/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Partner = (params) => {
        return client.request({ url: `api/v1/partner`, method: 'GET',
            params
        });
    };
    const postApiV1Partner = (partnerRequest) => {
        return client.request({ url: `api/v1/partner`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: partnerRequest
        });
    };
    const getApiV1PaymentId = (id) => {
        return client.request({ url: `api/v1/payment/${id}`, method: 'GET'
        });
    };
    const putApiV1PaymentId = (id, paymentUpdateRequest) => {
        return client.request({ url: `api/v1/payment/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: paymentUpdateRequest
        });
    };
    const deleteApiV1PaymentId = (id) => {
        return client.request({ url: `api/v1/payment/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Payment = (params) => {
        return client.request({ url: `api/v1/payment`, method: 'GET',
            params
        });
    };
    const postApiV1Payment = (paymentRequest) => {
        return client.request({ url: `api/v1/payment`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: paymentRequest
        });
    };
    const getApiV1PermissionUser = () => {
        return client.request({ url: `api/v1/permission/user`, method: 'GET'
        });
    };
    const getApiV1PermissionId = (id) => {
        return client.request({ url: `api/v1/permission/${id}`, method: 'GET'
        });
    };
    const putApiV1PermissionId = (id, permissionRequest) => {
        return client.request({ url: `api/v1/permission/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: permissionRequest
        });
    };
    const deleteApiV1PermissionId = (id) => {
        return client.request({ url: `api/v1/permission/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Permission = (params) => {
        return client.request({ url: `api/v1/permission`, method: 'GET',
            params
        });
    };
    const postApiV1Permission = (permissionRequest) => {
        return client.request({ url: `api/v1/permission`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: permissionRequest
        });
    };
    const getApiV1PersonalSettingsCard = () => {
        return client.request({ url: `api/v1/personal-settings/card`, method: 'GET'
        });
    };
    const getApiV1PersonalSettingsCards = (params) => {
        return client.request({ url: `api/v1/personal-settings/cards`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsContracts = (params) => {
        return client.request({ url: `api/v1/personal-settings/contracts`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsDonations = (params) => {
        return client.request({ url: `api/v1/personal-settings/donations`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsInfo = () => {
        return client.request({ url: `api/v1/personal-settings/info`, method: 'GET'
        });
    };
    const getApiV1PersonalSettingsLicense = (params) => {
        return client.request({ url: `api/v1/personal-settings/license`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsLoginHistory = (params) => {
        return client.request({ url: `api/v1/personal-settings/login-history`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsQualifications = () => {
        return client.request({ url: `api/v1/personal-settings/qualifications`, method: 'GET'
        });
    };
    const getApiV1PersonalSettingsRosters = (params) => {
        return client.request({ url: `api/v1/personal-settings/rosters`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsSameEmailUsers = (params) => {
        return client.request({ url: `api/v1/personal-settings/same-email-users`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsSamePhoneUsers = (params) => {
        return client.request({ url: `api/v1/personal-settings/same-phone-users`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsTrainings = (params) => {
        return client.request({ url: `api/v1/personal-settings/trainings`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsTransfers = (params) => {
        return client.request({ url: `api/v1/personal-settings/transfers`, method: 'GET',
            params
        });
    };
    const getApiV1PersonalSettingsUserImage = () => {
        return client.request({ url: `api/v1/personal-settings/user/image`, method: 'GET'
        });
    };
    const putApiV1PersonalSettingsUser = (userUpdateRequest) => {
        return client.request({ url: `api/v1/personal-settings/user`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: userUpdateRequest
        });
    };
    const getApiV1PersonalSettingsUsersOnDevice = (params) => {
        return client.request({ url: `api/v1/personal-settings/users-on-device`, method: 'GET',
            params
        });
    };
    const getApiV1PhotoImageId = (id) => {
        return client.request({ url: `api/v1/photo/image/${id}`, method: 'GET'
        });
    };
    const getApiV1PhotoUserUserIdImage = (userId) => {
        return client.request({ url: `api/v1/photo/user/${userId}/image`, method: 'GET'
        });
    };
    const putApiV1PhotoUserUserId = (userId, photoUpdateRequest) => {
        const formData = new FormData();
        formData.append('userId', photoUpdateRequest.userId);
        if (photoUpdateRequest.description !== undefined && photoUpdateRequest.description !== null) {
            formData.append('description', photoUpdateRequest.description);
        }
        if (photoUpdateRequest.photo !== undefined && photoUpdateRequest.photo !== null) {
            formData.append('photo', photoUpdateRequest.photo);
        }
        return client.request({ url: `api/v1/photo/user/${userId}`, method: 'PUT',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1PhotoUserId = (id) => {
        return client.request({ url: `api/v1/photo/user/${id}`, method: 'GET'
        });
    };
    const getApiV1PhotoId = (id) => {
        return client.request({ url: `api/v1/photo/${id}`, method: 'GET'
        });
    };
    const putApiV1PhotoId = (id, photoUpdateRequest) => {
        const formData = new FormData();
        formData.append('userId', photoUpdateRequest.userId);
        if (photoUpdateRequest.description !== undefined && photoUpdateRequest.description !== null) {
            formData.append('description', photoUpdateRequest.description);
        }
        if (photoUpdateRequest.photo !== undefined && photoUpdateRequest.photo !== null) {
            formData.append('photo', photoUpdateRequest.photo);
        }
        return client.request({ url: `api/v1/photo/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1PhotoUserId = (userId) => {
        return client.request({ url: `api/v1/photo/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1Photo = (params) => {
        return client.request({ url: `api/v1/photo`, method: 'GET',
            params
        });
    };
    const postApiV1Photo = (photoRequest) => {
        const formData = new FormData();
        formData.append('userId', photoRequest.userId);
        if (photoRequest.description !== undefined && photoRequest.description !== null) {
            formData.append('description', photoRequest.description);
        }
        formData.append('photo', photoRequest.photo);
        return client.request({ url: `api/v1/photo`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1PlayersImageUserId = (userId) => {
        return client.request({ url: `api/v1/players/image/${userId}`, method: 'GET'
        });
    };
    const getApiV1PlayersList = (params) => {
        return client.request({ url: `api/v1/players/list`, method: 'GET',
            params
        });
    };
    const getApiV1PlayersPlayerId = (playerId) => {
        return client.request({ url: `api/v1/players/${playerId}`, method: 'GET'
        });
    };
    const putApiV1PlayersId = (id, playersUpdateRequest) => {
        const formData = new FormData();
        if (playersUpdateRequest.height !== undefined && playersUpdateRequest.height !== null) {
            formData.append('height', playersUpdateRequest.height);
        }
        if (playersUpdateRequest.position !== undefined && playersUpdateRequest.position !== null) {
            formData.append('position', playersUpdateRequest.position);
        }
        if (playersUpdateRequest.jerseyNumber !== undefined && playersUpdateRequest.jerseyNumber !== null) {
            formData.append('jerseyNumber', playersUpdateRequest.jerseyNumber);
        }
        if (playersUpdateRequest.photo !== undefined && playersUpdateRequest.photo !== null) {
            formData.append('photo', playersUpdateRequest.photo);
        }
        return client.request({ url: `api/v1/players/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1PlayersId = (id) => {
        return client.request({ url: `api/v1/players/${id}`, method: 'DELETE'
        });
    };
    const postApiV1Players = (playersRequest) => {
        const formData = new FormData();
        formData.append('userId', playersRequest.userId);
        if (playersRequest.height !== undefined && playersRequest.height !== null) {
            formData.append('height', playersRequest.height);
        }
        if (playersRequest.position !== undefined && playersRequest.position !== null) {
            formData.append('position', playersRequest.position);
        }
        if (playersRequest.jerseyNumber !== undefined && playersRequest.jerseyNumber !== null) {
            formData.append('jerseyNumber', playersRequest.jerseyNumber);
        }
        if (playersRequest.photo !== undefined && playersRequest.photo !== null) {
            formData.append('photo', playersRequest.photo);
        }
        return client.request({ url: `api/v1/players`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1QualificationBeachTrainerExport = (params) => {
        return client.request({ url: `api/v1/qualification/beach-trainer/export`, method: 'GET',
            params
        });
    };
    const getApiV1QualificationReferee = (params) => {
        return client.request({ url: `api/v1/qualification/referee`, method: 'GET',
            params
        });
    };
    const getApiV1QualificationTrainerExport = (params) => {
        return client.request({ url: `api/v1/qualification/trainer/export`, method: 'GET',
            params
        });
    };
    const getApiV1QualificationTrainer = (params) => {
        return client.request({ url: `api/v1/qualification/trainer`, method: 'GET',
            params
        });
    };
    const getApiV1QualificationUserId = (id) => {
        return client.request({ url: `api/v1/qualification/user/${id}`, method: 'GET'
        });
    };
    const getApiV1QualificationId = (id) => {
        return client.request({ url: `api/v1/qualification/${id}`, method: 'GET'
        });
    };
    const putApiV1QualificationId = (id, qualificationUpdateRequest) => {
        return client.request({ url: `api/v1/qualification/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: qualificationUpdateRequest
        });
    };
    const deleteApiV1QualificationId = (id) => {
        return client.request({ url: `api/v1/qualification/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Qualification = (params) => {
        return client.request({ url: `api/v1/qualification`, method: 'GET',
            params
        });
    };
    const postApiV1Qualification = (qualificationRequest) => {
        return client.request({ url: `api/v1/qualification`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: qualificationRequest
        });
    };
    const postApiV1RefereeAssignDelegates = (assignDelegationRequest, params) => {
        return client.request({ url: `api/v1/referee/assign-delegates`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: assignDelegationRequest,
            params
        });
    };
    const postApiV1RefereeConfirmAttendanceUserId = (userId, refereeConfirmAttendanceRequest) => {
        return client.request({ url: `api/v1/referee/confirm-attendance/${userId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refereeConfirmAttendanceRequest
        });
    };
    const getApiV1RefereeDistanceHallRuianRefereeId = (hallRuian, refereeId, params) => {
        return client.request({ url: `api/v1/referee/distance/${hallRuian}/${refereeId}`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeDuoPreference = (params) => {
        return client.request({ url: `api/v1/referee/duo/preference`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeMatchMatchId = (matchId) => {
        return client.request({ url: `api/v1/referee/match/${matchId}`, method: 'GET'
        });
    };
    const getApiV1RefereeMatchListRefereesMatchIdListId = (matchId, listId) => {
        return client.request({ url: `api/v1/referee/match-list-referees/${matchId}/${listId}`, method: 'GET'
        });
    };
    const getApiV1RefereeMatchesExport = (params) => {
        return client.request({ url: `api/v1/referee/matches/export`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeMatchesToday = (params) => {
        return client.request({ url: `api/v1/referee/matches/today`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeMatches = (params) => {
        return client.request({ url: `api/v1/referee/matches`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeQualificationUserId = (userId) => {
        return client.request({ url: `api/v1/referee/qualification/${userId}`, method: 'GET'
        });
    };
    const getApiV1RefereeRegistry = (params) => {
        return client.request({ url: `api/v1/referee/registry`, method: 'GET',
            params
        });
    };
    const postApiV1RefereeRemoveDelegationDelegationId = (delegationId, params) => {
        return client.request({ url: `api/v1/referee/remove-delegation/${delegationId}`, method: 'POST',
            params
        });
    };
    const putApiV1RefereeSwapMatchId = (matchId, refereeSwapRequest) => {
        return client.request({ url: `api/v1/referee/swap/${matchId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: refereeSwapRequest
        });
    };
    const getApiV1RefereeTrainingUserId = (userId, params) => {
        return client.request({ url: `api/v1/referee/training/${userId}`, method: 'GET',
            params
        });
    };
    const postApiV1RefereeUnavailability = (refereeUnavailabilityRequest, params) => {
        return client.request({ url: `api/v1/referee/unavailability`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refereeUnavailabilityRequest,
            params
        });
    };
    const getApiV1RefereeUserRights = (params) => {
        return client.request({ url: `api/v1/referee/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeWhisper = (params) => {
        return client.request({ url: `api/v1/referee/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeUserIdCalendar = (userId, params) => {
        return client.request({ url: `api/v1/referee/${userId}/calendar`, method: 'GET',
            params
        });
    };
    const getApiV1RefereeUserIdDetail = (userId) => {
        return client.request({ url: `api/v1/referee/${userId}/detail`, method: 'GET'
        });
    };
    const getApiV1RefereeUserIdList = (userId, params) => {
        return client.request({ url: `api/v1/referee/${userId}/list`, method: 'GET',
            params
        });
    };
    const postApiV1RefereeUserIdPreferredColleague = (userId, params) => {
        return client.request({ url: `api/v1/referee/${userId}/preferred-colleague`, method: 'POST',
            params
        });
    };
    const getApiV1RefereeUserIdPreferredColleagues = (userId) => {
        return client.request({ url: `api/v1/referee/${userId}/preferred-colleagues`, method: 'GET'
        });
    };
    const getApiV1RefereeUserId = (userId) => {
        return client.request({ url: `api/v1/referee/${userId}`, method: 'GET'
        });
    };
    const putApiV1RefereeUserId = (userId, refereeUpdateRequest) => {
        return client.request({ url: `api/v1/referee/${userId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: refereeUpdateRequest
        });
    };
    const deleteApiV1RefereeUserId = (userId) => {
        return client.request({ url: `api/v1/referee/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1Referee = (params) => {
        return client.request({ url: `api/v1/referee`, method: 'GET',
            params
        });
    };
    const postApiV1Referee = (refereeRequest) => {
        return client.request({ url: `api/v1/referee`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refereeRequest
        });
    };
    const getApiV1RegistrationLastChanges = () => {
        return client.request({ url: `api/v1/registration/last-changes`, method: 'GET'
        });
    };
    const getApiV1RegistrationStatisticsClub = (params) => {
        return client.request({ url: `api/v1/registration/statistics/club`, method: 'GET',
            params
        });
    };
    const getApiV1RegistrationStatisticsDistrict = (params) => {
        return client.request({ url: `api/v1/registration/statistics/district`, method: 'GET',
            params
        });
    };
    const getApiV1RegistrationStatisticsRegionExport = (params) => {
        return client.request({ url: `api/v1/registration/statistics/region/export`, method: 'GET',
            params
        });
    };
    const getApiV1RegistrationStatisticsRegion = (params) => {
        return client.request({ url: `api/v1/registration/statistics/region`, method: 'GET',
            params
        });
    };
    const getApiV1RegistrationUserId = (userId) => {
        return client.request({ url: `api/v1/registration/${userId}`, method: 'GET'
        });
    };
    const putApiV1Registration = (registrationUpdateRequest) => {
        return client.request({ url: `api/v1/registration`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: registrationUpdateRequest
        });
    };
    const getApiV1RequestAttachmentId = (id) => {
        return client.request({ url: `api/v1/request/attachment/${id}`, method: 'GET'
        });
    };
    const deleteApiV1RequestCancelFollowRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/cancel-follow/${requestId}`, method: 'DELETE'
        });
    };
    const getApiV1RequestCompetitionManagementRequestType = (requestType, params) => {
        return client.request({ url: `api/v1/request/competition-management/${requestType}`, method: 'GET',
            params
        });
    };
    const postApiV1RequestConfirm = (confirmRequest) => {
        return client.request({ url: `api/v1/request/confirm`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: confirmRequest
        });
    };
    const postApiV1RequestConfirmRequest = (requestConfirmationRequest) => {
        return client.request({ url: `api/v1/request/confirm-request`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: requestConfirmationRequest
        });
    };
    const postApiV1RequestConfirmTeam = (requestConfirmationCompetitionRequest) => {
        return client.request({ url: `api/v1/request/confirm-team`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: requestConfirmationCompetitionRequest
        });
    };
    const getApiV1RequestCount = () => {
        return client.request({ url: `api/v1/request/count`, method: 'GET'
        });
    };
    const getApiV1RequestFileContentId = (id) => {
        return client.request({ url: `api/v1/request/file/content/${id}`, method: 'GET'
        });
    };
    const getApiV1RequestFileId = (id) => {
        return client.request({ url: `api/v1/request/file/${id}`, method: 'GET'
        });
    };
    const postApiV1RequestFileId = (id, requestAttachmentUpdateRequest) => {
        const formData = new FormData();
        if (requestAttachmentUpdateRequest.requestId !== undefined && requestAttachmentUpdateRequest.requestId !== null) {
            formData.append('requestId', requestAttachmentUpdateRequest.requestId.toString());
        }
        if (requestAttachmentUpdateRequest.attachment !== undefined && requestAttachmentUpdateRequest.attachment !== null) {
            formData.append('attachment', requestAttachmentUpdateRequest.attachment);
        }
        if (requestAttachmentUpdateRequest.name !== undefined && requestAttachmentUpdateRequest.name !== null) {
            formData.append('name', requestAttachmentUpdateRequest.name);
        }
        if (requestAttachmentUpdateRequest.type !== undefined && requestAttachmentUpdateRequest.type !== null) {
            formData.append('type', requestAttachmentUpdateRequest.type);
        }
        if (requestAttachmentUpdateRequest.size !== undefined && requestAttachmentUpdateRequest.size !== null) {
            formData.append('size', requestAttachmentUpdateRequest.size.toString());
        }
        if (requestAttachmentUpdateRequest.content !== undefined && requestAttachmentUpdateRequest.content !== null) {
            formData.append('content', requestAttachmentUpdateRequest.content);
        }
        if (requestAttachmentUpdateRequest.date !== undefined && requestAttachmentUpdateRequest.date !== null) {
            formData.append('date', requestAttachmentUpdateRequest.date);
        }
        return client.request({ url: `api/v1/request/file/${id}`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1RequestFileId = (id) => {
        return client.request({ url: `api/v1/request/file/${id}`, method: 'DELETE'
        });
    };
    const postApiV1RequestFile = (requestAttachmentRequest) => {
        const formData = new FormData();
        formData.append('requestId', requestAttachmentRequest.requestId.toString());
        formData.append('attachment', requestAttachmentRequest.attachment);
        formData.append('name', requestAttachmentRequest.name);
        formData.append('type', requestAttachmentRequest.type);
        formData.append('size', requestAttachmentRequest.size.toString());
        if (requestAttachmentRequest.content !== undefined && requestAttachmentRequest.content !== null) {
            formData.append('content', requestAttachmentRequest.content);
        }
        if (requestAttachmentRequest.date !== undefined && requestAttachmentRequest.date !== null) {
            formData.append('date', requestAttachmentRequest.date);
        }
        return client.request({ url: `api/v1/request/file`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const postApiV1RequestFollowRequestIdUserId = (requestId, userId) => {
        return client.request({ url: `api/v1/request/follow/${requestId}/${userId}`, method: 'POST'
        });
    };
    const getApiV1RequestFollowersRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/followers/${requestId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormAvailableGroupsCompetitionId = (competitionId) => {
        return client.request({ url: `api/v1/request/form/available-groups/${competitionId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormAvailableNumbersGroupId = (groupId) => {
        return client.request({ url: `api/v1/request/form/available-numbers/${groupId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormBeachCancelApplicationRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/beach/cancel-application/${requestId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormBeachCancelApplicationTournamentIdPairs = (tournamentId) => {
        return client.request({ url: `api/v1/request/form/beach/cancel-application/${tournamentId}/pairs`, method: 'GET'
        });
    };
    const postApiV1RequestFormBeachCancelApplication = (beachCancelTournamentRequest) => {
        return client.request({ url: `api/v1/request/form/beach/cancel-application`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachCancelTournamentRequest
        });
    };
    const getApiV1RequestFormBeachFineRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/beach/fine/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormBeachFine = (beachFineRequest) => {
        return client.request({ url: `api/v1/request/form/beach/fine`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachFineRequest
        });
    };
    const getApiV1RequestFormBeachHostingRequestRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/beach/hosting-request/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormBeachHostingRequest = (formsBeachHostingRequest) => {
        return client.request({ url: `api/v1/request/form/beach/hosting-request`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: formsBeachHostingRequest
        });
    };
    const getApiV1RequestFormBeachTournament = (params) => {
        return client.request({ url: `api/v1/request/form/beach/tournament`, method: 'GET',
            params
        });
    };
    const getApiV1RequestFormBeachTournamentApplicationCheck = (params) => {
        return client.request({ url: `api/v1/request/form/beach/tournament-application/check`, method: 'GET',
            params
        });
    };
    const getApiV1RequestFormBeachTournamentApplicationRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/beach/tournament-application/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormBeachTournamentApplication = (beachTournamentEntryRequest) => {
        return client.request({ url: `api/v1/request/form/beach/tournament-application`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: beachTournamentEntryRequest
        });
    };
    const getApiV1RequestFormCancelHostingRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/cancel-hosting/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormCancelHosting = (cancelHostingRequest) => {
        return client.request({ url: `api/v1/request/form/cancel-hosting`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: cancelHostingRequest
        });
    };
    const getApiV1RequestFormCancelRegistrationRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/cancel-registration/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormCancelRegistration = (cancelRegistrationRequest) => {
        return client.request({ url: `api/v1/request/form/cancel-registration`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: cancelRegistrationRequest
        });
    };
    const postApiV1RequestFormChampionshipApplicationAssignGroup = (championshipApplicationAssignGroupRequest, params) => {
        return client.request({ url: `api/v1/request/form/championship-application/assign-group`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: championshipApplicationAssignGroupRequest,
            params
        });
    };
    const getApiV1RequestFormChampionshipApplicationRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/championship-application/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormChampionshipApplication = (championshipApplicationRequest) => {
        return client.request({ url: `api/v1/request/form/championship-application`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: championshipApplicationRequest
        });
    };
    const getApiV1RequestFormChangeHallRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/change-hall/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormChangeHall = (changeHallRequest) => {
        return client.request({ url: `api/v1/request/form/change-hall`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: changeHallRequest
        });
    };
    const getApiV1RequestFormChangeInfoRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/change-info/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormChangeInfo = (changePersonalInfoRequest) => {
        return client.request({ url: `api/v1/request/form/change-info`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: changePersonalInfoRequest
        });
    };
    const getApiV1RequestFormChangeMatchDateRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/change-match-date/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormChangeMatchDate = (changeMatchDateRequest) => {
        return client.request({ url: `api/v1/request/form/change-match-date`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: changeMatchDateRequest
        });
    };
    const getApiV1RequestFormChangePhotoRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/change-photo/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormChangePhoto = (changePhotoRequest) => {
        const formData = new FormData();
        formData.append('userId', changePhotoRequest.userId);
        formData.append('photo', changePhotoRequest.photo);
        return client.request({ url: `api/v1/request/form/change-photo`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1RequestFormChangeTournamentDateRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/change-tournament-date/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormChangeTournamentDate = (changeTournamentDateRequest) => {
        return client.request({ url: `api/v1/request/form/change-tournament-date`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: changeTournamentDateRequest
        });
    };
    const getApiV1RequestFormCompetitionCodes = () => {
        return client.request({ url: `api/v1/request/form/competition-codes`, method: 'GET'
        });
    };
    const getApiV1RequestFormExtendCardRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/extend-card/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormExtendCard = (extendCardValidityRequest) => {
        return client.request({ url: `api/v1/request/form/extend-card`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: extendCardValidityRequest
        });
    };
    const getApiV1RequestFormExtendHostingRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/extend-hosting/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormExtendHosting = (extendHostingRequest) => {
        return client.request({ url: `api/v1/request/form/extend-hosting`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: extendHostingRequest
        });
    };
    const getApiV1RequestFormFineRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/fine/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormFine = (fineRequest) => {
        return client.request({ url: `api/v1/request/form/fine`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: fineRequest
        });
    };
    const getApiV1RequestFormHallsTeamId = (teamId) => {
        return client.request({ url: `api/v1/request/form/halls/${teamId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormMatchesGroupIdTeamId = (groupId, teamId) => {
        return client.request({ url: `api/v1/request/form/matches/${groupId}/${teamId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormMemberRegistrationRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/member-registration/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormMemberRegistration = (memberRegistrationRequest) => {
        const formData = new FormData();
        if (memberRegistrationRequest.prefixTitle !== undefined && memberRegistrationRequest.prefixTitle !== null) {
            formData.append('prefixTitle', memberRegistrationRequest.prefixTitle);
        }
        formData.append('firstName', memberRegistrationRequest.firstName);
        formData.append('lastName', memberRegistrationRequest.lastName);
        if (memberRegistrationRequest.suffixTitle !== undefined && memberRegistrationRequest.suffixTitle !== null) {
            formData.append('suffixTitle', memberRegistrationRequest.suffixTitle);
        }
        if (memberRegistrationRequest.maidenName !== undefined && memberRegistrationRequest.maidenName !== null) {
            formData.append('maidenName', memberRegistrationRequest.maidenName);
        }
        formData.append('gender', memberRegistrationRequest.gender);
        if (memberRegistrationRequest.birthCertificateNumber !== undefined && memberRegistrationRequest.birthCertificateNumber !== null) {
            formData.append('birthCertificateNumber', memberRegistrationRequest.birthCertificateNumber);
        }
        formData.append('dateOfBirth', memberRegistrationRequest.dateOfBirth);
        formData.append('foreigner', memberRegistrationRequest.foreigner);
        formData.append('nationality', memberRegistrationRequest.nationality);
        formData.append('unionNationality', memberRegistrationRequest.unionNationality);
        formData.append('ruian', memberRegistrationRequest.ruian);
        if (memberRegistrationRequest.phoneNumber !== undefined && memberRegistrationRequest.phoneNumber !== null) {
            formData.append('phoneNumber', memberRegistrationRequest.phoneNumber);
        }
        if (memberRegistrationRequest.email !== undefined && memberRegistrationRequest.email !== null) {
            formData.append('email', memberRegistrationRequest.email);
        }
        formData.append('clubId', memberRegistrationRequest.clubId);
        formData.append('photo', memberRegistrationRequest.photo);
        if (memberRegistrationRequest.print !== undefined && memberRegistrationRequest.print !== null) {
            formData.append('print', memberRegistrationRequest.print);
        }
        if (memberRegistrationRequest.deliveryType !== undefined && memberRegistrationRequest.deliveryType !== null) {
            formData.append('deliveryType', memberRegistrationRequest.deliveryType);
        }
        return client.request({ url: `api/v1/request/form/member-registration`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const getApiV1RequestFormMemberRenewalRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/member-renewal/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormMemberRenewal = (memberRenewalRequest) => {
        return client.request({ url: `api/v1/request/form/member-renewal`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: memberRenewalRequest
        });
    };
    const getApiV1RequestFormMembershipPaymentSeasons = () => {
        return client.request({ url: `api/v1/request/form/membership-payment/seasons`, method: 'GET'
        });
    };
    const getApiV1RequestFormMembershipPaymentUsersIdSeason = (id, season) => {
        return client.request({ url: `api/v1/request/form/membership-payment/users/${id}/${season}`, method: 'GET'
        });
    };
    const getApiV1RequestFormMembershipPaymentRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/membership-payment/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormMembershipPayment = (membershipPaymentRequest) => {
        return client.request({ url: `api/v1/request/form/membership-payment`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: membershipPaymentRequest
        });
    };
    const getApiV1RequestFormNewCardRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/new-card/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormNewCard = (newCardRequest) => {
        return client.request({ url: `api/v1/request/form/new-card`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: newCardRequest
        });
    };
    const getApiV1RequestFormRegionalApplicationRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/regional-application/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormRegionalApplication = (regionalApplicationRequest) => {
        return client.request({ url: `api/v1/request/form/regional-application`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: regionalApplicationRequest
        });
    };
    const getApiV1RequestFormReportHostingRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/report-hosting/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormReportHosting = (reportHostingRequest) => {
        return client.request({ url: `api/v1/request/form/report-hosting`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: reportHostingRequest
        });
    };
    const getApiV1RequestFormReportTransferRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/report-transfer/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormReportTransfer = (reportTransferRequest) => {
        return client.request({ url: `api/v1/request/form/report-transfer`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: reportTransferRequest
        });
    };
    const getApiV1RequestFormSubstituteHallRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/substitute-hall/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormSubstituteHall = (substituteHallRequest) => {
        return client.request({ url: `api/v1/request/form/substitute-hall`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: substituteHallRequest
        });
    };
    const getApiV1RequestFormTeamsGroupId = (groupId) => {
        return client.request({ url: `api/v1/request/form/teams/${groupId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormTeamsForTransferUserId = (userId) => {
        return client.request({ url: `api/v1/request/form/teams-for-transfer/${userId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormTeamsToExcludeUserId = (userId) => {
        return client.request({ url: `api/v1/request/form/teams-to-exclude/${userId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormToleranceGroupId = (groupId) => {
        return client.request({ url: `api/v1/request/form/tolerance/${groupId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormTournamentsGroupId = (groupId) => {
        return client.request({ url: `api/v1/request/form/tournaments/${groupId}`, method: 'GET'
        });
    };
    const getApiV1RequestFormTransferToAnotherTeamRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/form/transfer-to-another-team/${requestId}`, method: 'GET'
        });
    };
    const postApiV1RequestFormTransferToAnotherTeam = (transferToAnotherTeamRequest) => {
        return client.request({ url: `api/v1/request/form/transfer-to-another-team`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: transferToAnotherTeamRequest
        });
    };
    const getApiV1RequestGetTypeRequestId = (requestId) => {
        return client.request({ url: `api/v1/request/get-type/${requestId}`, method: 'GET'
        });
    };
    const getApiV1RequestList = (params) => {
        return client.request({ url: `api/v1/request/list`, method: 'GET',
            params
        });
    };
    const getApiV1RequestLogoId = (id) => {
        return client.request({ url: `api/v1/request/logo/${id}`, method: 'GET'
        });
    };
    const getApiV1RequestMyRequests = () => {
        return client.request({ url: `api/v1/request/my-requests`, method: 'GET'
        });
    };
    const getApiV1RequestPersonId = (id) => {
        return client.request({ url: `api/v1/request/person/${id}`, method: 'GET'
        });
    };
    const putApiV1RequestPersonId = (id, requestUserUpdateRequest) => {
        return client.request({ url: `api/v1/request/person/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: requestUserUpdateRequest
        });
    };
    const postApiV1RequestPerson = (requestUserRequest) => {
        return client.request({ url: `api/v1/request/person`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: requestUserRequest
        });
    };
    const postApiV1RequestRefund = (refundRequest) => {
        return client.request({ url: `api/v1/request/refund`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: refundRequest
        });
    };
    const getApiV1RequestTypesList = () => {
        return client.request({ url: `api/v1/request/types/list`, method: 'GET'
        });
    };
    const getApiV1RequestTypes = () => {
        return client.request({ url: `api/v1/request/types`, method: 'GET'
        });
    };
    const getApiV1RequestUserRights = (params) => {
        return client.request({ url: `api/v1/request/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1RequestWhisper = (params) => {
        return client.request({ url: `api/v1/request/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1RequestIdFile = (id) => {
        return client.request({ url: `api/v1/request/${id}/file`, method: 'GET'
        });
    };
    const getApiV1RequestIdLimited = (id) => {
        return client.request({ url: `api/v1/request/${id}/limited`, method: 'GET'
        });
    };
    const deleteApiV1RequestIdPersonPersonId = (id, personId) => {
        return client.request({ url: `api/v1/request/${id}/person/${personId}`, method: 'DELETE'
        });
    };
    const getApiV1RequestIdPerson = (id) => {
        return client.request({ url: `api/v1/request/${id}/person`, method: 'GET'
        });
    };
    const getApiV1RequestId = (id) => {
        return client.request({ url: `api/v1/request/${id}`, method: 'GET'
        });
    };
    const postApiV1RequestId = (id, requestUpdateRequest) => {
        const formData = new FormData();
        if (requestUpdateRequest.type !== undefined && requestUpdateRequest.type !== null) {
            formData.append('type', requestUpdateRequest.type.toString());
        }
        if (requestUpdateRequest.name !== undefined && requestUpdateRequest.name !== null) {
            formData.append('name', requestUpdateRequest.name);
        }
        if (requestUpdateRequest.created !== undefined && requestUpdateRequest.created !== null) {
            formData.append('created', requestUpdateRequest.created);
        }
        if (requestUpdateRequest.submitted !== undefined && requestUpdateRequest.submitted !== null) {
            formData.append('submitted', requestUpdateRequest.submitted);
        }
        if (requestUpdateRequest.validity !== undefined && requestUpdateRequest.validity !== null) {
            formData.append('validity', requestUpdateRequest.validity);
        }
        if (requestUpdateRequest.creator !== undefined && requestUpdateRequest.creator !== null) {
            formData.append('creator', requestUpdateRequest.creator.toString());
        }
        if (requestUpdateRequest.cancelled !== undefined && requestUpdateRequest.cancelled !== null) {
            formData.append('cancelled', requestUpdateRequest.cancelled);
        }
        if (requestUpdateRequest.canceller !== undefined && requestUpdateRequest.canceller !== null) {
            formData.append('canceller', requestUpdateRequest.canceller.toString());
        }
        if (requestUpdateRequest.cancelledType !== undefined && requestUpdateRequest.cancelledType !== null) {
            formData.append('cancelledType', requestUpdateRequest.cancelledType.toString());
        }
        if (requestUpdateRequest.cancelledMessage !== undefined && requestUpdateRequest.cancelledMessage !== null) {
            formData.append('cancelledMessage', requestUpdateRequest.cancelledMessage);
        }
        if (requestUpdateRequest.price !== undefined && requestUpdateRequest.price !== null) {
            formData.append('price', requestUpdateRequest.price.toString());
        }
        if (requestUpdateRequest.bill !== undefined && requestUpdateRequest.bill !== null) {
            formData.append('bill', requestUpdateRequest.bill.toString());
        }
        if (requestUpdateRequest.paid !== undefined && requestUpdateRequest.paid !== null) {
            formData.append('paid', requestUpdateRequest.paid);
        }
        if (requestUpdateRequest.implemented !== undefined && requestUpdateRequest.implemented !== null) {
            formData.append('implemented', requestUpdateRequest.implemented.toString());
        }
        if (requestUpdateRequest.closed !== undefined && requestUpdateRequest.closed !== null) {
            formData.append('closed', requestUpdateRequest.closed);
        }
        if (requestUpdateRequest.parameters !== undefined && requestUpdateRequest.parameters !== null) {
            formData.append('parameters', requestUpdateRequest.parameters);
        }
        if (requestUpdateRequest.confirmed1 !== undefined && requestUpdateRequest.confirmed1 !== null) {
            formData.append('confirmed1', requestUpdateRequest.confirmed1.toString());
        }
        if (requestUpdateRequest.cDate1 !== undefined && requestUpdateRequest.cDate1 !== null) {
            formData.append('cDate1', requestUpdateRequest.cDate1);
        }
        if (requestUpdateRequest.cValue1 !== undefined && requestUpdateRequest.cValue1 !== null) {
            formData.append('cValue1', requestUpdateRequest.cValue1);
        }
        if (requestUpdateRequest.confirmed2 !== undefined && requestUpdateRequest.confirmed2 !== null) {
            formData.append('confirmed2', requestUpdateRequest.confirmed2.toString());
        }
        if (requestUpdateRequest.cDate2 !== undefined && requestUpdateRequest.cDate2 !== null) {
            formData.append('cDate2', requestUpdateRequest.cDate2);
        }
        if (requestUpdateRequest.cValue2 !== undefined && requestUpdateRequest.cValue2 !== null) {
            formData.append('cValue2', requestUpdateRequest.cValue2);
        }
        if (requestUpdateRequest.confirmed3 !== undefined && requestUpdateRequest.confirmed3 !== null) {
            formData.append('confirmed3', requestUpdateRequest.confirmed3.toString());
        }
        if (requestUpdateRequest.cDate3 !== undefined && requestUpdateRequest.cDate3 !== null) {
            formData.append('cDate3', requestUpdateRequest.cDate3);
        }
        if (requestUpdateRequest.cValue3 !== undefined && requestUpdateRequest.cValue3 !== null) {
            formData.append('cValue3', requestUpdateRequest.cValue3);
        }
        if (requestUpdateRequest.confirmed4 !== undefined && requestUpdateRequest.confirmed4 !== null) {
            formData.append('confirmed4', requestUpdateRequest.confirmed4.toString());
        }
        if (requestUpdateRequest.cDate4 !== undefined && requestUpdateRequest.cDate4 !== null) {
            formData.append('cDate4', requestUpdateRequest.cDate4);
        }
        if (requestUpdateRequest.cValue4 !== undefined && requestUpdateRequest.cValue4 !== null) {
            formData.append('cValue4', requestUpdateRequest.cValue4);
        }
        if (requestUpdateRequest.confirmed5 !== undefined && requestUpdateRequest.confirmed5 !== null) {
            formData.append('confirmed5', requestUpdateRequest.confirmed5.toString());
        }
        if (requestUpdateRequest.cDate5 !== undefined && requestUpdateRequest.cDate5 !== null) {
            formData.append('cDate5', requestUpdateRequest.cDate5);
        }
        if (requestUpdateRequest.cValue5 !== undefined && requestUpdateRequest.cValue5 !== null) {
            formData.append('cValue5', requestUpdateRequest.cValue5);
        }
        if (requestUpdateRequest.confirmed6 !== undefined && requestUpdateRequest.confirmed6 !== null) {
            formData.append('confirmed6', requestUpdateRequest.confirmed6.toString());
        }
        if (requestUpdateRequest.cDate6 !== undefined && requestUpdateRequest.cDate6 !== null) {
            formData.append('cDate6', requestUpdateRequest.cDate6);
        }
        if (requestUpdateRequest.cValue6 !== undefined && requestUpdateRequest.cValue6 !== null) {
            formData.append('cValue6', requestUpdateRequest.cValue6);
        }
        if (requestUpdateRequest.confirmed7 !== undefined && requestUpdateRequest.confirmed7 !== null) {
            formData.append('confirmed7', requestUpdateRequest.confirmed7.toString());
        }
        if (requestUpdateRequest.cDate7 !== undefined && requestUpdateRequest.cDate7 !== null) {
            formData.append('cDate7', requestUpdateRequest.cDate7);
        }
        if (requestUpdateRequest.cValue7 !== undefined && requestUpdateRequest.cValue7 !== null) {
            formData.append('cValue7', requestUpdateRequest.cValue7);
        }
        if (requestUpdateRequest.confirmed8 !== undefined && requestUpdateRequest.confirmed8 !== null) {
            formData.append('confirmed8', requestUpdateRequest.confirmed8.toString());
        }
        if (requestUpdateRequest.cDate8 !== undefined && requestUpdateRequest.cDate8 !== null) {
            formData.append('cDate8', requestUpdateRequest.cDate8);
        }
        if (requestUpdateRequest.cValue8 !== undefined && requestUpdateRequest.cValue8 !== null) {
            formData.append('cValue8', requestUpdateRequest.cValue8);
        }
        if (requestUpdateRequest.confirmed9 !== undefined && requestUpdateRequest.confirmed9 !== null) {
            formData.append('confirmed9', requestUpdateRequest.confirmed9.toString());
        }
        if (requestUpdateRequest.cDate9 !== undefined && requestUpdateRequest.cDate9 !== null) {
            formData.append('cDate9', requestUpdateRequest.cDate9);
        }
        if (requestUpdateRequest.cValue9 !== undefined && requestUpdateRequest.cValue9 !== null) {
            formData.append('cValue9', requestUpdateRequest.cValue9);
        }
        if (requestUpdateRequest.confirmed10 !== undefined && requestUpdateRequest.confirmed10 !== null) {
            formData.append('confirmed10', requestUpdateRequest.confirmed10.toString());
        }
        if (requestUpdateRequest.cDate10 !== undefined && requestUpdateRequest.cDate10 !== null) {
            formData.append('cDate10', requestUpdateRequest.cDate10);
        }
        if (requestUpdateRequest.cValue10 !== undefined && requestUpdateRequest.cValue10 !== null) {
            formData.append('cValue10', requestUpdateRequest.cValue10);
        }
        if (requestUpdateRequest.confirmed11 !== undefined && requestUpdateRequest.confirmed11 !== null) {
            formData.append('confirmed11', requestUpdateRequest.confirmed11.toString());
        }
        if (requestUpdateRequest.cDate11 !== undefined && requestUpdateRequest.cDate11 !== null) {
            formData.append('cDate11', requestUpdateRequest.cDate11);
        }
        if (requestUpdateRequest.cValue11 !== undefined && requestUpdateRequest.cValue11 !== null) {
            formData.append('cValue11', requestUpdateRequest.cValue11);
        }
        if (requestUpdateRequest.logo !== undefined && requestUpdateRequest.logo !== null) {
            formData.append('logo', requestUpdateRequest.logo);
        }
        if (requestUpdateRequest.version !== undefined && requestUpdateRequest.version !== null) {
            formData.append('version', requestUpdateRequest.version.toString());
        }
        return client.request({ url: `api/v1/request/${id}`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const deleteApiV1RequestId = (id) => {
        return client.request({ url: `api/v1/request/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Request = (params) => {
        return client.request({ url: `api/v1/request`, method: 'GET',
            params
        });
    };
    const postApiV1Request = (requestRequest) => {
        const formData = new FormData();
        formData.append('type', requestRequest.type.toString());
        formData.append('name', requestRequest.name);
        formData.append('created', requestRequest.created);
        if (requestRequest.submitted !== undefined && requestRequest.submitted !== null) {
            formData.append('submitted', requestRequest.submitted);
        }
        if (requestRequest.validity !== undefined && requestRequest.validity !== null) {
            formData.append('validity', requestRequest.validity);
        }
        if (requestRequest.creator !== undefined && requestRequest.creator !== null) {
            formData.append('creator', requestRequest.creator.toString());
        }
        if (requestRequest.cancelled !== undefined && requestRequest.cancelled !== null) {
            formData.append('cancelled', requestRequest.cancelled);
        }
        if (requestRequest.canceller !== undefined && requestRequest.canceller !== null) {
            formData.append('canceller', requestRequest.canceller.toString());
        }
        if (requestRequest.cancelledType !== undefined && requestRequest.cancelledType !== null) {
            formData.append('cancelledType', requestRequest.cancelledType.toString());
        }
        formData.append('cancelledMessage', requestRequest.cancelledMessage);
        formData.append('price', requestRequest.price.toString());
        formData.append('bill', requestRequest.bill.toString());
        formData.append('paid', requestRequest.paid);
        formData.append('implemented', requestRequest.implemented.toString());
        if (requestRequest.closed !== undefined && requestRequest.closed !== null) {
            formData.append('closed', requestRequest.closed);
        }
        formData.append('parameters', requestRequest.parameters);
        formData.append('confirmed1', requestRequest.confirmed1.toString());
        if (requestRequest.cDate1 !== undefined && requestRequest.cDate1 !== null) {
            formData.append('cDate1', requestRequest.cDate1);
        }
        formData.append('cValue1', requestRequest.cValue1);
        formData.append('confirmed2', requestRequest.confirmed2.toString());
        if (requestRequest.cDate2 !== undefined && requestRequest.cDate2 !== null) {
            formData.append('cDate2', requestRequest.cDate2);
        }
        formData.append('cValue2', requestRequest.cValue2);
        formData.append('confirmed3', requestRequest.confirmed3.toString());
        if (requestRequest.cDate3 !== undefined && requestRequest.cDate3 !== null) {
            formData.append('cDate3', requestRequest.cDate3);
        }
        formData.append('cValue3', requestRequest.cValue3);
        formData.append('confirmed4', requestRequest.confirmed4.toString());
        if (requestRequest.cDate4 !== undefined && requestRequest.cDate4 !== null) {
            formData.append('cDate4', requestRequest.cDate4);
        }
        formData.append('cValue4', requestRequest.cValue4);
        formData.append('confirmed5', requestRequest.confirmed5.toString());
        if (requestRequest.cDate5 !== undefined && requestRequest.cDate5 !== null) {
            formData.append('cDate5', requestRequest.cDate5);
        }
        formData.append('cValue5', requestRequest.cValue5);
        formData.append('confirmed6', requestRequest.confirmed6.toString());
        if (requestRequest.cDate6 !== undefined && requestRequest.cDate6 !== null) {
            formData.append('cDate6', requestRequest.cDate6);
        }
        formData.append('cValue6', requestRequest.cValue6);
        formData.append('confirmed7', requestRequest.confirmed7.toString());
        if (requestRequest.cDate7 !== undefined && requestRequest.cDate7 !== null) {
            formData.append('cDate7', requestRequest.cDate7);
        }
        formData.append('cValue7', requestRequest.cValue7);
        formData.append('confirmed8', requestRequest.confirmed8.toString());
        if (requestRequest.cDate8 !== undefined && requestRequest.cDate8 !== null) {
            formData.append('cDate8', requestRequest.cDate8);
        }
        formData.append('cValue8', requestRequest.cValue8);
        formData.append('confirmed9', requestRequest.confirmed9.toString());
        if (requestRequest.cDate9 !== undefined && requestRequest.cDate9 !== null) {
            formData.append('cDate9', requestRequest.cDate9);
        }
        formData.append('cValue9', requestRequest.cValue9);
        formData.append('confirmed10', requestRequest.confirmed10.toString());
        if (requestRequest.cDate10 !== undefined && requestRequest.cDate10 !== null) {
            formData.append('cDate10', requestRequest.cDate10);
        }
        formData.append('cValue10', requestRequest.cValue10);
        formData.append('confirmed11', requestRequest.confirmed11.toString());
        if (requestRequest.cDate11 !== undefined && requestRequest.cDate11 !== null) {
            formData.append('cDate11', requestRequest.cDate11);
        }
        formData.append('cValue11', requestRequest.cValue11);
        if (requestRequest.logo !== undefined && requestRequest.logo !== null) {
            formData.append('logo', requestRequest.logo);
        }
        formData.append('version', requestRequest.version.toString());
        return client.request({ url: `api/v1/request`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const postApiV1RightsAddModuleRightsModule = (module, params) => {
        return client.request({ url: `api/v1/rights/add-module-rights/${module}`, method: 'POST',
            params
        });
    };
    const putApiV1RightsEditModuleRightsModule = (module, params) => {
        return client.request({ url: `api/v1/rights/edit-module-rights/${module}`, method: 'PUT',
            params
        });
    };
    const getApiV1RightsModuleRightsItemListModule = (module, params) => {
        return client.request({ url: `api/v1/rights/module-rights-item-list/${module}`, method: 'GET',
            params
        });
    };
    const getApiV1RightsModuleRightsListModule = (module, params) => {
        return client.request({ url: `api/v1/rights/module-rights-list/${module}`, method: 'GET',
            params
        });
    };
    const getApiV1RightsModules = () => {
        return client.request({ url: `api/v1/rights/modules`, method: 'GET'
        });
    };
    const getApiV1RightsMpRegions = () => {
        return client.request({ url: `api/v1/rights/mp/regions`, method: 'GET'
        });
    };
    const getApiV1RightsMpRegionIdDistricts = (regionId) => {
        return client.request({ url: `api/v1/rights/mp/${regionId}/districts`, method: 'GET'
        });
    };
    const deleteApiV1RightsRemoveModuleRightsModule = (module, params) => {
        return client.request({ url: `api/v1/rights/remove-module-rights/${module}`, method: 'DELETE',
            params
        });
    };
    const getApiV1RosterCompetitionCompetitionIdDetail = (competitionId, params) => {
        return client.request({ url: `api/v1/roster/competition/${competitionId}/detail`, method: 'GET',
            params
        });
    };
    const getApiV1RosterCompetitionsTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/roster/competitions/${teamId}`, method: 'GET',
            params
        });
    };
    const getApiV1RosterFunctionariesTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/roster/functionaries/${teamId}`, method: 'GET',
            params
        });
    };
    const getApiV1RosterHistoryTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/roster/history/${teamId}`, method: 'GET',
            params
        });
    };
    const getApiV1RosterManaged = () => {
        return client.request({ url: `api/v1/roster/managed`, method: 'GET'
        });
    };
    const getApiV1RosterMatchesToday = () => {
        return client.request({ url: `api/v1/roster/matches-today`, method: 'GET'
        });
    };
    const getApiV1RosterMyRosters = (params) => {
        return client.request({ url: `api/v1/roster/my-rosters`, method: 'GET',
            params
        });
    };
    const getApiV1RosterMyRostersOld = (params) => {
        return client.request({ url: `api/v1/roster/my-rosters-old`, method: 'GET',
            params
        });
    };
    const putApiV1RosterPerson = (rosterPersonRequest) => {
        return client.request({ url: `api/v1/roster/person`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: rosterPersonRequest
        });
    };
    const postApiV1RosterPerson = (rosterPersonRequest, params) => {
        return client.request({ url: `api/v1/roster/person`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: rosterPersonRequest,
            params
        });
    };
    const getApiV1RosterPlayersTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/roster/players/${teamId}`, method: 'GET',
            params
        });
    };
    const getApiV1RosterPrintTeamIdCompetitionId = (teamId, competitionId) => {
        return client.request({ url: `api/v1/roster/print/${teamId}/${competitionId}`, method: 'GET'
        });
    };
    const getApiV1RosterStatisticsCategory = (params) => {
        return client.request({ url: `api/v1/roster/statistics/category`, method: 'GET',
            params
        });
    };
    const getApiV1RosterStatisticsClub = (params) => {
        return client.request({ url: `api/v1/roster/statistics/club`, method: 'GET',
            params
        });
    };
    const getApiV1RosterStatisticsCompetition = (params) => {
        return client.request({ url: `api/v1/roster/statistics/competition`, method: 'GET',
            params
        });
    };
    const getApiV1RosterStatisticsComplete = () => {
        return client.request({ url: `api/v1/roster/statistics/complete`, method: 'GET'
        });
    };
    const getApiV1RosterStatisticsLetter = (params) => {
        return client.request({ url: `api/v1/roster/statistics/letter`, method: 'GET',
            params
        });
    };
    const getApiV1RosterStatisticsRegion = () => {
        return client.request({ url: `api/v1/roster/statistics/region`, method: 'GET'
        });
    };
    const getApiV1RosterUserRights = (params) => {
        return client.request({ url: `api/v1/roster/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1RosterVersionsTeamId = (teamId) => {
        return client.request({ url: `api/v1/roster/versions/${teamId}`, method: 'GET'
        });
    };
    const getApiV1RosterId = (id) => {
        return client.request({ url: `api/v1/roster/${id}`, method: 'GET'
        });
    };
    const putApiV1RosterId = (id, rosterUpdateRequest) => {
        return client.request({ url: `api/v1/roster/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: rosterUpdateRequest
        });
    };
    const deleteApiV1RosterId = (id) => {
        return client.request({ url: `api/v1/roster/${id}`, method: 'DELETE'
        });
    };
    const getApiV1RosterTeamIdEditFunctionaries = (teamId, params) => {
        return client.request({ url: `api/v1/roster/${teamId}/edit/functionaries`, method: 'GET',
            params
        });
    };
    const getApiV1RosterTeamIdEditPlayersInvalid = (teamId, params) => {
        return client.request({ url: `api/v1/roster/${teamId}/edit/players/invalid`, method: 'GET',
            params
        });
    };
    const getApiV1RosterTeamIdEditPlayersValid = (teamId, params) => {
        return client.request({ url: `api/v1/roster/${teamId}/edit/players/valid`, method: 'GET',
            params
        });
    };
    const getApiV1RosterTeamIdEditPlayers = (teamId, params) => {
        return client.request({ url: `api/v1/roster/${teamId}/edit/players`, method: 'GET',
            params
        });
    };
    const deleteApiV1RosterTeamIdEditRemoveFunctionaryUserId = (teamId, userId) => {
        return client.request({ url: `api/v1/roster/${teamId}/edit/remove/functionary/${userId}`, method: 'DELETE'
        });
    };
    const deleteApiV1RosterTeamIdEditRemovePlayerUserId = (teamId, userId) => {
        return client.request({ url: `api/v1/roster/${teamId}/edit/remove/player/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1Roster = (params) => {
        return client.request({ url: `api/v1/roster`, method: 'GET',
            params
        });
    };
    const postApiV1Roster = (rosterRequest) => {
        return client.request({ url: `api/v1/roster`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: rosterRequest
        });
    };
    const getApiV1RuianCityId = (id) => {
        return client.request({ url: `api/v1/ruian/city/${id}`, method: 'GET'
        });
    };
    const getApiV1RuianCity = (params) => {
        return client.request({ url: `api/v1/ruian/city`, method: 'GET',
            params
        });
    };
    const getApiV1RuianCountryWhisper = (params) => {
        return client.request({ url: `api/v1/ruian/country/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1RuianCountryId = (id) => {
        return client.request({ url: `api/v1/ruian/country/${id}`, method: 'GET'
        });
    };
    const getApiV1RuianCountry = (params) => {
        return client.request({ url: `api/v1/ruian/country`, method: 'GET',
            params
        });
    };
    const getApiV1RuianCountrySearch = (params) => {
        return client.request({ url: `api/v1/ruian/country-search`, method: 'GET',
            params
        });
    };
    const getApiV1RuianDistanceRuianId1RuianId2 = (ruianId1, ruianId2) => {
        return client.request({ url: `api/v1/ruian/distance/${ruianId1}/${ruianId2}`, method: 'GET'
        });
    };
    const getApiV1RuianDistrictId = (id) => {
        return client.request({ url: `api/v1/ruian/district/${id}`, method: 'GET'
        });
    };
    const getApiV1RuianDistrict = (params) => {
        return client.request({ url: `api/v1/ruian/district`, method: 'GET',
            params
        });
    };
    const getApiV1RuianHallTown = (town) => {
        return client.request({ url: `api/v1/ruian/hall/${town}`, method: 'GET'
        });
    };
    const getApiV1RuianHouseStreetCode = (street, code) => {
        return client.request({ url: `api/v1/ruian/house/${street}/${code}`, method: 'GET'
        });
    };
    const getApiV1RuianRegionIdTown = (id, params) => {
        return client.request({ url: `api/v1/ruian/region/${id}/town`, method: 'GET',
            params
        });
    };
    const getApiV1RuianRegionId = (id) => {
        return client.request({ url: `api/v1/ruian/region/${id}`, method: 'GET'
        });
    };
    const getApiV1RuianRegion = (params) => {
        return client.request({ url: `api/v1/ruian/region`, method: 'GET',
            params
        });
    };
    const getApiV1RuianStreetCode = (code) => {
        return client.request({ url: `api/v1/ruian/street/${code}`, method: 'GET'
        });
    };
    const getApiV1RuianTownTownIdSections = (townId) => {
        return client.request({ url: `api/v1/ruian/town/${townId}/sections`, method: 'GET'
        });
    };
    const getApiV1RuianTownpartCode = (code) => {
        return client.request({ url: `api/v1/ruian/townpart/${code}`, method: 'GET'
        });
    };
    const getApiV1RuianWhisper = (params) => {
        return client.request({ url: `api/v1/ruian/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1RuianId = (id) => {
        return client.request({ url: `api/v1/ruian/${id}`, method: 'GET'
        });
    };
    const getApiV1Ruian = (params) => {
        return client.request({ url: `api/v1/ruian`, method: 'GET',
            params
        });
    };
    const getApiV1SettingsUserUserId = (userId) => {
        return client.request({ url: `api/v1/settings/user/${userId}`, method: 'GET'
        });
    };
    const getApiV1SettingsId = (id) => {
        return client.request({ url: `api/v1/settings/${id}`, method: 'GET'
        });
    };
    const putApiV1SettingsId = (id, settingsUpdateRequest) => {
        return client.request({ url: `api/v1/settings/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: settingsUpdateRequest
        });
    };
    const deleteApiV1SettingsId = (id) => {
        return client.request({ url: `api/v1/settings/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Settings = (params) => {
        return client.request({ url: `api/v1/settings`, method: 'GET',
            params
        });
    };
    const postApiV1Settings = (settingsRequest) => {
        return client.request({ url: `api/v1/settings`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: settingsRequest
        });
    };
    const getApiV1SignpostAffiliationHistoryUserId = (userId) => {
        return client.request({ url: `api/v1/signpost/affiliation/history/${userId}`, method: 'GET'
        });
    };
    const getApiV1SignpostAffiliationUserId = (userId) => {
        return client.request({ url: `api/v1/signpost/affiliation/${userId}`, method: 'GET'
        });
    };
    const getApiV1SignpostClubs = () => {
        return client.request({ url: `api/v1/signpost/clubs`, method: 'GET'
        });
    };
    const getApiV1SignpostModules = () => {
        return client.request({ url: `api/v1/signpost/modules`, method: 'GET'
        });
    };
    const getApiV1SignpostPlayers = (params) => {
        return client.request({ url: `api/v1/signpost/players`, method: 'GET',
            params
        });
    };
    const getApiV1SmsGraph = () => {
        return client.request({ url: `api/v1/sms/graph`, method: 'GET'
        });
    };
    const getApiV1SmsPackage = () => {
        return client.request({ url: `api/v1/sms/package`, method: 'GET'
        });
    };
    const postApiV1SmsSend = (smsRequest) => {
        return client.request({ url: `api/v1/sms/send`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: smsRequest
        });
    };
    const getApiV1Sms = (params) => {
        return client.request({ url: `api/v1/sms`, method: 'GET',
            params
        });
    };
    const getApiV1SportsfieldCertificate = (params) => {
        return client.request({ url: `api/v1/sportsfield/certificate`, method: 'GET',
            params
        });
    };
    const getApiV1SportsfieldCities = () => {
        return client.request({ url: `api/v1/sportsfield/cities`, method: 'GET'
        });
    };
    const getApiV1SportsfieldSuggestionId = (id) => {
        return client.request({ url: `api/v1/sportsfield/suggestion/${id}`, method: 'GET'
        });
    };
    const putApiV1SportsfieldSuggestionId = (id, sportsFieldSuggestionUpdateRequest) => {
        return client.request({ url: `api/v1/sportsfield/suggestion/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: sportsFieldSuggestionUpdateRequest
        });
    };
    const deleteApiV1SportsfieldSuggestionId = (id) => {
        return client.request({ url: `api/v1/sportsfield/suggestion/${id}`, method: 'DELETE'
        });
    };
    const getApiV1SportsfieldSuggestion = (params) => {
        return client.request({ url: `api/v1/sportsfield/suggestion`, method: 'GET',
            params
        });
    };
    const postApiV1SportsfieldSuggestion = (sportsFieldSuggestionRequest) => {
        return client.request({ url: `api/v1/sportsfield/suggestion`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: sportsFieldSuggestionRequest
        });
    };
    const getApiV1SportsfieldWhisper = (params) => {
        return client.request({ url: `api/v1/sportsfield/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1SportsfieldId = (id) => {
        return client.request({ url: `api/v1/sportsfield/${id}`, method: 'GET'
        });
    };
    const putApiV1SportsfieldId = (id, sportsFieldUpdateRequest, params) => {
        return client.request({ url: `api/v1/sportsfield/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: sportsFieldUpdateRequest,
            params
        });
    };
    const deleteApiV1SportsfieldId = (id, params) => {
        return client.request({ url: `api/v1/sportsfield/${id}`, method: 'DELETE',
            params
        });
    };
    const getApiV1SportsfieldHallIdSchedule = (hallId, params) => {
        return client.request({ url: `api/v1/sportsfield/${hallId}/schedule`, method: 'GET',
            params
        });
    };
    const getApiV1Sportsfield = (params) => {
        return client.request({ url: `api/v1/sportsfield`, method: 'GET',
            params
        });
    };
    const postApiV1Sportsfield = (sportsFieldRequest) => {
        return client.request({ url: `api/v1/sportsfield`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: sportsFieldRequest
        });
    };
    const postApiV1SuperLinkCheck = (sLTGCheckRequest) => {
        return client.request({ url: `api/v1/super-link/check`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: sLTGCheckRequest
        });
    };
    const getApiV1SuperLinkCompetitionCompetitionId = (competitionId, params) => {
        return client.request({ url: `api/v1/super-link/competition/${competitionId}`, method: 'GET',
            params
        });
    };
    const getApiV1SuperLinkGroupGroupId = (groupId, params) => {
        return client.request({ url: `api/v1/super-link/group/${groupId}`, method: 'GET',
            params
        });
    };
    const postApiV1SuperLinkLink = (sLTGLinkRequest) => {
        return client.request({ url: `api/v1/super-link/link`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: sLTGLinkRequest
        });
    };
    const getApiV1SuperLinkTeamTeamId = (teamId) => {
        return client.request({ url: `api/v1/super-link/team/${teamId}`, method: 'GET'
        });
    };
    const postApiV1SuperRosterAddUser = (sRAddUserRequest) => {
        return client.request({ url: `api/v1/super-roster/add-user`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: sRAddUserRequest
        });
    };
    const getApiV1SuperRosterCompetitionCompetitionId = (competitionId, params) => {
        return client.request({ url: `api/v1/super-roster/competition/${competitionId}`, method: 'GET',
            params
        });
    };
    const deleteApiV1SuperRosterRemoveUserUserId = (userId, params) => {
        return client.request({ url: `api/v1/super-roster/remove-user/${userId}`, method: 'DELETE',
            params
        });
    };
    const getApiV1SuperRosterTeamTeamId = (teamId) => {
        return client.request({ url: `api/v1/super-roster/team/${teamId}`, method: 'GET'
        });
    };
    const getApiV1SuperRosterUserEditUserId = (userId, params) => {
        return client.request({ url: `api/v1/super-roster/user-edit/${userId}`, method: 'GET',
            params
        });
    };
    const putApiV1SuperRosterUserEdit = (sRUserEditRequest) => {
        return client.request({ url: `api/v1/super-roster/user-edit`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: sRUserEditRequest
        });
    };
    const getApiV1SuperRosterUserRosterUserId = (userId, params) => {
        return client.request({ url: `api/v1/super-roster/user-roster/${userId}`, method: 'GET',
            params
        });
    };
    const getApiV1SurveyAnswerId = (id) => {
        return client.request({ url: `api/v1/survey/answer/${id}`, method: 'GET'
        });
    };
    const putApiV1SurveyAnswerId = (id, surveyAnswerUpdateRequest) => {
        return client.request({ url: `api/v1/survey/answer/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: surveyAnswerUpdateRequest
        });
    };
    const deleteApiV1SurveyAnswerId = (id) => {
        return client.request({ url: `api/v1/survey/answer/${id}`, method: 'DELETE'
        });
    };
    const getApiV1SurveyAnswer = (params) => {
        return client.request({ url: `api/v1/survey/answer`, method: 'GET',
            params
        });
    };
    const postApiV1SurveyAnswer = (surveyAnswerRequest) => {
        return client.request({ url: `api/v1/survey/answer`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: surveyAnswerRequest
        });
    };
    const getApiV1SurveyArchive = (params) => {
        return client.request({ url: `api/v1/survey/archive`, method: 'GET',
            params
        });
    };
    const putApiV1SurveyQuestionSurveyQuestionIdChangeAnswerText = (surveyQuestionId, surveyAnswerTextUpdateRequest, params) => {
        return client.request({ url: `api/v1/survey/question/${surveyQuestionId}/change-answer-text`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: surveyAnswerTextUpdateRequest,
            params
        });
    };
    const postApiV1SurveyQuestionSurveyQuestionIdMergeAnswers = (surveyQuestionId, surveySubmittedAnswerCollection, params) => {
        return client.request({ url: `api/v1/survey/question/${surveyQuestionId}/merge-answers`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: surveySubmittedAnswerCollection,
            params
        });
    };
    const getApiV1SurveyQuestionSurveyQuestionId = (surveyQuestionId, params) => {
        return client.request({ url: `api/v1/survey/question/${surveyQuestionId}`, method: 'GET',
            params
        });
    };
    const putApiV1SurveyQuestionSurveyQuestionId = (surveyQuestionId, surveyQuestionUpdateRequest, params) => {
        return client.request({ url: `api/v1/survey/question/${surveyQuestionId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: surveyQuestionUpdateRequest,
            params
        });
    };
    const deleteApiV1SurveyQuestionSurveyQuestionId = (surveyQuestionId, params) => {
        return client.request({ url: `api/v1/survey/question/${surveyQuestionId}`, method: 'DELETE',
            params
        });
    };
    const getApiV1SurveyQuestion = (params) => {
        return client.request({ url: `api/v1/survey/question`, method: 'GET',
            params
        });
    };
    const postApiV1SurveyQuestion = (surveyQuestionRequest) => {
        return client.request({ url: `api/v1/survey/question`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: surveyQuestionRequest
        });
    };
    const getApiV1SurveyRelevant = (params) => {
        return client.request({ url: `api/v1/survey/relevant`, method: 'GET',
            params
        });
    };
    const getApiV1SurveySurveyIdDetail = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/detail`, method: 'GET'
        });
    };
    const getApiV1SurveySurveyIdExport = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/export`, method: 'GET'
        });
    };
    const postApiV1SurveySurveyIdMembersUserId = (surveyId, userId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/members/${userId}`, method: 'POST'
        });
    };
    const deleteApiV1SurveySurveyIdMembersUserId = (surveyId, userId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/members/${userId}`, method: 'DELETE'
        });
    };
    const getApiV1SurveySurveyIdMembers = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/members`, method: 'GET'
        });
    };
    const putApiV1SurveySurveyIdMembers = (surveyId, surveyMemberUpdateCollection) => {
        return client.request({ url: `api/v1/survey/${surveyId}/members`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: surveyMemberUpdateCollection
        });
    };
    const postApiV1SurveySurveyIdNotify = (surveyId, surveyNotificationRequest) => {
        return client.request({ url: `api/v1/survey/${surveyId}/notify`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: surveyNotificationRequest
        });
    };
    const getApiV1SurveySurveyIdPdf = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/pdf`, method: 'GET'
        });
    };
    const getApiV1SurveySurveyIdQuestion = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/question`, method: 'GET'
        });
    };
    const getApiV1SurveySurveyIdResults = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}/results`, method: 'GET'
        });
    };
    const postApiV1SurveySurveyIdSubmit = (surveyId, surveySubmittedQuestionCollection) => {
        return client.request({ url: `api/v1/survey/${surveyId}/submit`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: surveySubmittedQuestionCollection
        });
    };
    const getApiV1SurveySurveyId = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}`, method: 'GET'
        });
    };
    const putApiV1SurveySurveyId = (surveyId, surveyUpdateRequest) => {
        return client.request({ url: `api/v1/survey/${surveyId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: surveyUpdateRequest
        });
    };
    const deleteApiV1SurveySurveyId = (surveyId) => {
        return client.request({ url: `api/v1/survey/${surveyId}`, method: 'DELETE'
        });
    };
    const getApiV1Survey = (params) => {
        return client.request({ url: `api/v1/survey`, method: 'GET',
            params
        });
    };
    const postApiV1Survey = (surveyRequest) => {
        return client.request({ url: `api/v1/survey`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: surveyRequest
        });
    };
    const postApiV1TeamAddTeamGroupId = (groupId, teamAddRequest) => {
        return client.request({ url: `api/v1/team/add-team/${groupId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: teamAddRequest
        });
    };
    const getApiV1TeamClubId = (id) => {
        return client.request({ url: `api/v1/team/club/${id}`, method: 'GET'
        });
    };
    const getApiV1TeamCompetition = (params) => {
        return client.request({ url: `api/v1/team/competition`, method: 'GET',
            params
        });
    };
    const getApiV1TeamCompetitionTeamsGroupId = (groupId) => {
        return client.request({ url: `api/v1/team/competition-teams/${groupId}`, method: 'GET'
        });
    };
    const postApiV1TeamCreateNewTeamGroupId = (groupId, teamCreateRequest) => {
        return client.request({ url: `api/v1/team/create-new-team/${groupId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: teamCreateRequest
        });
    };
    const getApiV1TeamGroupGroupIdCompetition = (groupId) => {
        return client.request({ url: `api/v1/team/group/${groupId}/competition`, method: 'GET'
        });
    };
    const getApiV1TeamGroupGroupIdExportPdf = (groupId, params) => {
        return client.request({ url: `api/v1/team/group/${groupId}/export/pdf`, method: 'GET',
            params
        });
    };
    const getApiV1TeamGroupGroupId = (groupId, params) => {
        return client.request({ url: `api/v1/team/group/${groupId}`, method: 'GET',
            params
        });
    };
    const getApiV1TeamNumbersGroupId = (groupId) => {
        return client.request({ url: `api/v1/team/numbers/${groupId}`, method: 'GET'
        });
    };
    const getApiV1TeamOtherCompetitionTeamsGroupId = (groupId) => {
        return client.request({ url: `api/v1/team/other-competition-teams/${groupId}`, method: 'GET'
        });
    };
    const getApiV1TeamTeamIdAvailableLetters = (teamId, params) => {
        return client.request({ url: `api/v1/team/${teamId}/available-letters`, method: 'GET',
            params
        });
    };
    const deleteApiV1TeamTeamIdGroupGroupId = (teamId, groupId) => {
        return client.request({ url: `api/v1/team/${teamId}/group/${groupId}`, method: 'DELETE'
        });
    };
    const putApiV1TeamTeamIdGroup = (teamId, teamGroupRequest) => {
        return client.request({ url: `api/v1/team/${teamId}/group`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: teamGroupRequest
        });
    };
    const deleteApiV1TeamTeamIdHallHallId = (teamId, hallId, params) => {
        return client.request({ url: `api/v1/team/${teamId}/hall/${hallId}`, method: 'DELETE',
            params
        });
    };
    const getApiV1TeamTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/team/${teamId}`, method: 'GET',
            params
        });
    };
    const putApiV1TeamTeamId = (teamId, teamUpdateRequest, params) => {
        return client.request({ url: `api/v1/team/${teamId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: teamUpdateRequest,
            params
        });
    };
    const deleteApiV1TeamTeamId = (teamId, params) => {
        return client.request({ url: `api/v1/team/${teamId}`, method: 'DELETE',
            params
        });
    };
    const getApiV1TeamIdGroupGroupId = (id, groupId) => {
        return client.request({ url: `api/v1/team/${id}/group/${groupId}`, method: 'GET'
        });
    };
    const getApiV1TeamIdHall = (id) => {
        return client.request({ url: `api/v1/team/${id}/hall`, method: 'GET'
        });
    };
    const putApiV1TeamIdHall = (id, teamHallRequest, params) => {
        return client.request({ url: `api/v1/team/${id}/hall`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: teamHallRequest,
            params
        });
    };
    const putApiV1TeamGroupIdInitialCondition = (groupId, initialConditionRequest) => {
        return client.request({ url: `api/v1/team/${groupId}/initial-condition`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: initialConditionRequest
        });
    };
    const getApiV1Team = (params) => {
        return client.request({ url: `api/v1/team`, method: 'GET',
            params
        });
    };
    const postApiV1Team = (teamRequest) => {
        return client.request({ url: `api/v1/team`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: teamRequest
        });
    };
    const getApiV1TrainingUserUserId = (userId, params) => {
        return client.request({ url: `api/v1/training/user/${userId}`, method: 'GET',
            params
        });
    };
    const getApiV1TrainingId = (id) => {
        return client.request({ url: `api/v1/training/${id}`, method: 'GET'
        });
    };
    const putApiV1TrainingId = (id, trainingUpdateRequest) => {
        return client.request({ url: `api/v1/training/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: trainingUpdateRequest
        });
    };
    const deleteApiV1TrainingId = (id) => {
        return client.request({ url: `api/v1/training/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Training = (params) => {
        return client.request({ url: `api/v1/training`, method: 'GET',
            params
        });
    };
    const postApiV1Training = (trainingRequest) => {
        return client.request({ url: `api/v1/training`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: trainingRequest
        });
    };
    const putApiV1TransactionKsTransactionId = (transactionId, transactionKsUpdateRequest, params) => {
        return client.request({ url: `api/v1/transaction/ks/${transactionId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: transactionKsUpdateRequest,
            params
        });
    };
    const putApiV1TransactionVsTransactionId = (transactionId, transactionVsUpdateRequest, params) => {
        return client.request({ url: `api/v1/transaction/vs/${transactionId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: transactionVsUpdateRequest,
            params
        });
    };
    const getApiV1TransactionId = (id) => {
        return client.request({ url: `api/v1/transaction/${id}`, method: 'GET'
        });
    };
    const deleteApiV1TransactionId = (id) => {
        return client.request({ url: `api/v1/transaction/${id}`, method: 'DELETE'
        });
    };
    const getApiV1TransactionTransactionIdDetail = (transactionId, params) => {
        return client.request({ url: `api/v1/transaction/${transactionId}/detail`, method: 'GET',
            params
        });
    };
    const putApiV1TransactionTransactionId = (transactionId, transactionUpdateRequest, params) => {
        return client.request({ url: `api/v1/transaction/${transactionId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: transactionUpdateRequest,
            params
        });
    };
    const getApiV1Transaction = (params) => {
        return client.request({ url: `api/v1/transaction`, method: 'GET',
            params
        });
    };
    const postApiV1Transaction = (transactionRequest) => {
        return client.request({ url: `api/v1/transaction`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: transactionRequest
        });
    };
    const getApiV1TransferCzechPlayersAbroad = (params) => {
        return client.request({ url: `api/v1/transfer/czech-players-abroad`, method: 'GET',
            params
        });
    };
    const getApiV1TransferForeignPlayers = (params) => {
        return client.request({ url: `api/v1/transfer/foreign-players`, method: 'GET',
            params
        });
    };
    const postApiV1TransferFromAbroad = (transferFromAbroadRequest) => {
        return client.request({ url: `api/v1/transfer/from-abroad`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: transferFromAbroadRequest
        });
    };
    const postApiV1TransferHosting = (transferRequest) => {
        return client.request({ url: `api/v1/transfer/hosting`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: transferRequest
        });
    };
    const getApiV1TransferStatisticsRegion = (params) => {
        return client.request({ url: `api/v1/transfer/statistics/region`, method: 'GET',
            params
        });
    };
    const getApiV1TransferStatisticsUser = (params) => {
        return client.request({ url: `api/v1/transfer/statistics/user`, method: 'GET',
            params
        });
    };
    const postApiV1TransferToAbroad = (transferToAbroadRequest) => {
        return client.request({ url: `api/v1/transfer/to-abroad`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: transferToAbroadRequest
        });
    };
    const getApiV1TransferUserId = (id, params) => {
        return client.request({ url: `api/v1/transfer/user/${id}`, method: 'GET',
            params
        });
    };
    const getApiV1TransferUserUserIdRoster = (userId, params) => {
        return client.request({ url: `api/v1/transfer/user/${userId}/roster`, method: 'GET',
            params
        });
    };
    const putApiV1TransferIdEndHosting = (id) => {
        return client.request({ url: `api/v1/transfer/${id}/end-hosting`, method: 'PUT'
        });
    };
    const putApiV1TransferIdEndMembership = (id) => {
        return client.request({ url: `api/v1/transfer/${id}/end-membership`, method: 'PUT'
        });
    };
    const getApiV1TransferId = (id) => {
        return client.request({ url: `api/v1/transfer/${id}`, method: 'GET'
        });
    };
    const putApiV1TransferId = (id, transferUpdateRequest) => {
        return client.request({ url: `api/v1/transfer/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: transferUpdateRequest
        });
    };
    const deleteApiV1TransferId = (id) => {
        return client.request({ url: `api/v1/transfer/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Transfer = (params) => {
        return client.request({ url: `api/v1/transfer`, method: 'GET',
            params
        });
    };
    const postApiV1Transfer = (transferRequest) => {
        return client.request({ url: `api/v1/transfer`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: transferRequest
        });
    };
    const getApiV1UnavailabilitySeasonMatchStatistics = (params) => {
        return client.request({ url: `api/v1/unavailability/season/match/statistics`, method: 'GET',
            params
        });
    };
    const getApiV1UnavailabilitySeasonMatch = (params) => {
        return client.request({ url: `api/v1/unavailability/season/match`, method: 'GET',
            params
        });
    };
    const getApiV1UnavailabilitySeasonStatistics = (params) => {
        return client.request({ url: `api/v1/unavailability/season/statistics`, method: 'GET',
            params
        });
    };
    const getApiV1UnavailabilitySeason = (params) => {
        return client.request({ url: `api/v1/unavailability/season`, method: 'GET',
            params
        });
    };
    const getApiV1UnavailabilityId = (id) => {
        return client.request({ url: `api/v1/unavailability/${id}`, method: 'GET'
        });
    };
    const putApiV1UnavailabilityId = (id, unavailabilityUpdateRequest) => {
        return client.request({ url: `api/v1/unavailability/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: unavailabilityUpdateRequest
        });
    };
    const deleteApiV1UnavailabilityId = (id, params) => {
        return client.request({ url: `api/v1/unavailability/${id}`, method: 'DELETE',
            params
        });
    };
    const getApiV1Unavailability = (params) => {
        return client.request({ url: `api/v1/unavailability`, method: 'GET',
            params
        });
    };
    const postApiV1Unavailability = (unavailabilityRequest) => {
        return client.request({ url: `api/v1/unavailability`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: unavailabilityRequest
        });
    };
    const getApiV1UserAccessUserId = (userId) => {
        return client.request({ url: `api/v1/user/access/${userId}`, method: 'GET'
        });
    };
    const postApiV1UserAccessUserId = (userId, userAccessRequest) => {
        return client.request({ url: `api/v1/user/access/${userId}`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: userAccessRequest
        });
    };
    const getApiV1UserCalendar = (params) => {
        return client.request({ url: `api/v1/user/calendar`, method: 'GET',
            params
        });
    };
    const getApiV1UserMatchMissingPhotoreport = (params) => {
        return client.request({ url: `api/v1/user/match/missing-photoreport`, method: 'GET',
            params
        });
    };
    const getApiV1UserUserRights = (params) => {
        return client.request({ url: `api/v1/user/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1UserWhisperNoClub = (params) => {
        return client.request({ url: `api/v1/user/whisper/no-club`, method: 'GET',
            params
        });
    };
    const getApiV1UserWhisper = (params) => {
        return client.request({ url: `api/v1/user/whisper`, method: 'GET',
            params
        });
    };
    const getApiV1UserId = (id) => {
        return client.request({ url: `api/v1/user/${id}`, method: 'GET'
        });
    };
    const putApiV1UserId = (id, userUpdateRequest) => {
        return client.request({ url: `api/v1/user/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: userUpdateRequest
        });
    };
    const deleteApiV1UserId = (id) => {
        return client.request({ url: `api/v1/user/${id}`, method: 'DELETE'
        });
    };
    const getApiV1UserUserIdClubsMembers = (userId, params) => {
        return client.request({ url: `api/v1/user/${userId}/clubs/members`, method: 'GET',
            params
        });
    };
    const getApiV1User = (params) => {
        return client.request({ url: `api/v1/user`, method: 'GET',
            params
        });
    };
    const postApiV1User = (userRequest) => {
        return client.request({ url: `api/v1/user`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: userRequest
        });
    };
    const getApiV1VotingAnswerId = (id) => {
        return client.request({ url: `api/v1/voting/answer/${id}`, method: 'GET'
        });
    };
    const putApiV1VotingAnswerId = (id, votingAnswerUpdateRequest) => {
        return client.request({ url: `api/v1/voting/answer/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingAnswerUpdateRequest
        });
    };
    const deleteApiV1VotingAnswerId = (id) => {
        return client.request({ url: `api/v1/voting/answer/${id}`, method: 'DELETE'
        });
    };
    const getApiV1VotingAnswer = () => {
        return client.request({ url: `api/v1/voting/answer`, method: 'GET'
        });
    };
    const postApiV1VotingAnswer = (votingAnswerRequestCollection, params) => {
        return client.request({ url: `api/v1/voting/answer`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingAnswerRequestCollection,
            params
        });
    };
    const getApiV1VotingOptionId = (id) => {
        return client.request({ url: `api/v1/voting/option/${id}`, method: 'GET'
        });
    };
    const putApiV1VotingOptionId = (id, votingOptionUpdateRequest) => {
        return client.request({ url: `api/v1/voting/option/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingOptionUpdateRequest
        });
    };
    const deleteApiV1VotingOptionId = (id) => {
        return client.request({ url: `api/v1/voting/option/${id}`, method: 'DELETE'
        });
    };
    const getApiV1VotingOption = (params) => {
        return client.request({ url: `api/v1/voting/option`, method: 'GET',
            params
        });
    };
    const postApiV1VotingOption = (votingOptionRequest) => {
        return client.request({ url: `api/v1/voting/option`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingOptionRequest
        });
    };
    const postApiV1VotingQuestionProgramPoint = (votingQuestionProgramPointRequest, params) => {
        return client.request({ url: `api/v1/voting/question/program-point`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingQuestionProgramPointRequest,
            params
        });
    };
    const getApiV1VotingQuestionId = (id, params) => {
        return client.request({ url: `api/v1/voting/question/${id}`, method: 'GET',
            params
        });
    };
    const putApiV1VotingQuestionVotingQuestionId = (votingQuestionId, votingQuestionUpdateRequest, params) => {
        return client.request({ url: `api/v1/voting/question/${votingQuestionId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingQuestionUpdateRequest,
            params
        });
    };
    const deleteApiV1VotingQuestionVotingQuestionId = (votingQuestionId, params) => {
        return client.request({ url: `api/v1/voting/question/${votingQuestionId}`, method: 'DELETE',
            params
        });
    };
    const postApiV1VotingQuestion = (votingQuestionRequest, params) => {
        return client.request({ url: `api/v1/voting/question`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingQuestionRequest,
            params
        });
    };
    const putApiV1VotingRoomAccessId = (id, votingRoomAccessUpdateRequest) => {
        return client.request({ url: `api/v1/voting/room/access/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingRoomAccessUpdateRequest
        });
    };
    const deleteApiV1VotingRoomAccessId = (id) => {
        return client.request({ url: `api/v1/voting/room/access/${id}`, method: 'DELETE'
        });
    };
    const getApiV1VotingRoomArchive = (params) => {
        return client.request({ url: `api/v1/voting/room/archive`, method: 'GET',
            params
        });
    };
    const getApiV1VotingRoomMyRooms = () => {
        return client.request({ url: `api/v1/voting/room/my-rooms`, method: 'GET'
        });
    };
    const getApiV1VotingRoomRelevant = (params) => {
        return client.request({ url: `api/v1/voting/room/relevant`, method: 'GET',
            params
        });
    };
    const getApiV1VotingRoomVotingRoomIdAccess = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/access`, method: 'GET'
        });
    };
    const postApiV1VotingRoomVotingRoomIdAccess = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/access`, method: 'POST'
        });
    };
    const getApiV1VotingRoomVotingRoomIdActive = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/active`, method: 'GET'
        });
    };
    const postApiV1VotingRoomVotingRoomIdAddMember = (votingRoomId, votingRoomMemberRequest) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/add-member`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingRoomMemberRequest
        });
    };
    const getApiV1VotingRoomVotingRoomIdAttachmentAttachmentId = (votingRoomId, attachmentId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/attachment/${attachmentId}`, method: 'GET'
        });
    };
    const deleteApiV1VotingRoomVotingRoomIdAttachmentAttachmentId = (votingRoomId, attachmentId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/attachment/${attachmentId}`, method: 'DELETE'
        });
    };
    const getApiV1VotingRoomVotingRoomIdAttachment = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/attachment`, method: 'GET'
        });
    };
    const postApiV1VotingRoomVotingRoomIdAttachment = (votingRoomId, votingRoomAttachmentRequest) => {
        const formData = new FormData();
        if (votingRoomAttachmentRequest.file !== undefined && votingRoomAttachmentRequest.file !== null) {
            formData.append('file', votingRoomAttachmentRequest.file);
        }
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/attachment`, method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data', },
            data: formData
        });
    };
    const postApiV1VotingRoomVotingRoomIdCanEnter = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/can-enter`, method: 'POST'
        });
    };
    const postApiV1VotingRoomVotingRoomIdClose = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/close`, method: 'POST'
        });
    };
    const postApiV1VotingRoomVotingRoomIdCopyData = (votingRoomId, votingRoomCopyRequest) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/copy-data`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingRoomCopyRequest
        });
    };
    const getApiV1VotingRoomVotingRoomIdExport = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/export`, method: 'GET'
        });
    };
    const getApiV1VotingRoomVotingRoomIdInvite = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/invite`, method: 'GET'
        });
    };
    const postApiV1VotingRoomVotingRoomIdLock = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/lock`, method: 'POST'
        });
    };
    const putApiV1VotingRoomVotingRoomIdMemberLogAccess = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/member/log-access`, method: 'PUT'
        });
    };
    const getApiV1VotingRoomVotingRoomIdMembers = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/members`, method: 'GET'
        });
    };
    const postApiV1VotingRoomVotingRoomIdOpen = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/open`, method: 'POST'
        });
    };
    const getApiV1VotingRoomVotingRoomIdPdf = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/pdf`, method: 'GET'
        });
    };
    const getApiV1VotingRoomVotingRoomIdProgram = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/program`, method: 'GET'
        });
    };
    const getApiV1VotingRoomVotingRoomIdQuestion = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/question`, method: 'GET'
        });
    };
    const putApiV1VotingRoomVotingRoomIdRemoveMember = (votingRoomId, votingRoomMemberRequest) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/remove-member`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingRoomMemberRequest
        });
    };
    const getApiV1VotingRoomVotingRoomIdResultsQuestionId = (votingRoomId, questionId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/results/${questionId}`, method: 'GET'
        });
    };
    const getApiV1VotingRoomVotingRoomIdResults = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/results`, method: 'GET'
        });
    };
    const postApiV1VotingRoomVotingRoomIdSendInvitations = (votingRoomId, params) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/send-invitations`, method: 'POST',
            params
        });
    };
    const postApiV1VotingRoomVotingRoomIdUnlock = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}/unlock`, method: 'POST'
        });
    };
    const getApiV1VotingRoomVotingRoomId = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}`, method: 'GET'
        });
    };
    const putApiV1VotingRoomVotingRoomId = (votingRoomId, votingRoomUpdateRequest) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingRoomUpdateRequest
        });
    };
    const deleteApiV1VotingRoomVotingRoomId = (votingRoomId) => {
        return client.request({ url: `api/v1/voting/room/${votingRoomId}`, method: 'DELETE'
        });
    };
    const putApiV1VotingRoomQuestionIdEndProgramPoint = (questionId, params) => {
        return client.request({ url: `api/v1/voting/room/${questionId}/end-program-point`, method: 'PUT',
            params
        });
    };
    const putApiV1VotingRoomQuestionIdStartVoting = (questionId, params) => {
        return client.request({ url: `api/v1/voting/room/${questionId}/start-voting`, method: 'PUT',
            params
        });
    };
    const getApiV1VotingRoom = (params) => {
        return client.request({ url: `api/v1/voting/room`, method: 'GET',
            params
        });
    };
    const postApiV1VotingRoom = (votingRoomRequest) => {
        return client.request({ url: `api/v1/voting/room`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingRoomRequest
        });
    };
    const getApiV1VotingUserRights = (params) => {
        return client.request({ url: `api/v1/voting/user-rights`, method: 'GET',
            params
        });
    };
    const getApiV1VotingVoterId = (id) => {
        return client.request({ url: `api/v1/voting/voter/${id}`, method: 'GET'
        });
    };
    const putApiV1VotingVoterId = (id, votingVoterUpdateRequest) => {
        return client.request({ url: `api/v1/voting/voter/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingVoterUpdateRequest
        });
    };
    const deleteApiV1VotingVoterId = (id) => {
        return client.request({ url: `api/v1/voting/voter/${id}`, method: 'DELETE'
        });
    };
    const getApiV1VotingVoter = (params) => {
        return client.request({ url: `api/v1/voting/voter`, method: 'GET',
            params
        });
    };
    const postApiV1VotingVoter = (votingVoterRequest) => {
        return client.request({ url: `api/v1/voting/voter`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingVoterRequest
        });
    };
    const getApiV1VotingId = (id) => {
        return client.request({ url: `api/v1/voting/${id}`, method: 'GET'
        });
    };
    const putApiV1VotingId = (id, votingUpdateRequest) => {
        return client.request({ url: `api/v1/voting/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: votingUpdateRequest
        });
    };
    const deleteApiV1VotingId = (id) => {
        return client.request({ url: `api/v1/voting/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Voting = (params) => {
        return client.request({ url: `api/v1/voting`, method: 'GET',
            params
        });
    };
    const postApiV1Voting = (votingRequest) => {
        return client.request({ url: `api/v1/voting`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: votingRequest
        });
    };
    const getApiV1YoutubeId = (id) => {
        return client.request({ url: `api/v1/youtube/${id}`, method: 'GET'
        });
    };
    const putApiV1YoutubeId = (id, youtubeUpdateRequest) => {
        return client.request({ url: `api/v1/youtube/${id}`, method: 'PUT',
            headers: { 'Content-Type': 'application/json', },
            data: youtubeUpdateRequest
        });
    };
    const deleteApiV1YoutubeId = (id) => {
        return client.request({ url: `api/v1/youtube/${id}`, method: 'DELETE'
        });
    };
    const getApiV1Youtube = (params) => {
        return client.request({ url: `api/v1/youtube`, method: 'GET',
            params
        });
    };
    const postApiV1Youtube = (youtubeRequest) => {
        return client.request({ url: `api/v1/youtube`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: youtubeRequest
        });
    };
    return { getApiV1AddressBookContactUserId, putApiV1AddressBookContactUserId, deleteApiV1AddressBookContactUserId, postApiV1AddressBookContact, getApiV1AddressBookList, getApiV1AddressBookMy, getApiV1AddressBookUserRights, postApiV1AddressBookAddressBookIdAddRights, getApiV1AddressBookAddressBookIdContact, getApiV1AddressBookAddressBookIdExport, getApiV1AddressBookAddressBookId, putApiV1AddressBookAddressBookId, deleteApiV1AddressBookAddressBookId, getApiV1AddressBook, postApiV1AddressBook, postApiV1ApiConfirmPassword, postApiV1ApiCreate, deleteApiV1ApiDeleteId, getApiV1ApiGeneratePassword, getApiV1ApiId, getApiV1Api, getApiV1ArticleGalleryGallery, getApiV1ArticleImageId, getApiV1ArticleSectionId, putApiV1ArticleSectionId, deleteApiV1ArticleSectionId, getApiV1ArticleSection, postApiV1ArticleSection, getApiV1ArticleId, putApiV1ArticleId, deleteApiV1ArticleId, getApiV1Article, postApiV1Article, getApiV1AssociationId, putApiV1AssociationId, deleteApiV1AssociationId, getApiV1Association, postApiV1Association, getApiV1AuthAccess, postApiV1AuthLogin, getApiV1AuthMe, putApiV1AuthPassword, postApiV1AuthRefresh, postApiV1AuthResetConfirm, postApiV1AuthReset, putApiV1AuthUsername, deleteApiV1BankAccountAccountId, postApiV1BankAccount, getApiV1BankAccountsExport, getApiV1BankAccountsStatisticsExport, getApiV1BankAccountsStatistics, getApiV1BankAccountsTypeType, getApiV1BankAccountsAccountIdTransactionsExport, getApiV1BankAccountsAccountIdTransactionsPdf, getApiV1BankAccountsAccountIdTransactions, getApiV1BankAccountsAccountId, getApiV1BankAccounts, getApiV1BankAccountsList, postApiV1BankPayRequest, getApiV1BankPaymentPaymentId, getApiV1BankPayment, getApiV1BankRequestPaymentRequestId, postApiV1BankTransaction, getApiV1BankUserRights, postApiV1BankWithdraw, getApiV1BankIdAccountName, getApiV1BannerFileId, getApiV1BannerId, putApiV1BannerId, deleteApiV1BannerId, getApiV1Banner, postApiV1Banner, getApiV1BeachAbv, getApiV1BeachAgeCategories, getApiV1BeachAllowedFolders, getApiV1BeachApplicationPlayerPlayerIdHistory, postApiV1BeachApplicationSetWildCardRegistrationId, putApiV1BeachApplicationRegistrationId, getApiV1BeachApplicationTournamentIdMainCompetition, getApiV1BeachApplicationTournamentIdQualification, getApiV1BeachApplicationTournamentId, postApiV1BeachApplication, putApiV1BeachAttachmentType, getApiV1BeachCategory, getApiV1BeachConstants, getApiV1BeachDelegationCategoryCategory, deleteApiV1BeachDelegationPenaltyPenaltyId, postApiV1BeachDelegationPenalty, postApiV1BeachDelegationRefereeEmail, putApiV1BeachDelegationRefereeTests, getApiV1BeachDelegationRefereeUserIdTournaments, getApiV1BeachDelegationRefereeUserIdValuation, putApiV1BeachDelegationRefereeUserIdValuation, putApiV1BeachDelegationRefereeUserId, getApiV1BeachDelegationReferee, getApiV1BeachDelegationTournamentTournamentIdReferee, postApiV1BeachDelegationTournamentTournamentIdValuation, postApiV1BeachFolderGivePermission, postApiV1BeachFolderTakePermission, getApiV1BeachFolderTournaments, getApiV1BeachFolderFolderIdPermissionAvailableLevels, getApiV1BeachFolderFolderIdPermission, getApiV1BeachFolderFolderIdSubfolders, getApiV1BeachFolderFolderId, putApiV1BeachFolderFolderId, deleteApiV1BeachFolderFolderId, getApiV1BeachFolder, postApiV1BeachFolder, getApiV1BeachGameMatchId, putApiV1BeachGameMatchId, deleteApiV1BeachGameMatchId, getApiV1BeachGame, postApiV1BeachGame, getApiV1BeachHosting, postApiV1BeachHosting, getApiV1BeachLeaderboardList, getApiV1BeachLeaderboardSettings, getApiV1BeachLeaderboardLeaderboardIdPlayers, putApiV1BeachLeaderboardLeaderboardIdPointsPointsId, deleteApiV1BeachLeaderboardLeaderboardIdPointsPointsId, postApiV1BeachLeaderboardLeaderboardIdPoints, getApiV1BeachLeaderboardLeaderboardId, putApiV1BeachLeaderboardLeaderboardId, getApiV1BeachLeaderboard, postApiV1BeachLeaderboard, getApiV1BeachLeaderboardsRecalculate, getApiV1BeachLeaderboards, getApiV1BeachMyTournamentsCanSignUp, getApiV1BeachMyTournamentsFuture, getApiV1BeachMyTournamentsPlayed, getApiV1BeachPersonIdTest, getApiV1BeachPlayerId, putApiV1BeachPlayerId, deleteApiV1BeachPlayerId, getApiV1BeachPlayerUserIdLeaderboardLeaderboardId, getApiV1BeachPlayerUserIdLeaderboards, getApiV1BeachPlayer, postApiV1BeachPlayer, getApiV1BeachPoints, postApiV1BeachPoints, getApiV1BeachRefereeDelegationListListId, postApiV1BeachRefereeListBulkEmail, postApiV1BeachRefereeListReferee, deleteApiV1BeachRefereeListListIdRefereeUserId, getApiV1BeachRefereeListListId, deleteApiV1BeachRefereeListListId, getApiV1BeachRefereeList, postApiV1BeachRefereeList, getApiV1BeachRefereeMyDelegationUnavailability, postApiV1BeachRefereeMyDelegationUnavailability, putApiV1BeachRefereeMyDelegationDelegationIdConfirm, putApiV1BeachRefereeMyDelegationDelegationIdDecline, deleteApiV1BeachRefereeMyDelegationUnavailabilityIdCancel, getApiV1BeachRefereeMyDelegation, postApiV1BeachRefereePaymentsConfirmPayment, postApiV1BeachRefereePaymentsDeclinePayment, postApiV1BeachRefereePaymentsShowPdf, getApiV1BeachRefereePaymentsTournaments, postApiV1BeachRefereePaymentsTournamentIdCreatePaymentUserId, getApiV1BeachRefereePaymentsTournamentIdOverview, getApiV1BeachRefereePaymentsTournamentIdPaymentUserId, getApiV1BeachRefereePaymentsTournamentIdReferees, getApiV1BeachRefereeTournamentList, postApiV1BeachRefereeTournamentRefereeNotify, postApiV1BeachRefereeTournamentReferee, getApiV1BeachRefereeTournamentTournamentIdReferee, getApiV1BeachRefereeTournamentTournamentId, getApiV1BeachRefereeWhisper, deleteApiV1BeachRefereeRefereeId, getApiV1BeachRefereeUserIdDelegation, getApiV1BeachRefereeUserIdUnavailability, postApiV1BeachRefereeUserIdUnavailability, deleteApiV1BeachRefereeUnavailabilityIdCancel, deleteApiV1BeachRefereeUnavailabilityIdDelete, putApiV1BeachRefereeUnavailabilityIdUnavailability, getApiV1BeachScoreboardTournamentId, getApiV1BeachStatisticExport, getApiV1BeachStatistic, getApiV1BeachStatisticsClubsTypeExport, getApiV1BeachStatisticsClubsType, getApiV1BeachStatisticsPlayersExport, getApiV1BeachStatisticsPlayers, getApiV1BeachStatisticsRefereeDelegations, getApiV1BeachStatisticsRefereeEvaluation, getApiV1BeachStatisticsRefereeUnavailability, getApiV1BeachStatisticsSummaryExport, getApiV1BeachStatisticsSummary, postApiV1BeachTemplatesEvaluationCopyFileId, getApiV1BeachTemplatesEvaluationDownloadFileId, putApiV1BeachTemplatesEvaluationEditFileId, getApiV1BeachTemplatesEvaluationValuesFileId, getApiV1BeachTemplatesEvaluationFileId, deleteApiV1BeachTemplatesEvaluationFileId, getApiV1BeachTemplatesEvaluation, postApiV1BeachTemplatesEvaluation, getApiV1BeachTemplatesEvaluations, postApiV1BeachTemplatesScheduleCopyFileId, getApiV1BeachTemplatesScheduleDownloadFileId, putApiV1BeachTemplatesScheduleEditFileId, getApiV1BeachTemplatesScheduleFileId, deleteApiV1BeachTemplatesScheduleFileId, postApiV1BeachTemplatesSchedule, getApiV1BeachTemplatesSchedules, postApiV1BeachTest, getApiV1BeachTournamentDetailLists, getApiV1BeachTournamentGetEvaluationTournamentId, getApiV1BeachTournamentMainCompetitionScript, postApiV1BeachTournamentMainCompetitionScript, postApiV1BeachTournamentOverlapAllow, postApiV1BeachTournamentOverlapForbid, getApiV1BeachTournamentQualificationScript, postApiV1BeachTournamentQualificationScript, postApiV1BeachTournamentRegistrationEmail, putApiV1BeachTournamentRegistrationRegistrationIdCancel, getApiV1BeachTournamentRegistrationRegistrationIdDetail, putApiV1BeachTournamentRegistrationRegistrationIdRenew, putApiV1BeachTournamentRegistrationRegistrationIdWildcard, deleteApiV1BeachTournamentRegistrationRegistrationIdWildcard, putApiV1BeachTournamentRegistrationRegistrationId, deleteApiV1BeachTournamentRegistrationRegistrationId, postApiV1BeachTournamentRegistration, postApiV1BeachTournamentReturnStartingFee, putApiV1BeachTournamentSetEvaluationTournamentId, getApiV1BeachTournamentTypes, getApiV1BeachTournamentWildCardTypes, getApiV1BeachTournamentTournamentIdAttachmentAttachmentId, deleteApiV1BeachTournamentTournamentIdAttachmentAttachmentId, getApiV1BeachTournamentTournamentIdAttachment, postApiV1BeachTournamentTournamentIdAttachment, putApiV1BeachTournamentTournamentIdCancelQualificationRegistrationId, getApiV1BeachTournamentTournamentIdDetail, putApiV1BeachTournamentTournamentIdEndQualification, getApiV1BeachTournamentTournamentIdMainCompetitionMatches, getApiV1BeachTournamentTournamentIdQualificationMatches, putApiV1BeachTournamentTournamentIdQualifyRegistrationId, getApiV1BeachTournamentTournamentIdRegistrationRecalculate, getApiV1BeachTournamentTournamentIdResultExport, getApiV1BeachTournamentTournamentIdResult, putApiV1BeachTournamentTournamentIdResults, getApiV1BeachTournamentTournamentIdStartingFee, putApiV1BeachTournamentTournamentId, deleteApiV1BeachTournamentTournamentId, putApiV1BeachTournamentMatchIdMainCompetitionMatch, putApiV1BeachTournamentMatchIdQualificationMatchResult, getApiV1BeachTournamentMatchIdQualificationMatch, putApiV1BeachTournamentMatchIdQualificationMatch, getApiV1BeachTournament, postApiV1BeachTournament, getApiV1BeachUserRights, postApiV1CardCreateUserId, getApiV1CardHistoryUserId, getApiV1CardPdfUserId, getApiV1CardId, putApiV1CardId, deleteApiV1CardId, getApiV1Card, postApiV1Card, getApiV1CategoryList, getApiV1CategoryId, putApiV1CategoryId, getApiV1Category, postApiV1Category, getApiV1ClubAbv, getApiV1ClubDonationPayment, getApiV1ClubDonationStatus, getApiV1ClubFavorite, getApiV1ClubImageClubId, putApiV1ClubImageClubId, deleteApiV1ClubImageClubId, getApiV1ClubMatchPastId, getApiV1ClubMatchId, putApiV1ClubMatchId, getApiV1ClubMemberBeachDailyOverview, getApiV1ClubMemberBeachDailyOverviewDetail, putApiV1ClubMemberBeachUserIdSetBeach, getApiV1ClubMemberBeach, getApiV1ClubMemberBirthNumber, getApiV1ClubMemberExport, getApiV1ClubMember, getApiV1ClubMembersForNsaCsvExportClubId, getApiV1ClubMembersForNsaExportClubId, getApiV1ClubMembersForNsaYears, getApiV1ClubMembersForNsaClubId, getApiV1ClubResponsiblePeopleClubId, postApiV1ClubTalentedYouthUserId, getApiV1ClubUserRights, getApiV1ClubWhisper, putApiV1ClubIdCancel, putApiV1ClubIdRestore, getApiV1ClubId, putApiV1ClubId, getApiV1ClubClubIdMemberEventsDatesUserId, getApiV1Club, postApiV1Club, postApiV1CompetitionFavoriteId, deleteApiV1CompetitionFavoriteId, getApiV1CompetitionFavorite, getApiV1CompetitionFolderFolderIdCompetitions, getApiV1CompetitionFolderFolderIdSeasons, getApiV1CompetitionFolderFolderIdSubfolders, postApiV1CompetitionFolderFolderIdTakePermission, putApiV1CompetitionFolderFolderId, deleteApiV1CompetitionFolderFolderId, postApiV1CompetitionFolder, deleteApiV1CompetitionGroupGroupIdRefereeUserId, getApiV1CompetitionGroupGroupIdReferee, postApiV1CompetitionGroupGroupIdReferee, postApiV1CompetitionGroupGroupIdRunScheduleScript, getApiV1CompetitionRegionWhisper, getApiV1CompetitionScriptFileId, deleteApiV1CompetitionScriptFileId, getApiV1CompetitionScript, postApiV1CompetitionScript, getApiV1CompetitionScripts, getApiV1CompetitionSeasons, getApiV1CompetitionSystems, getApiV1CompetitionUserRights, getApiV1CompetitionWhisper, getApiV1CompetitionIdBalls, getApiV1CompetitionIdGroups, getApiV1CompetitionId, putApiV1CompetitionId, deleteApiV1CompetitionId, postApiV1CompetitionFolderIdTakePermission, getApiV1Competition, postApiV1Competition, getApiV1ContractAvailableClubsUserId, getApiV1ContractContractClubs, getApiV1ContractId, putApiV1ContractId, deleteApiV1ContractId, getApiV1Contract, postApiV1Contract, getApiV1DelegationEvaluationMatchId, postApiV1DelegationEvaluationMatchId, postApiV1DelegationGroupAddFavorite, getApiV1DelegationGroupFavorite, getApiV1DelegationGroupPermission, getApiV1DelegationGroupGroupIdIsFavorite, getApiV1DelegationGroupGroupIdMatch, getApiV1DelegationGroupGroupIdMatchDelegations, deleteApiV1DelegationGroupGroupIdRemoveFavorite, getApiV1DelegationGroup, getApiV1DelegationListListIdEvaluationSend, getApiV1DelegationListListIdEvaluation, putApiV1DelegationListListIdTests, getApiV1DelegationList, getApiV1DelegationMatchVacantExport, getApiV1DelegationMatchVacantMaster, getApiV1DelegationMatchVacant, putApiV1DelegationMatchMatchIdEvaluation, getApiV1DelegationPenaltySend, getApiV1DelegationPenaltyId, putApiV1DelegationPenaltyId, deleteApiV1DelegationPenaltyId, getApiV1DelegationPenalty, postApiV1DelegationPenalty, getApiV1DelegationRefereeUserIdEvaluation, getApiV1DelegationRefereeUserIdMatchDelegations, getApiV1DelegationRefereeUserIdPenalty, postApiV1DelegationRefereeUserIdPenalty, getApiV1DelegationResultId, putApiV1DelegationResultId, deleteApiV1DelegationResultId, getApiV1DelegationResult, postApiV1DelegationResult, getApiV1DelegationTechnicalList, getApiV1DelegationTechnicalUserIdMatchList, getApiV1DelegationUserRights, getApiV1DelegationId, putApiV1DelegationId, deleteApiV1DelegationId, getApiV1DelegationDelegationIdEvaluation, putApiV1DelegationDelegationIdEvaluation, postApiV1DelegationDelegationIdRefereeUserIdConfirmEvaluation, getApiV1Delegation, postApiV1Delegation, getApiV1DeviceId, putApiV1DeviceId, deleteApiV1DeviceId, getApiV1Device, postApiV1Device, getApiV1DonationClubIdUser, getApiV1DonationClubId, getApiV1DonationStatisticsClubClubId, getApiV1DonationStatisticsClub, getApiV1DonationStatisticsDistrict, getApiV1DonationStatisticsRegion, getApiV1DonationUserId, getApiV1DonationId, putApiV1DonationId, deleteApiV1DonationId, getApiV1Donation, postApiV1Donation, getApiV1EmailPackage, postApiV1EmailSend, getApiV1Email, getApiV1ExcuseId, putApiV1ExcuseId, deleteApiV1ExcuseId, getApiV1Excuse, postApiV1Excuse, getApiV1FamouspersonExport, postApiV1FamouspersonPayDonations, getApiV1FamouspersonId, putApiV1FamouspersonId, deleteApiV1FamouspersonId, getApiV1Famousperson, postApiV1Famousperson, getApiV1FeeId, putApiV1FeeId, deleteApiV1FeeId, getApiV1Fee, postApiV1Fee, getApiV1FilesId, putApiV1FilesId, deleteApiV1FilesId, getApiV1Files, postApiV1Files, postApiV1GroupCreateCompetitionId, postApiV1GroupDraw, postApiV1GroupFavoriteGroupId, deleteApiV1GroupFavoriteGroupId, getApiV1GroupFavorite, getApiV1GroupWhisper, getApiV1GroupGroupIdBracket, getApiV1GroupGroupIdOverlapsGroups, getApiV1GroupGroupIdPhotoReportMatchNumber, getApiV1GroupGroupIdPossibleOrganizers, getApiV1GroupGroupIdScheduleExport, getApiV1GroupGroupIdSchedule, getApiV1GroupGroupIdTableExport, getApiV1GroupGroupIdTableFilter, getApiV1GroupGroupIdTable, getApiV1GroupGroupIdTeamTeamId, postApiV1GroupGroupIdUploadPhotoReport, getApiV1GroupGroupId, putApiV1GroupGroupId, deleteApiV1GroupGroupId, getApiV1GroupGroupId1OverlapsGroupId2, getApiV1Group, postApiV1Group, getApiV1HallClubId, getApiV1HallFilterOptions, getApiV1HallListExport, getApiV1HallList, getApiV1HallPersonId, putApiV1HallPersonId, deleteApiV1HallPersonId, getApiV1HallPerson, postApiV1HallPerson, getApiV1HallSuggestionList, postApiV1HallSuggestionHallSuggestionIdApprove, getApiV1HallSuggestionHallSuggestionIdDetail, deleteApiV1HallSuggestionHallSuggestionIdReject, getApiV1HallSuggestionHallSuggestionId, putApiV1HallSuggestionHallSuggestionId, deleteApiV1HallSuggestionHallSuggestionId, getApiV1HallSuggestion, postApiV1HallSuggestion, getApiV1HallUserRights, getApiV1HallIdDetail, getApiV1HallId, putApiV1HallId, deleteApiV1HallId, getApiV1Hall, postApiV1Hall, getApiV1Hash, getApiV1HelloGet, getApiV1LibraryPostId, postApiV1LibraryPostId, deleteApiV1LibraryPostId, getApiV1LibraryPost, postApiV1LibraryPost, getApiV1LibraryId, putApiV1LibraryId, deleteApiV1LibraryId, getApiV1Library, postApiV1Library, getApiV1LicenseDetailUserIdCredits, getApiV1LicenseDetailUserIdTraining, getApiV1LicenseDetailUserId, getApiV1LicenseExport, postApiV1LicenseRenewUserId, deleteApiV1LicenseTrainingCreditsId, postApiV1LicenseTrainingCredits, postApiV1LicenseTrainingMarkParticipation, getApiV1LicenseTrainingQualifications, getApiV1LicenseTrainingIdParticipants, getApiV1LicenseTrainingId, putApiV1LicenseTrainingId, deleteApiV1LicenseTrainingId, deleteApiV1LicenseTrainingTrainingIdUnmarkParticipationUserId, getApiV1LicenseTraining, postApiV1LicenseTraining, getApiV1LicenseId, putApiV1LicenseId, deleteApiV1LicenseId, getApiV1License, postApiV1License, getApiV1ListAll, getApiV1ListArchived, getApiV1ListByCategory, getApiV1ListColumnOptions, getApiV1ListFilterList, getApiV1ListUser, getApiV1ListUserRights, getApiV1ListIdDetail, getApiV1ListIdRefereeArchive, postApiV1ListIdRefereeEmail, getApiV1ListIdRefereeExport, getApiV1ListIdRefereeHistory, getApiV1ListIdRefereeVersion, deleteApiV1ListIdRefereeRefereeListId, getApiV1ListIdRefereeUserIdDetail, getApiV1ListIdReferee, postApiV1ListIdReferee, postApiV1ListIdRestore, getApiV1ListId, putApiV1ListId, deleteApiV1ListId, getApiV1List, postApiV1List, getApiV1LoginId, putApiV1LoginId, deleteApiV1LoginId, getApiV1Login, postApiV1Login, getApiV1MatchTeamHallsTeamId, getApiV1MatchId, getApiV1MatchMatchIdDetail, putApiV1MatchMatchIdDetail, getApiV1MatchMatchIdDetailEdit, postApiV1MatchMatchIdSetOutcome, deleteApiV1MatchMatchId, getApiV1Match, postApiV1Match, getApiV1MenuId, putApiV1MenuId, deleteApiV1MenuId, getApiV1Menu, postApiV1Menu, getApiV1NsaExportClubExtraYear, getApiV1NsaExportClub, getApiV1NsaExportPersonUniqYear, getApiV1NsaExportPersonYear, getApiV1NsaExportPlayerTcm, getApiV1NsaExportPlayerYear, getApiV1NsaExportTrainerTcm, getApiV1NsaExportTrainerYear, postApiV1NsaImportPlayer, postApiV1NsaImportTrainer, getApiV1NsaPlayerExtId, putApiV1NsaPlayerExtId, getApiV1NsaSubsidyClubId, getApiV1NsaSummary, getApiV1NsaTalentedYouthExport, getApiV1NsaTalentedYouth, getApiV1OnlineId, putApiV1OnlineId, deleteApiV1OnlineId, getApiV1Online, postApiV1Online, postApiV1ParticipationImport, getApiV1ParticipationImportCron, getApiV1ParticipationImportSeparateCron, getApiV1PartnerId, putApiV1PartnerId, deleteApiV1PartnerId, getApiV1Partner, postApiV1Partner, getApiV1PaymentId, putApiV1PaymentId, deleteApiV1PaymentId, getApiV1Payment, postApiV1Payment, getApiV1PermissionUser, getApiV1PermissionId, putApiV1PermissionId, deleteApiV1PermissionId, getApiV1Permission, postApiV1Permission, getApiV1PersonalSettingsCard, getApiV1PersonalSettingsCards, getApiV1PersonalSettingsContracts, getApiV1PersonalSettingsDonations, getApiV1PersonalSettingsInfo, getApiV1PersonalSettingsLicense, getApiV1PersonalSettingsLoginHistory, getApiV1PersonalSettingsQualifications, getApiV1PersonalSettingsRosters, getApiV1PersonalSettingsSameEmailUsers, getApiV1PersonalSettingsSamePhoneUsers, getApiV1PersonalSettingsTrainings, getApiV1PersonalSettingsTransfers, getApiV1PersonalSettingsUserImage, putApiV1PersonalSettingsUser, getApiV1PersonalSettingsUsersOnDevice, getApiV1PhotoImageId, getApiV1PhotoUserUserIdImage, putApiV1PhotoUserUserId, getApiV1PhotoUserId, getApiV1PhotoId, putApiV1PhotoId, deleteApiV1PhotoUserId, getApiV1Photo, postApiV1Photo, getApiV1PlayersImageUserId, getApiV1PlayersList, getApiV1PlayersPlayerId, putApiV1PlayersId, deleteApiV1PlayersId, postApiV1Players, getApiV1QualificationBeachTrainerExport, getApiV1QualificationReferee, getApiV1QualificationTrainerExport, getApiV1QualificationTrainer, getApiV1QualificationUserId, getApiV1QualificationId, putApiV1QualificationId, deleteApiV1QualificationId, getApiV1Qualification, postApiV1Qualification, postApiV1RefereeAssignDelegates, postApiV1RefereeConfirmAttendanceUserId, getApiV1RefereeDistanceHallRuianRefereeId, getApiV1RefereeDuoPreference, getApiV1RefereeMatchMatchId, getApiV1RefereeMatchListRefereesMatchIdListId, getApiV1RefereeMatchesExport, getApiV1RefereeMatchesToday, getApiV1RefereeMatches, getApiV1RefereeQualificationUserId, getApiV1RefereeRegistry, postApiV1RefereeRemoveDelegationDelegationId, putApiV1RefereeSwapMatchId, getApiV1RefereeTrainingUserId, postApiV1RefereeUnavailability, getApiV1RefereeUserRights, getApiV1RefereeWhisper, getApiV1RefereeUserIdCalendar, getApiV1RefereeUserIdDetail, getApiV1RefereeUserIdList, postApiV1RefereeUserIdPreferredColleague, getApiV1RefereeUserIdPreferredColleagues, getApiV1RefereeUserId, putApiV1RefereeUserId, deleteApiV1RefereeUserId, getApiV1Referee, postApiV1Referee, getApiV1RegistrationLastChanges, getApiV1RegistrationStatisticsClub, getApiV1RegistrationStatisticsDistrict, getApiV1RegistrationStatisticsRegionExport, getApiV1RegistrationStatisticsRegion, getApiV1RegistrationUserId, putApiV1Registration, getApiV1RequestAttachmentId, deleteApiV1RequestCancelFollowRequestId, getApiV1RequestCompetitionManagementRequestType, postApiV1RequestConfirm, postApiV1RequestConfirmRequest, postApiV1RequestConfirmTeam, getApiV1RequestCount, getApiV1RequestFileContentId, getApiV1RequestFileId, postApiV1RequestFileId, deleteApiV1RequestFileId, postApiV1RequestFile, postApiV1RequestFollowRequestIdUserId, getApiV1RequestFollowersRequestId, getApiV1RequestFormAvailableGroupsCompetitionId, getApiV1RequestFormAvailableNumbersGroupId, getApiV1RequestFormBeachCancelApplicationRequestId, getApiV1RequestFormBeachCancelApplicationTournamentIdPairs, postApiV1RequestFormBeachCancelApplication, getApiV1RequestFormBeachFineRequestId, postApiV1RequestFormBeachFine, getApiV1RequestFormBeachHostingRequestRequestId, postApiV1RequestFormBeachHostingRequest, getApiV1RequestFormBeachTournament, getApiV1RequestFormBeachTournamentApplicationCheck, getApiV1RequestFormBeachTournamentApplicationRequestId, postApiV1RequestFormBeachTournamentApplication, getApiV1RequestFormCancelHostingRequestId, postApiV1RequestFormCancelHosting, getApiV1RequestFormCancelRegistrationRequestId, postApiV1RequestFormCancelRegistration, postApiV1RequestFormChampionshipApplicationAssignGroup, getApiV1RequestFormChampionshipApplicationRequestId, postApiV1RequestFormChampionshipApplication, getApiV1RequestFormChangeHallRequestId, postApiV1RequestFormChangeHall, getApiV1RequestFormChangeInfoRequestId, postApiV1RequestFormChangeInfo, getApiV1RequestFormChangeMatchDateRequestId, postApiV1RequestFormChangeMatchDate, getApiV1RequestFormChangePhotoRequestId, postApiV1RequestFormChangePhoto, getApiV1RequestFormChangeTournamentDateRequestId, postApiV1RequestFormChangeTournamentDate, getApiV1RequestFormCompetitionCodes, getApiV1RequestFormExtendCardRequestId, postApiV1RequestFormExtendCard, getApiV1RequestFormExtendHostingRequestId, postApiV1RequestFormExtendHosting, getApiV1RequestFormFineRequestId, postApiV1RequestFormFine, getApiV1RequestFormHallsTeamId, getApiV1RequestFormMatchesGroupIdTeamId, getApiV1RequestFormMemberRegistrationRequestId, postApiV1RequestFormMemberRegistration, getApiV1RequestFormMemberRenewalRequestId, postApiV1RequestFormMemberRenewal, getApiV1RequestFormMembershipPaymentSeasons, getApiV1RequestFormMembershipPaymentUsersIdSeason, getApiV1RequestFormMembershipPaymentRequestId, postApiV1RequestFormMembershipPayment, getApiV1RequestFormNewCardRequestId, postApiV1RequestFormNewCard, getApiV1RequestFormRegionalApplicationRequestId, postApiV1RequestFormRegionalApplication, getApiV1RequestFormReportHostingRequestId, postApiV1RequestFormReportHosting, getApiV1RequestFormReportTransferRequestId, postApiV1RequestFormReportTransfer, getApiV1RequestFormSubstituteHallRequestId, postApiV1RequestFormSubstituteHall, getApiV1RequestFormTeamsGroupId, getApiV1RequestFormTeamsForTransferUserId, getApiV1RequestFormTeamsToExcludeUserId, getApiV1RequestFormToleranceGroupId, getApiV1RequestFormTournamentsGroupId, getApiV1RequestFormTransferToAnotherTeamRequestId, postApiV1RequestFormTransferToAnotherTeam, getApiV1RequestGetTypeRequestId, getApiV1RequestList, getApiV1RequestLogoId, getApiV1RequestMyRequests, getApiV1RequestPersonId, putApiV1RequestPersonId, postApiV1RequestPerson, postApiV1RequestRefund, getApiV1RequestTypesList, getApiV1RequestTypes, getApiV1RequestUserRights, getApiV1RequestWhisper, getApiV1RequestIdFile, getApiV1RequestIdLimited, deleteApiV1RequestIdPersonPersonId, getApiV1RequestIdPerson, getApiV1RequestId, postApiV1RequestId, deleteApiV1RequestId, getApiV1Request, postApiV1Request, postApiV1RightsAddModuleRightsModule, putApiV1RightsEditModuleRightsModule, getApiV1RightsModuleRightsItemListModule, getApiV1RightsModuleRightsListModule, getApiV1RightsModules, getApiV1RightsMpRegions, getApiV1RightsMpRegionIdDistricts, deleteApiV1RightsRemoveModuleRightsModule, getApiV1RosterCompetitionCompetitionIdDetail, getApiV1RosterCompetitionsTeamId, getApiV1RosterFunctionariesTeamId, getApiV1RosterHistoryTeamId, getApiV1RosterManaged, getApiV1RosterMatchesToday, getApiV1RosterMyRosters, getApiV1RosterMyRostersOld, putApiV1RosterPerson, postApiV1RosterPerson, getApiV1RosterPlayersTeamId, getApiV1RosterPrintTeamIdCompetitionId, getApiV1RosterStatisticsCategory, getApiV1RosterStatisticsClub, getApiV1RosterStatisticsCompetition, getApiV1RosterStatisticsComplete, getApiV1RosterStatisticsLetter, getApiV1RosterStatisticsRegion, getApiV1RosterUserRights, getApiV1RosterVersionsTeamId, getApiV1RosterId, putApiV1RosterId, deleteApiV1RosterId, getApiV1RosterTeamIdEditFunctionaries, getApiV1RosterTeamIdEditPlayersInvalid, getApiV1RosterTeamIdEditPlayersValid, getApiV1RosterTeamIdEditPlayers, deleteApiV1RosterTeamIdEditRemoveFunctionaryUserId, deleteApiV1RosterTeamIdEditRemovePlayerUserId, getApiV1Roster, postApiV1Roster, getApiV1RuianCityId, getApiV1RuianCity, getApiV1RuianCountryWhisper, getApiV1RuianCountryId, getApiV1RuianCountry, getApiV1RuianCountrySearch, getApiV1RuianDistanceRuianId1RuianId2, getApiV1RuianDistrictId, getApiV1RuianDistrict, getApiV1RuianHallTown, getApiV1RuianHouseStreetCode, getApiV1RuianRegionIdTown, getApiV1RuianRegionId, getApiV1RuianRegion, getApiV1RuianStreetCode, getApiV1RuianTownTownIdSections, getApiV1RuianTownpartCode, getApiV1RuianWhisper, getApiV1RuianId, getApiV1Ruian, getApiV1SettingsUserUserId, getApiV1SettingsId, putApiV1SettingsId, deleteApiV1SettingsId, getApiV1Settings, postApiV1Settings, getApiV1SignpostAffiliationHistoryUserId, getApiV1SignpostAffiliationUserId, getApiV1SignpostClubs, getApiV1SignpostModules, getApiV1SignpostPlayers, getApiV1SmsGraph, getApiV1SmsPackage, postApiV1SmsSend, getApiV1Sms, getApiV1SportsfieldCertificate, getApiV1SportsfieldCities, getApiV1SportsfieldSuggestionId, putApiV1SportsfieldSuggestionId, deleteApiV1SportsfieldSuggestionId, getApiV1SportsfieldSuggestion, postApiV1SportsfieldSuggestion, getApiV1SportsfieldWhisper, getApiV1SportsfieldId, putApiV1SportsfieldId, deleteApiV1SportsfieldId, getApiV1SportsfieldHallIdSchedule, getApiV1Sportsfield, postApiV1Sportsfield, postApiV1SuperLinkCheck, getApiV1SuperLinkCompetitionCompetitionId, getApiV1SuperLinkGroupGroupId, postApiV1SuperLinkLink, getApiV1SuperLinkTeamTeamId, postApiV1SuperRosterAddUser, getApiV1SuperRosterCompetitionCompetitionId, deleteApiV1SuperRosterRemoveUserUserId, getApiV1SuperRosterTeamTeamId, getApiV1SuperRosterUserEditUserId, putApiV1SuperRosterUserEdit, getApiV1SuperRosterUserRosterUserId, getApiV1SurveyAnswerId, putApiV1SurveyAnswerId, deleteApiV1SurveyAnswerId, getApiV1SurveyAnswer, postApiV1SurveyAnswer, getApiV1SurveyArchive, putApiV1SurveyQuestionSurveyQuestionIdChangeAnswerText, postApiV1SurveyQuestionSurveyQuestionIdMergeAnswers, getApiV1SurveyQuestionSurveyQuestionId, putApiV1SurveyQuestionSurveyQuestionId, deleteApiV1SurveyQuestionSurveyQuestionId, getApiV1SurveyQuestion, postApiV1SurveyQuestion, getApiV1SurveyRelevant, getApiV1SurveySurveyIdDetail, getApiV1SurveySurveyIdExport, postApiV1SurveySurveyIdMembersUserId, deleteApiV1SurveySurveyIdMembersUserId, getApiV1SurveySurveyIdMembers, putApiV1SurveySurveyIdMembers, postApiV1SurveySurveyIdNotify, getApiV1SurveySurveyIdPdf, getApiV1SurveySurveyIdQuestion, getApiV1SurveySurveyIdResults, postApiV1SurveySurveyIdSubmit, getApiV1SurveySurveyId, putApiV1SurveySurveyId, deleteApiV1SurveySurveyId, getApiV1Survey, postApiV1Survey, postApiV1TeamAddTeamGroupId, getApiV1TeamClubId, getApiV1TeamCompetition, getApiV1TeamCompetitionTeamsGroupId, postApiV1TeamCreateNewTeamGroupId, getApiV1TeamGroupGroupIdCompetition, getApiV1TeamGroupGroupIdExportPdf, getApiV1TeamGroupGroupId, getApiV1TeamNumbersGroupId, getApiV1TeamOtherCompetitionTeamsGroupId, getApiV1TeamTeamIdAvailableLetters, deleteApiV1TeamTeamIdGroupGroupId, putApiV1TeamTeamIdGroup, deleteApiV1TeamTeamIdHallHallId, getApiV1TeamTeamId, putApiV1TeamTeamId, deleteApiV1TeamTeamId, getApiV1TeamIdGroupGroupId, getApiV1TeamIdHall, putApiV1TeamIdHall, putApiV1TeamGroupIdInitialCondition, getApiV1Team, postApiV1Team, getApiV1TrainingUserUserId, getApiV1TrainingId, putApiV1TrainingId, deleteApiV1TrainingId, getApiV1Training, postApiV1Training, putApiV1TransactionKsTransactionId, putApiV1TransactionVsTransactionId, getApiV1TransactionId, deleteApiV1TransactionId, getApiV1TransactionTransactionIdDetail, putApiV1TransactionTransactionId, getApiV1Transaction, postApiV1Transaction, getApiV1TransferCzechPlayersAbroad, getApiV1TransferForeignPlayers, postApiV1TransferFromAbroad, postApiV1TransferHosting, getApiV1TransferStatisticsRegion, getApiV1TransferStatisticsUser, postApiV1TransferToAbroad, getApiV1TransferUserId, getApiV1TransferUserUserIdRoster, putApiV1TransferIdEndHosting, putApiV1TransferIdEndMembership, getApiV1TransferId, putApiV1TransferId, deleteApiV1TransferId, getApiV1Transfer, postApiV1Transfer, getApiV1UnavailabilitySeasonMatchStatistics, getApiV1UnavailabilitySeasonMatch, getApiV1UnavailabilitySeasonStatistics, getApiV1UnavailabilitySeason, getApiV1UnavailabilityId, putApiV1UnavailabilityId, deleteApiV1UnavailabilityId, getApiV1Unavailability, postApiV1Unavailability, getApiV1UserAccessUserId, postApiV1UserAccessUserId, getApiV1UserCalendar, getApiV1UserMatchMissingPhotoreport, getApiV1UserUserRights, getApiV1UserWhisperNoClub, getApiV1UserWhisper, getApiV1UserId, putApiV1UserId, deleteApiV1UserId, getApiV1UserUserIdClubsMembers, getApiV1User, postApiV1User, getApiV1VotingAnswerId, putApiV1VotingAnswerId, deleteApiV1VotingAnswerId, getApiV1VotingAnswer, postApiV1VotingAnswer, getApiV1VotingOptionId, putApiV1VotingOptionId, deleteApiV1VotingOptionId, getApiV1VotingOption, postApiV1VotingOption, postApiV1VotingQuestionProgramPoint, getApiV1VotingQuestionId, putApiV1VotingQuestionVotingQuestionId, deleteApiV1VotingQuestionVotingQuestionId, postApiV1VotingQuestion, putApiV1VotingRoomAccessId, deleteApiV1VotingRoomAccessId, getApiV1VotingRoomArchive, getApiV1VotingRoomMyRooms, getApiV1VotingRoomRelevant, getApiV1VotingRoomVotingRoomIdAccess, postApiV1VotingRoomVotingRoomIdAccess, getApiV1VotingRoomVotingRoomIdActive, postApiV1VotingRoomVotingRoomIdAddMember, getApiV1VotingRoomVotingRoomIdAttachmentAttachmentId, deleteApiV1VotingRoomVotingRoomIdAttachmentAttachmentId, getApiV1VotingRoomVotingRoomIdAttachment, postApiV1VotingRoomVotingRoomIdAttachment, postApiV1VotingRoomVotingRoomIdCanEnter, postApiV1VotingRoomVotingRoomIdClose, postApiV1VotingRoomVotingRoomIdCopyData, getApiV1VotingRoomVotingRoomIdExport, getApiV1VotingRoomVotingRoomIdInvite, postApiV1VotingRoomVotingRoomIdLock, putApiV1VotingRoomVotingRoomIdMemberLogAccess, getApiV1VotingRoomVotingRoomIdMembers, postApiV1VotingRoomVotingRoomIdOpen, getApiV1VotingRoomVotingRoomIdPdf, getApiV1VotingRoomVotingRoomIdProgram, getApiV1VotingRoomVotingRoomIdQuestion, putApiV1VotingRoomVotingRoomIdRemoveMember, getApiV1VotingRoomVotingRoomIdResultsQuestionId, getApiV1VotingRoomVotingRoomIdResults, postApiV1VotingRoomVotingRoomIdSendInvitations, postApiV1VotingRoomVotingRoomIdUnlock, getApiV1VotingRoomVotingRoomId, putApiV1VotingRoomVotingRoomId, deleteApiV1VotingRoomVotingRoomId, putApiV1VotingRoomQuestionIdEndProgramPoint, putApiV1VotingRoomQuestionIdStartVoting, getApiV1VotingRoom, postApiV1VotingRoom, getApiV1VotingUserRights, getApiV1VotingVoterId, putApiV1VotingVoterId, deleteApiV1VotingVoterId, getApiV1VotingVoter, postApiV1VotingVoter, getApiV1VotingId, putApiV1VotingId, deleteApiV1VotingId, getApiV1Voting, postApiV1Voting, getApiV1YoutubeId, putApiV1YoutubeId, deleteApiV1YoutubeId, getApiV1Youtube, postApiV1Youtube };
};
exports.getApi = getApi;
